import { normalizePhoneCountryBR } from "@/utils/phone";
import { ehLinhaDeVoz, operacoesDaProposta, megabonusDaProposta } from '../../../../backend/src/services/whatsapp/gerar-mensagem-proposta';
import { WhatsappBadge } from '@/components/leads-carteira/WhatsappBadge';
import React, { useState, useEffect, useRef, useMemo, useCallback, useDeferredValue } from 'react';
import { HoverCard, HoverCardTrigger, HoverCardContent } from '@/components/ui/hover-card';
import { validarLeadParaPedido } from '@/lib/validarLeadParaPedido';
import { registrarDiagnosticoRevisao } from '@/lib/registrarDiagnosticoRevisao';
import { normalizarMsisdn } from '@/lib/renovacaoCalculo';
import { useBeneficiosDaComposicao } from '@/hooks/useBeneficiosDaComposicao';
import { ehNumeroDaCasa, nomeDaConexaoDoNumero, MENSAGEM_NUMERO_DA_CASA } from '@/lib/numerosDaCasa';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Separator } from '@/components/ui/separator';
import { Skeleton } from '@/components/ui/skeleton';
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from '@/components/ui/collapsible';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { LeadFaturaTab } from './LeadFaturaTab';
import { ContaRenovacaoCpf } from './ContaRenovacaoCpf';
import { useCNPJLookup } from '@/hooks/useCNPJLookup';
import { useAbrirConversaInbox } from '@/hooks/useAbrirConversaInbox';
import { useRegenerarItensPedido } from '@/hooks/useRegenerarItensPedido';
import { computarLinhasTravadas, filtrarItensProtegidos } from '@/lib/linhasProtegidasRevisao';
import { separarRecuperacao } from '@/lib/ficaCanceladaRevisao';
import { useMotivosFicaCancelada } from '@/hooks/useMotivosFicaCancelada';
import { ResumoRecuperacaoParcial, contarItens, MANTER_MOTIVO_ATUAL } from './ResumoRecuperacaoParcial';
import { formatPedidoCode } from '@/lib/formatters';
import { useCnpjContatoMaster } from '@/hooks/useCnpjContatoMaster';
import { useCarteiraClaroAtual, type CarteiraClaroAtual } from '@/hooks/useCarteiraClaroAtual';
import { useParqueMovelByCnpj, useParqueFixoByCnpj } from '@/hooks/useParqueVivoByCnpj';
import { useMapaParqueByCnpj } from '@/hooks/useMapaParqueByCnpj';

import { LeadPedidosTab } from './LeadPedidosTab';
import { LeadDadosComplementarTab, TelefonesEncontradosCard } from './LeadDadosComplementarTab';
import { LeadParqueVivoTab } from './LeadParqueVivoTab';
import { TimelineUnificada } from '@/components/timeline/TimelineUnificada';
import { LeadBaseLinhasTab } from './LeadBaseLinhasTab';
import { LeadDados360Portabilidade } from './LeadDados360Portabilidade';
import { LeadDados360PortabilidadeCpf } from './LeadDados360PortabilidadeCpf';
import { LeadPreviaVendaIaCpf } from './LeadPreviaVendaIaCpf';
import { LeadAberturaListaCpf } from './LeadAberturaListaCpf';
import { LeadPropostaEnviadaEmail } from './LeadPropostaEnviadaEmail';
import { PreviaPropostaTopCard } from './PreviaPropostaTopCard';
import { usePreviaPropostaLead } from '@/hooks/usePreviaPropostaLead';
import type { PreviaDoLead } from '@/lib/previaPropostaApi';
import { useAberturaListaCpf } from '@/hooks/useVendaIaCpf';
import { LeadDados360RetencaoCpf } from './LeadDados360RetencaoCpf';
import { LeadDados360RenovacaoCpf } from './LeadDados360RenovacaoCpf';
import { LeadPerfilInteligente } from './LeadPerfilInteligente';
import { LeadDados360TT } from './LeadDados360TT';
import { LeadDados360Algar } from './LeadDados360Algar';
import { LeadDados360Api } from './LeadDados360Api';
import { LeadDadosCpfAssertiva } from './LeadDadosCpfAssertiva';
import { LeadDadosDaLista } from './LeadDadosDaLista';
import { LeadDados360Oi } from './LeadDados360Oi';
import { AssertivaDadosCard } from '@/components/assertiva/AssertivaDadosCard';
import { BadgeStatusAptidao } from './BadgeStatusAptidao';
import { MontadorComposicaoPlano } from './MontadorComposicaoPlano';
import { ComparativoPropostaVisual } from './ComparativoPropostaVisual';
import { NumerosParaLigarCard } from './NumerosParaLigarCard';
import { PlanoAtualTT } from './PlanoAtualTT';
import { PlanoAtualRenovacao } from './PlanoAtualRenovacao';
import { PlanoAtualPortabilidade } from './PlanoAtualPortabilidade';
import { usePlantaVivoSnapshot } from '@/hooks/usePlantaVivoSnapshot';
import { DEFAULT_PROPOSTA_MESSAGE, DEFAULT_RETORNO_MESSAGE, DEFAULT_FECHAMENTO_MESSAGE, DEFAULT_APRESENTACAO_MESSAGE, DEFAULT_APRESENTACAO_CARTEIRA_MESSAGE, getDefaultMessages, getDefaultMessagesFromDBComVariacoes, selecionarVariacaoPorLead, ehMensagemPadrao } from '@/constants/leadPropostaVariables';
import { PLANOS_RENOVACAO_CNPJ as PLANOS_RENOVACAO_CNPJ_STATIC, type ComposicaoProposta, type LinhaComposicao, type RenovacaoSimulacao, calcularTotalGB, calcularTotalValor, gerarMensagemPropostaCompleta, gerarMensagemRetornoCompleta, gerarMensagemFechamentoCompleta } from '@/constants/planosCNPJ';
import { usePlanosPropostaCatalogo, useResolverPlanoCatalogo } from '@/hooks/usePlanosPropostaCatalogo';
import { useEnviosMensagemLead } from '@/hooks/useEnviosMensagemLead';
import { aplicarSugestaoFaturaRenovacao, assinaturaFaturaRenovacao, reconciliarRenovacaoComFatura, renovacaoEstaSincronizadaComFatura } from '@/lib/renovacaoProposta';
import { validarPropostaCompleta } from '@/utils/validarPropostaCompleta';
import { useOperadoraLinhas } from '@/hooks/useOperadoraLinhas';
import { regraPorTipoLinha } from '@/lib/operadoraCoerencia';

type TipoMensagemLead = 'apresentacao' | 'apresentacao_2' | 'apresentacao_3' | 'apresentacao_carteira' | 'retorno' | 'proposta' | 'proposta_imagem' | 'proposta_email' | 'apresentacao_sms' | 'fechamento';

// A ordem dos botões do lead (Douglas 28/09/2026): as apresentações, o retorno,
// as três formas de proposta e o fechamento. No CPF são três apresentações (as
// três variações do modelo do tipo do lead); no CNPJ segue Apresentação e
// Ap. Carteira até o alinhamento com os modelos da Meta.
const BOTOES_MENSAGEM_CPF: { tipo: TipoMensagemLead; label: string }[] = [
  { tipo: 'apresentacao', label: 'Apresentação 1' },
  { tipo: 'apresentacao_2', label: 'Apresentação 2' },
  { tipo: 'apresentacao_3', label: 'Apresentação 3' },
  { tipo: 'retorno', label: 'Retorno' },
  { tipo: 'proposta', label: 'Proposta Texto' },
  { tipo: 'proposta_imagem', label: 'Proposta Imagem' },
  { tipo: 'proposta_email', label: 'Proposta E-mail' },
  { tipo: 'apresentacao_sms', label: 'Apresentação SMS' },
  { tipo: 'fechamento', label: 'Fechamento' },
];
const BOTOES_MENSAGEM_CNPJ: { tipo: TipoMensagemLead; label: string }[] = [
  { tipo: 'apresentacao', label: 'Apresentação' },
  { tipo: 'apresentacao_carteira', label: 'Ap. Carteira' },
  { tipo: 'retorno', label: 'Retorno' },
  { tipo: 'proposta', label: 'Proposta Texto' },
  { tipo: 'proposta_imagem', label: 'Proposta Imagem' },
  { tipo: 'proposta_email', label: 'Proposta E-mail' },
  { tipo: 'apresentacao_sms', label: 'Apresentação SMS' },
  { tipo: 'fechamento', label: 'Fechamento' },
];
// Oi e Algar (Douglas 02/10/2026): a abertura é UMA, a da situação do lead —
// não há Apresentação 2 e 3.
const TIPOS_LEAD_LISTA_CPF = new Set(['OI_CPF', 'ALGAR_CPF', 'RF_CPF']);
const botoesMensagem = (pf: boolean, tipoLead: string | null | undefined) => {
  if (!pf) return BOTOES_MENSAGEM_CNPJ;
  if (!TIPOS_LEAD_LISTA_CPF.has(String(tipoLead ?? ''))) return BOTOES_MENSAGEM_CPF;
  return BOTOES_MENSAGEM_CPF.filter((b) => b.tipo !== 'apresentacao_2' && b.tipo !== 'apresentacao_3')
    .map((b) => (b.tipo === 'apresentacao' ? { ...b, label: 'Apresentação' } : b));
};
const ehTipoApresentacao = (t: TipoMensagemLead) => t === 'apresentacao' || t === 'apresentacao_2' || t === 'apresentacao_3';
const rotuloDoTipoMensagem = (t: TipoMensagemLead, pf: boolean) =>
  (pf ? BOTOES_MENSAGEM_CPF : BOTOES_MENSAGEM_CNPJ).find(b => b.tipo === t)?.label ?? 'Mensagem';
function textoDoTipoMensagem(p: { mensagem_apresentacao: string; mensagem_apresentacao_2: string; mensagem_apresentacao_3: string; mensagem_apresentacao_carteira: string; mensagem_retorno: string; mensagem_fechamento: string; mensagem_whats: string }, t: TipoMensagemLead): string {
  if (t === 'apresentacao') return p.mensagem_apresentacao;
  if (t === 'apresentacao_2') return p.mensagem_apresentacao_2;
  if (t === 'apresentacao_3') return p.mensagem_apresentacao_3;
  if (t === 'apresentacao_carteira') return p.mensagem_apresentacao_carteira;
  if (t === 'retorno') return p.mensagem_retorno;
  if (t === 'fechamento') return p.mensagem_fechamento;
  return p.mensagem_whats;
}

interface SugestaoRenovacaoFatura {
  plano_codigo?: string | null;
  plano_nome?: string | null;
  gb_livre?: number;
  gb_redes_sociais?: number;
  valor_mensal?: number;
  delta_percentual?: number | null;
  faixa_delta?: number | null;
  acrescimo_receita?: number;
  ticket_alvo_faixa_1?: number | null;
  sugestao_motivo?: string;
}

interface LinhaAnaliseSugestaoFatura {
  msisdn?: string;
  proposta_otimizacao?: SugestaoRenovacaoFatura;
}

interface LinhaContaFatura {
  msisdn: string;
  fatura_upload_id: string;
  conta_numero: string | null;
  competencia: string;
  gb_nominal: number | null;
  gb_elegivel_renovacao: number | null;
  valor_mensal_linha: number | null;
  plano_atual: string | null;
  data_fidelidade?: string | null;
}
import { conflitosDaComposicao } from './ConferenciaOperadoraLinhas';
import { useAuth } from '@/hooks/useAuth';
import { usePainelPedido } from '@/contexts/PainelPedidoContext';
import {
  Building2, Phone, Mail, User, CreditCard, Check, AlertTriangle, AlertCircle,
  MessageSquare, Copy, X, Handshake, FileText, Clock, CloudOff,
  MapPin, Calendar, TrendingUp, Save, Loader2, RefreshCw, Users, Send, Database, ExternalLink, Receipt, Zap, ShieldCheck,
  ArrowLeft, ChevronLeft, ChevronRight, ChevronDown, PhoneOff, Smartphone, Shield, Sparkles, Eye, EyeOff, Lock,
  RotateCcw,
} from 'lucide-react';
import { format } from 'date-fns';
import { formatarCNPJ, formatarCPF, formatarMoeda, keepOnlyDigits, formatarTelefone } from '@/utils/formatters';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';
import { leadJaVirouPedido } from "@/lib/leadJaVirouPedido";
import { useQueryClient, useQuery, keepPreviousData } from '@tanstack/react-query';
import { useRenovacaoParametros, type RenovacaoFaixaParametro } from '@/hooks/useRenovacaoParametros';
import { deltasDaRenovacao } from '@/lib/renovacaoCalculo';
import type { LeadCarteira } from '@/hooks/useLeadsCarteira';
import { registrarValoresPropostaSalvos } from '@/lib/leadHistoricoService';
import { canHaveOwnSales } from '@/lib/roles-permissions';
import { ClickToCall } from '@/components/common/ClickToCall';
import { ConvergenciaOrientacaoCard } from '@/components/leads-carteira/ConvergenciaOrientacaoCard';
import { LeadSmsDialog } from './LeadSmsDialog';
import { ListaDestinosProposta, EditorSmsProposta } from './PropostaDestinos';
import { PropostaEmailComposer, type ModeloEmailProposta } from './PropostaEmailComposer';
import { buscarPreviaPropostaEmail, enviarPropostaEmailLead, type DadosEmailProposta } from '@/lib/propostaEmailApi';
import { avisoValoresDoTexto, ROTULO_METODO_EMAIL, temPropostaMontada, type MetodoEnvioEmail } from '../../../../backend/src/services/leads/proposta-email-texto';
import { buscarDestinosProposta, buscarEnvioProposta, enviarSmsPropostaLead, smsTravado } from '@/lib/leadSmsApi';
import { EnvioPropostaStatus } from './EnvioPropostaStatus';
import { LIMITE_SMS, modelosSmsProposta, tamanhoSms } from '@/lib/propostaSmsModelos';
import { SeloPnPedido } from './SeloPnPedido';
import { LeadNegadoVoltarTrabalhar } from './LeadNegadoVoltarTrabalhar';
import { usePnDesfechosLeads } from '@/hooks/usePnDesfechosLeads';
import { useDadosPadrao } from '@/hooks/useDadosPadrao';
import { LeadDadosPadrao } from './LeadDadosPadrao';

interface ModalDetalhesLeadCompletoProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  lead: LeadCarteira | null;
  onStatusChange: (leadId: string, status: 'NEGADO' | 'NEGOCIANDO' | 'FECHADO') => void;
  onLigar: (telefone: string) => void;
  fromPedidoId?: string | null;
  onVoltarParaPedido?: () => void;
  // Props de navegação do carrossel
  indiceAtual?: number;
  totalLeads?: number;
  onNavegar?: (direcao: 'anterior' | 'proximo') => void;
  canNavigate?: { anterior: boolean; proximo: boolean };
  leadIdsFrozen?: string[];
  // 🆕 Aba inicial (para abrir direto em proposta após tabulação)
  initialTab?: string;
}

// ⛔ VAZIO ESTÁVEL (Douglas 02/09/2026). Fora do modo revisão estas listas são
// sempre vazias — mas `= []` no destructuring e `new Set()` no memo criam objeto
// NOVO a cada render, e como o Montador é React.memo a comparação rasa falhava
// SEMPRE: o montador inteiro (2.700 linhas, dezenas de Select/Tooltip) era
// reconstruído a cada tecla do modal. É o amplificador do "tela pesada".
const SEM_ITENS_REVISAO: never[] = [];
const SEM_LINHAS_TRAVADAS: Set<string> = new Set();

// Dados do cliente CPF para a conferência do fechamento (Douglas 25/09/2026).
function clienteCpfDoLead(fonte: unknown, contatoTelefone?: string | null, contatoEmail?: string | null) {
  const l = (fonte || {}) as Record<string, unknown>;
  if (l.tipo_pessoa !== 'PF') return undefined;
  const txt = (v: unknown) => String(v ?? '').trim();
  const endereco = [
    [txt(l.venda_logradouro), txt(l.venda_numero)].filter(Boolean).join(', '),
    txt(l.venda_complemento), txt(l.venda_bairro),
    [txt(l.venda_cidade), txt(l.venda_uf)].filter(Boolean).join('/'),
    txt(l.venda_cep),
  ].filter(Boolean).join(' - ') || txt(l.endereco_empresa);
  return {
    cpf: txt(l.cpf),
    nome: txt(l.razao_social),
    endereco: endereco || null,
    telefone: contatoTelefone || txt(l.contato_real_telefone) || txt(l.telefone) || null,
    email: contatoEmail || txt(l.contato_real_email) || txt(l.email) || null,
  };
}

function primeiroNomeDoCliente(nome?: string | null): string {
  const p = String(nome || '').trim().split(/\s+/)[0] || '';
  return p ? p.charAt(0).toUpperCase() + p.slice(1).toLowerCase() : '';
}

export const ModalDetalhesLeadCompleto = React.memo(function ModalDetalhesLeadCompleto({
  open,
  onOpenChange,
  lead,
  onStatusChange,
  onLigar,
  fromPedidoId,
  onVoltarParaPedido,
  indiceAtual,
  totalLeads,
  onNavegar,
  canNavigate,
  leadIdsFrozen,
  initialTab,
}: ModalDetalhesLeadCompletoProps) {
  const queryClient = useQueryClient();
  const { user, profile } = useAuth();
  const { open: openPedido } = usePainelPedido();
  const leadIdPn = open && lead?.id ? lead.id : null;
  const dadosPadrao = useDadosPadrao(leadIdPn);
  const { data: pnDesfechos = {} } = usePnDesfechosLeads(leadIdPn ? [leadIdPn] : []);
  const pnDesfecho = lead?.pn_desfecho ?? (leadIdPn ? pnDesfechos[leadIdPn] : null);
  const [saving, setSaving] = useState(false);
  const [enviandoProposta, setEnviandoProposta] = useState(false);
  const enviandoPropostaRef = useRef(false);
  const [activeTab, setActiveTab] = useState(initialTab || 'dados');
  const [voltarTrabalharAberto, setVoltarTrabalharAberto] = useState(false);
  
  // 🆕 Resetar aba quando lead muda ou initialTab é fornecida
  useEffect(() => {
    if (open && lead?.id) {
      setActiveTab(initialTab || 'dados');
    }
  }, [open, lead?.id, initialTab]);

  // Estado para AlertDialog de cancelamento de revisão
  const [showCancelRevisaoDialog, setShowCancelRevisaoDialog] = useState(false);
  const [cancelandoRevisao, setCancelandoRevisao] = useState(false);
  const [vivoOpen, setVivoOpen] = useState(false);
  const [credlinkOpen, setCredlinkOpen] = useState(false);
  const [ecossistemaOpen, setEcossistemaOpen] = useState(false);
  
  // Estado para navegação com alterações não salvas
  const [isDirty, setIsDirty] = useState(false);
  const [showNavigationGuard, setShowNavigationGuard] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState<'anterior' | 'proximo' | null>(null);
  
  // Estado para controle de autosave com feedback visual
  const [statusSalvamento, setStatusSalvamento] = useState<'idle' | 'salvando' | 'salvo' | 'erro'>('idle');
  const [tipoMensagemAtivo, setTipoMensagemAtivo] = useState<TipoMensagemLead>('proposta');
  // 🆕 Ref pra capturar o card visual como PNG (Proposta Imagem)
  const comparativoRef = useRef<{ gerarImagemBlob: () => Promise<Blob> } | null>(null);
  const mensagemRef = useRef<HTMLTextAreaElement>(null);
  
  // Estado para composição de proposta CNPJ - SEPARADO para evitar ping-pong
  // composicaoBase: fonte externa (hidratação do banco, seleção de cenário)
  // composicaoEditando: estado vivo do Montador (o que está sendo editado agora)
  const [composicaoBase, setComposicaoBase] = useState<ComposicaoProposta | null>(null);
  const [composicaoEditando, setComposicaoEditando] = useState<ComposicaoProposta | null>(null);
  const [cenarioSelecionadoId, setCenarioSelecionadoId] = useState<string | undefined>();
  
  // Composição para exibição (prioriza editando, fallback para base)
  const composicaoParaExibir = useMemo(() => {
    const composicao = composicaoEditando ?? composicaoBase;
    return composicao ? { ...composicao, tipoPessoa: lead?.tipo_pessoa === 'PF' ? 'PF' as const : 'PJ' as const } : null;
  }, [composicaoEditando, composicaoBase, lead?.tipo_pessoa]);
  const resolverPlano = useResolverPlanoCatalogo(lead?.tipo_pessoa === 'PF' ? 'PF' : 'PJ');
  const { withCatalogo: withCatalogoPlanos } = usePlanosPropostaCatalogo(lead?.tipo_pessoa === 'PF' ? 'PF' : 'PJ');
  const planosRenovacao = useMemo(
    () => withCatalogoPlanos('movel_renovacao', PLANOS_RENOVACAO_CNPJ_STATIC),
    [withCatalogoPlanos],
  );

  // Plano Novo 2 — Renovação com Incremento
  const [composicaoBase2, setComposicaoBase2] = useState<ComposicaoProposta | null>(null);
  const [composicaoEditando2, setComposicaoEditando2] = useState<ComposicaoProposta | null>(null);
  const composicaoParaExibir2 = useMemo(() => composicaoEditando2 ?? composicaoBase2 ?? null, [composicaoEditando2, composicaoBase2]);

  // ── Coerência produto × operadora (Douglas 07/08) ──────────────────────────
  // Consulta a operadora real das linhas com régua (PORTABILIDADE/TT/RENOVAÇÃO)
  // e trava Recuperar/Abrir Pedido quando há conflito CONFIRMADO — foi assim que
  // um PN com linha Claro fechou pedido e morreu no BKO (2608060062). Linha sem
  // consulta NÃO trava.
  const numerosParaConferir = useMemo(() => {
    const linhas = [
      ...(composicaoParaExibir?.linhas ?? []),
      ...(composicaoParaExibir2?.linhas ?? []),
    ];
    return linhas
      .filter((l) => regraPorTipoLinha(l?.tipo))
      .map((l) => String(l?.numero ?? ''))
      .filter((n) => n.replace(/\D/g, '').length >= 10);
  }, [composicaoParaExibir, composicaoParaExibir2]);
  const { porTelefone: operadorasLinhas } = useOperadoraLinhas(numerosParaConferir);
  const conflitosOperadora = useMemo(
    () => conflitosDaComposicao(
      [
        ...(composicaoParaExibir?.linhas ?? []),
        ...(composicaoParaExibir2?.linhas ?? []),
      ],
      operadorasLinhas,
    ),
    [composicaoParaExibir, composicaoParaExibir2, operadorasLinhas],
  );

  
  // Cache local de dados RF por CNPJ (evita re-consultas e flicker)
  const [dadosRFCache, setDadosRFCache] = useState<Record<string, any>>({});
  
  // Ref para controlar se já fez a hidratação inicial (evita autosave antes de carregar)
  const hidratadoRef = useRef(false);
  // Ref para bloquear autosave durante processo de hidratação (evita race condition)
  const hidratandoRef = useRef(false);
  // Ref para guardar composição carregada original (evita sobrescrever com dados idênticos)
  const composicaoCarregadaRef = useRef<string | null>(null);
  const autosaveTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  // Ref para bloquear re-hidratação quando usuário editou composição manualmente
  const composicaoEditadaManualmenteRef = useRef(false);
  const faturaRenovacaoSincronizadaRef = useRef<string | null>(null);
  // Assinatura da ultima reconciliacao automatica com a fatura. Sem ela o efeito
  // reconcilia a cada render enquanto o predicado nao fechar — e ha' fatura em
  // que ele NUNCA fecha (dois numeros que normalizam igual, numero vazio): vira
  // laco infinito de setState, que e' a tela tremendo. Ver o efeito la' embaixo.
  const reconciliacaoFaturaRef = useRef<string | null>(null);
  // Ref de sinalização: true = próxima hidratação é a primeira desta sessão do modal
  const isFirstHydrationRef = useRef(false);
  // Refs para evitar closure stale no executarSaveImediato
  const composicaoParaExibirRef = useRef<any>(null);
  const composicaoParaExibir2Ref = useRef<any>(null);
  const propostaRef = useRef<any>(null);
  
  // Hook para consulta Receita Federal
  const { consultarCNPJ, loading: loadingRF } = useCNPJLookup();
  const { abrirConversa } = useAbrirConversaInbox();
  
  // Hook para regenerar itens do pedido após revisão
  const { regenerar, regenerando } = useRegenerarItensPedido();
  
  // NOVO: Buscar lead COMPLETO do banco quando modal abre (fonte de verdade)
  const { data: leadCompleto, isLoading: loadingLeadCompleto } = useQuery({
    queryKey: ['lead-completo', lead?.id],
    queryFn: async () => {
      if (!lead?.id) return null;
      console.log('🔍 Buscando lead completo do banco:', lead.id);
      const { data, error } = await supabase
        .from('leads_carteira')
        .select('*')
        .eq('id', lead.id)
        .maybeSingle();
      
      if (error) {
        console.error('Erro ao buscar lead completo:', error);
        return null;
      }
      console.log('✅ Lead completo carregado, proposta_composicao_cnpj:', !!data?.proposta_composicao_cnpj);
      return data;
    },
    enabled: open && !!lead?.id,
    staleTime: 0, // Sempre buscar fresh
    gcTime: 0, // Não cachear (equivale ao antigo cacheTime: 0)
  });

  // Dados derivados: priorizar leadCompleto (banco) sobre lead (prop)
  // Resolve bug onde navegação pelo carrossel passa objeto incompleto (só id)
  const dadosLead = useMemo(() => ({
    ...lead,
    ...(leadCompleto ?? {}),
  }), [lead, leadCompleto]);

  const nomeConsultorProposta = canHaveOwnSales(profile?.role)
    ? profile?.nome
    : (dadosLead?.consultor_nome || profile?.nome);

  // PROPOSTA E-MAIL e APRESENTAÇÃO SMS (Douglas 02/10/2026): para quem vai sai
  // da régua do banco (fn_destinos_proposta_lead). Contato Real preenchido → só
  // ele; vazio → todos do CNPJ. O SMS leva também todas as linhas da conta.
  const precisaDestinos = tipoMensagemAtivo === 'proposta_email' || tipoMensagemAtivo === 'apresentacao_sms';
  const destinosQuery = useQuery({
    queryKey: ['destinos-proposta', lead?.id],
    enabled: !!lead?.id && precisaDestinos,
    staleTime: 60_000,
    queryFn: () => buscarDestinosProposta(lead.id),
  });
  // O ENVIO DA PROPOSTA NA TELA (Douglas 07/10/2026): por qual linha sai, se
  // chegou, e o Criar pedido só depois que chegou. Atualiza sozinho enquanto
  // a mensagem está saindo.
  const envioPropostaQuery = useQuery({
    queryKey: ['envio-proposta', lead?.id],
    enabled: !!lead?.id && !dadosLead?.pedido_id,
    staleTime: 3_000,
    queryFn: () => buscarEnvioProposta(lead.id),
    refetchInterval: (q) => {
      const sit = q.state.data?.ultimo?.situacao;
      return sit === 'saindo' || (sit === 'enviada' && !q.state.data?.pode_criar_pedido) ? 4_000 : 30_000;
    },
  });
  const envioProposta = envioPropostaQuery.data;
  const ehEnvioDeProposta = tipoMensagemAtivo === 'proposta' || tipoMensagemAtivo === 'proposta_imagem';
  const propostaJaEnviada = ehEnvioDeProposta && envioProposta?.bloqueio?.codigo === 'mesma_proposta_ja_enviada';
  const envioSegurado = ehEnvioDeProposta && !!envioProposta?.bloqueio;
  const criarPedidoTravado = !!envioProposta && !envioProposta.pode_criar_pedido;
  const [emailsEscolhidos, setEmailsEscolhidos] = useState<string[] | null>(null);
  const [telefonesEscolhidos, setTelefonesEscolhidos] = useState<string[] | null>(null);
  const emailsMarcados = emailsEscolhidos ?? (destinosQuery.data?.emails ?? []).map((d) => d.destino);
  const telefonesMarcados = (telefonesEscolhidos ?? (destinosQuery.data?.telefones ?? []).map((d) => d.destino))
    .filter((t) => !(destinosQuery.data?.telefones ?? []).some((d) => d.destino === t && smsTravado(d)));
  const modelosSms = useMemo(() => modelosSmsProposta({
    tipoLead: lead?.tipo_lead,
    tipoPessoa: lead?.tipo_pessoa,
    razaoSocial: lead?.nome_fantasia || lead?.razao_social,
    nomeContato: lead?.contato_real_nome || lead?.razao_social,
    consultorNome: dadosLead?.consultor_nome || nomeConsultorProposta,
  }), [lead?.tipo_lead, lead?.tipo_pessoa, lead?.nome_fantasia, lead?.razao_social, lead?.contato_real_nome, dadosLead?.consultor_nome, nomeConsultorProposta]);
  // Sem celular marcado (ou todos na trava de 7 dias) não há o que enviar.
  const smsSemDestino = tipoMensagemAtivo === 'apresentacao_sms' && telefonesMarcados.length === 0;
  const [textoSms, setTextoSms] = useState<string | null>(null);
  const textoSmsAtual = textoSms ?? modelosSms[0]?.texto ?? '';
  // PROPOSTA E-MAIL editável (Douglas 05/10/2026): null = o texto pronto do
  // servidor. Como sai: SMTP, SendGrid ou os dois, "como era antes".
  const [metodoEmail, setMetodoEmail] = useState<MetodoEnvioEmail | null>(null);
  const [assuntoEmail, setAssuntoEmail] = useState<string | null>(null);
  const [aberturaEmail, setAberturaEmail] = useState<string | null>(null);
  const [fechamentoEmail, setFechamentoEmail] = useState<string | null>(null);
  const [versaoTextoEmail, setVersaoTextoEmail] = useState(0);
  // Lead CNPJ com proposta do TOP (Douglas 06/10/2026): Prévia (tabela) ou
  // Natural (o e-mail todo em texto). O que foi escrito em cada um fica guardado
  // ao trocar de modelo.
  const [modeloEmail, setModeloEmail] = useState<ModeloEmailProposta>('previa');
  const textosPorModeloEmail = useRef<Partial<Record<ModeloEmailProposta, { assunto: string | null; abertura: string | null; fechamento: string | null }>>>({});
  const [imagemPreviaEmail, setImagemPreviaEmail] = useState<string | null>(null);
  const imagemPreviaEmailRef = useRef<string | null>(null);
  useEffect(() => {
    setEmailsEscolhidos(null);
    setTelefonesEscolhidos(null);
    setTextoSms(null);
    setMetodoEmail(null);
    setAssuntoEmail(null);
    setAberturaEmail(null);
    setFechamentoEmail(null);
    setModeloEmail('previa');
    textosPorModeloEmail.current = {};
    setVersaoTextoEmail((v) => v + 1);
  }, [lead?.id]);

  // Modo revisão: SOMENTE vindo do pedido pelo botão "Revisar Proposta"
  // (que só existe em pedido no COMERCIAL ou cancelado — pedido já enviado
  // NÃO se revisa, regra do sistema). Se a janela se perder, retomar é
  // clicar de novo em "Revisar Proposta" no pedido (continua a revisão).
  const revisaoPedidoId = fromPedidoId || null;
  const emModoRevisao = !!revisaoPedidoId;
  const { data: pedidosRenovacaoExistentes = [] } = useQuery({
    queryKey: ['pedidos-renovacao-existentes', lead?.id],
    enabled: open && lead?.tipo_lead === 'RENOVACAO_CLARO' && !!lead?.id && !emModoRevisao,
    queryFn: async () => {
      const { data } = await supabase
        .from('pedidos')
        .select('id')
        .eq('lead_origem_id', lead!.id)
        .eq('deletado', false)
        .limit(1);
      return data || [];
    },
    staleTime: 15_000,
  });
  const renovacaoSomenteLeitura = !emModoRevisao
    && (Boolean(dadosLead.pedido_id) || pedidosRenovacaoExistentes.length > 0);

  // Trava por LINHA na revisão de cancelado: descobre quais linhas pertencem a itens
  // FINALIZADOS (não-editáveis) e passa pro Montador. (Douglas 16/06)
  const { data: itensPedidoRevisao = SEM_ITENS_REVISAO } = useQuery({
    queryKey: ['itens-pedido-revisao', revisaoPedidoId],
    enabled: emModoRevisao && !!revisaoPedidoId,
    queryFn: async () => {
      // Agregar MÃE + FILHOS: os itens migram pro pedido filho quando fecha,
      // então ler só da mãe (pedido_mae_id=NULL) devolve 0 itens e a trava
      // por linha não enxerga os finalizados. (Douglas 16/06)
      const { data: filhos } = await supabase.from('pedidos')
        .select('id, numero_pedido')
        .eq('pedido_mae_id', revisaoPedidoId as string);
      // numero_pedido da MÃE + filhos p/ rotular cada item (#P...-seq) no editor. (Douglas 22/06)
      const { data: mae } = await supabase.from('pedidos')
        .select('id, numero_pedido')
        .eq('id', revisaoPedidoId as string)
        .maybeSingle();
      const numeroPorPedido: Record<string, number> = {};
      [mae, ...((filhos || []) as any[])].forEach((p: any) => { if (p?.id) numeroPorPedido[p.id] = p.numero_pedido; });
      const ids = [revisaoPedidoId as string, ...((filhos || []).map((f: any) => f.id))];
      const { data } = await supabase.from('itens_pedido')
        .select('id, linha_id, quadro_atual, data_ativacao, linhas_telefone, seq, pedido_id')
        .in('pedido_id', ids);
      // Enriquecer com _numeroItem (#P<pedido>-<seq>) p/ sinalizar o vínculo da linha
      // com o item no editor de revisão. (Douglas 22/06)
      return (data || []).map((it: any) => ({
        ...it,
        _numeroItem: numeroPorPedido[it.pedido_id]
          ? `${formatPedidoCode(numeroPorPedido[it.pedido_id])}-${it.seq ?? '?'}`
          : (it.seq != null ? `item ${it.seq}` : null),
      }));
    },
  });
  // 🛡️ Itens de OUTROS pedidos do lead (familia movel/fixa) — travam suas linhas na
  // revisao de UM pedido (nao deixa editar/inserir linha que vive em outro pedido). (25/06)
  const { data: itensOutrosPedidosRevisao = SEM_ITENS_REVISAO } = useQuery({
    queryKey: ['itens-outros-pedidos-revisao', revisaoPedidoId, lead?.id],
    enabled: emModoRevisao && !!revisaoPedidoId && !!lead?.id,
    queryFn: async () => {
      const { data: filhos } = await supabase.from('pedidos').select('id').eq('pedido_mae_id', revisaoPedidoId as string);
      const idsRevisado = [revisaoPedidoId as string, ...((filhos || []).map((f: any) => f.id))];
      const { data: pedidosLead } = await supabase.from('pedidos').select('id').eq('lead_origem_id', lead!.id).eq('deletado', false);
      const idsOutros = (pedidosLead || []).map((p: any) => p.id).filter((id: string) => !idsRevisado.includes(id));
      if (idsOutros.length === 0) return [] as any[];
      const { data } = await supabase.from('itens_pedido').select('id, linha_id, quadro_atual, data_ativacao, linhas_telefone, seq, pedido_id').in('pedido_id', idsOutros);
      return data || [];
    },
  });
  const linhasTravadasIds = useMemo(
    () => emModoRevisao
      ? computarLinhasTravadas(itensPedidoRevisao as any, ((composicaoBase as any)?.linhas as any) || [], !!(leadCompleto as any)?.revisao_de_cancelado, itensOutrosPedidosRevisao as any)
      : SEM_LINHAS_TRAVADAS,
    [emModoRevisao, itensPedidoRevisao, composicaoBase, leadCompleto, itensOutrosPedidosRevisao],
  );

  // Itens protegidos (não-cancelados) p/ a trava ROBUSTA por linha no Montador. (Douglas 16/06)
  const itensProtegidosRevisao = useMemo(
    () => emModoRevisao
      ? [...filtrarItensProtegidos(itensPedidoRevisao as any, !!(leadCompleto as any)?.revisao_de_cancelado), ...((itensOutrosPedidosRevisao as any[]) || [])]
      : SEM_ITENS_REVISAO,
    [emModoRevisao, itensPedidoRevisao, leadCompleto, itensOutrosPedidosRevisao],
  );

  // Recuperação de cancelado: aplica direto (1 botão, sem mandar nada ao cliente). (Douglas 16/06)
  const isRevisaoCancelado = emModoRevisao && (leadCompleto as any)?.revisao_de_cancelado === true;

  // Recuperar parte do pedido (Douglas 23/10/2026): itens cancelados que o cliente
  // não quer mais ficam no cancelado; o resto volta. Vale só para esta revisão.
  const [ficamCancelados, setFicamCancelados] = useState<Set<string>>(() => new Set());
  const [motivoFicamEscolhido, setMotivoFicamEscolhido] = useState<string | null>(null);
  useEffect(() => {
    setFicamCancelados(new Set());
    setMotivoFicamEscolhido(null);
  }, [revisaoPedidoId]);
  const { data: motivosFicaCancelada = [] } = useMotivosFicaCancelada(isRevisaoCancelado);
  const motivoFicamId = motivoFicamEscolhido ?? motivosFicaCancelada[0]?.id ?? MANTER_MOTIVO_ATUAL;
  const separacaoRecuperacao = useMemo(
    () => isRevisaoCancelado
      ? separarRecuperacao(composicaoParaExibir?.linhas || [], itensPedidoRevisao as any, ficamCancelados, itensOutrosPedidosRevisao as any)
      : { volta: [], fica: [] },
    [isRevisaoCancelado, composicaoParaExibir, itensPedidoRevisao, ficamCancelados, itensOutrosPedidosRevisao],
  );

  // 🆕 Buscar Planta Vivo Snapshot para leads de PORTABILIDADE
  const { snapshot: plantaVivoSnapshot, isLoading: loadingPlantaVivo } = usePlantaVivoSnapshot(
    lead?.tipo_lead === 'PORTABILIDADE_VIVO' ? lead?.id : null
  );
  
  // 🆕 Buscar parque móvel VIVO do staging para PORTABILIDADE (dados mais atuais)
  const { data: parqueMovelVivo } = useParqueMovelByCnpj(
    lead?.tipo_lead === 'PORTABILIDADE_VIVO' ? lead?.cnpj : null
  );
  
  // 🆕 Buscar parque fixo VIVO do staging para PORTABILIDADE
  const { data: parqueFixoVivo } = useParqueFixoByCnpj(
    lead?.tipo_lead === 'PORTABILIDADE_VIVO' ? lead?.cnpj : null
  );
  
  // Mapa Parque para header (tp_produto, linhas fixas)
  const { mapaParque: mapaParqueHeader } = useMapaParqueByCnpj(lead?.cnpj);
  
  // TM e classificação da última carteira Claro: é a régua da trava do pedido.
  // Fica numa ref para a chegada dela não re-hidratar a proposta aberta.
  const { data: carteiraClaroAtual } = useCarteiraClaroAtual(lead?.cnpj);
  const { data: enviosMensagem } = useEnviosMensagemLead(lead?.id);
  const carteiraRenovacaoRef = useRef<CarteiraClaroAtual | null>(null);
  useEffect(() => {
    carteiraRenovacaoRef.current = carteiraClaroAtual ?? null;
  }, [carteiraClaroAtual]);

  // Buscar dados resumidos da fatura para auto-preencher Plano Atual
  const { data: dadosFatura } = useQuery({
    queryKey: ['fatura-resumo-lead', lead?.cliente_id, lead?.cnpj, lead?.tipo_pessoa === 'PF' ? lead?.cpf : null],
    queryFn: async () => {
      let clienteIdParaBusca = lead?.cliente_id;
      
      // FALLBACK: Se não tem cliente_id, buscar cliente pelo CNPJ
      if (!clienteIdParaBusca && lead?.cnpj) {
        const { data: clienteData } = await supabase
          .from('clientes')
          .select('id')
          .eq('cnpj', lead.cnpj)
          .maybeSingle();
        
        if (clienteData?.id) {
          clienteIdParaBusca = clienteData.id;
          
          // Atualizar o lead com o cliente_id encontrado para futuras consultas
          await supabase
            .from('leads_carteira')
            .update({ cliente_id: clienteData.id })
            .eq('id', lead.id);
        }
      }
      
      const { data: linhasContas, error: erroContas } = await supabase.rpc('renovacao_linhas_contas', {
        // CPF: a conta CPF (a da gerente) fica pelo documento da pessoa — é ajuda, não obrigação
        p_cnpj: (lead?.tipo_pessoa === 'PF' ? (lead as { cpf?: string | null }).cpf : lead?.cnpj) || '',
      });
      if (erroContas) throw erroContas;
      const _linhasBase = Array.isArray(linhasContas) ? linhasContas as unknown as LinhaContaFatura[] : [];
      if (!_linhasBase.length) return null;
      const faturaUploadIds = [...new Set(_linhasBase.map(linha => String(linha.fatura_upload_id)))];
      const faturaUploadId = faturaUploadIds[0];
      const sugestoesPorMsisdn = new Map<string, SugestaoRenovacaoFatura>();
      const { data: analises, error: erroAnalises } = await supabase
        .from('fatura_analise').select('fatura_id,json_resultado').in('fatura_id', faturaUploadIds);
      if (erroAnalises) throw erroAnalises;
      for (const analise of analises || []) {
        const resultado = analise.json_resultado as unknown as {
          analise_detalhada?: { linhas?: LinhaAnaliseSugestaoFatura[] };
        } | null;
        for (const linha of resultado?.analise_detalhada?.linhas || []) {
          const msisdn = normalizarMsisdn(linha.msisdn || '');
          const proposta = linha.proposta_otimizacao;
          if (_linhasBase.some(base => base.fatura_upload_id === analise.fatura_id && normalizarMsisdn(base.msisdn) === msisdn)
            && proposta?.plano_codigo && Number(proposta.valor_mensal || 0) > 0) {
            sugestoesPorMsisdn.set(msisdn, proposta);
          }
        }
      }
      const visaoConta: any = { linhas_ativas: _linhasBase.length };
      const linhasAnaliseDetalhada: any[] = _linhasBase.map((l: any) => ({
        msisdn: l.msisdn,
        faturaUploadId: l.fatura_upload_id,
        contaNumero: l.conta_numero,
        competenciaFatura: l.competencia,
        dataFidelidade: l.data_fidelidade ?? null,
        situacao_atual: {
          gb_nominal: Number(l.gb_nominal || 0),
          gb_elegivel_renovacao: Number(l.gb_elegivel_renovacao || l.gb_nominal || 0),
          valor_mensal: Number(l.valor_mensal_linha || 0),
          plano_nome: l.plano_atual || 'N/I',
        },
        proposta_otimizacao: {
          gb_livre: Number(sugestoesPorMsisdn.get(normalizarMsisdn(l.msisdn))?.gb_livre ?? l.gb_elegivel_renovacao ?? 0),
          gb_redes_sociais: Number(sugestoesPorMsisdn.get(normalizarMsisdn(l.msisdn))?.gb_redes_sociais || 0),
          valor_mensal: Number(sugestoesPorMsisdn.get(normalizarMsisdn(l.msisdn))?.valor_mensal || 0),
          ...sugestoesPorMsisdn.get(normalizarMsisdn(l.msisdn)),
        },
      }));
      const linhasFonte = linhasAnaliseDetalhada;
      
      // Calcular total GB somando gb_nominal de cada linha
      const totalGb = linhasFonte.reduce((sum: number, l: any) => {
        return sum + (l.situacao_atual?.gb_nominal || 0);
      }, 0);
      
      // Calcular VALOR ATUAL somando valor_mensal de cada linha (não usar visao_conta)
      const totalValorAtual = linhasFonte.reduce((sum: number, l: any) => {
        return sum + (l.situacao_atual?.valor_mensal || l.situacao_atual?.valor || 0);
      }, 0);
      
      // Calcular totais da proposta (Plano Novo) - usando analise_detalhada.linhas
      const linhasAnalise = linhasAnaliseDetalhada;
      
      // GB Novo = gb_livre + gb_redes_sociais
      const totalGbProposto = linhasAnalise.reduce((sum: number, l: any) => {
        const gbLivre = l.proposta_otimizacao?.gb_livre || 0;
        const gbRedes = l.proposta_otimizacao?.gb_redes_sociais || 0;
        return sum + gbLivre + gbRedes;
      }, 0);
      
      const totalValorProposto = linhasAnalise.reduce((sum: number, l: any) => {
        return sum + (l.proposta_otimizacao?.valor_mensal || 0);
      }, 0);
      
      return {
        faturaUploadId,
        // Plano Atual
        linhas: visaoConta?.linhas_ativas || linhasFonte.length,
        gb: totalGb,
        valor: totalValorAtual,  // Soma das linhas, não visao_conta
        // Plano Novo
        gb_proposto: totalGbProposto,
        valor_proposto: totalValorProposto,
        // Linhas detalhadas para exibição no comparativo - USAR linhasFonte que tem msisdn correto
        linhasDetalhadas: linhasFonte.map((l: any) => ({
          faturaUploadId: l.faturaUploadId,
          contaNumero: l.contaNumero,
          competenciaFatura: l.competenciaFatura,
          numero: l.msisdn || l.numero || '',
          gbAtual: l.situacao_atual?.gb_elegivel_renovacao || l.situacao_atual?.gb_nominal || 0,
          valorAtual: l.situacao_atual?.valor_mensal || l.situacao_atual?.valor || 0,
          planoAtual: l.situacao_atual?.plano_nome || l.situacao_atual?.plano || 'N/I',
          sugestaoPlanoId: l.proposta_otimizacao?.plano_codigo || null,
          sugestaoPlanoNome: l.proposta_otimizacao?.plano_nome || null,
          sugestaoValor: Number(l.proposta_otimizacao?.valor_mensal || 0),
          sugestaoDelta: l.proposta_otimizacao?.delta_percentual ?? null,
          sugestaoFaixa: l.proposta_otimizacao?.faixa_delta ?? null,
          sugestaoAcrescimo: Number(l.proposta_otimizacao?.acrescimo_receita || 0),
          sugestaoTicketAlvoFaixa1: l.proposta_otimizacao?.ticket_alvo_faixa_1 ?? null,
          sugestaoMotivo: l.proposta_otimizacao?.sugestao_motivo || '',
          dataFidelidade: l.dataFidelidade ?? null,
        })),
      };
    },
    enabled: !!(lead?.cliente_id || lead?.cnpj),
    refetchInterval: lead?.tipo_lead === 'RENOVACAO_CLARO' ? 5_000 : false,
    refetchOnWindowFocus: true,
  });
  
  // Auto-preencher proposta com dados da fatura (cada campo independente)
  // IMPORTANTE: Para RENOVACAO_CLARO, SEMPRE sincronizar linhas_atual com a fatura analisada
  // mesmo que já tenha um valor (pois o valor antigo do lead pode estar desatualizado)
  useEffect(() => {
    if (dadosFatura) {
      const isFalsy = (val: string) => !val || val === '' || val === '0' || val === '0,00';
      const tipoLead = (leadCompleto || lead)?.tipo_lead;
      
      setProposta(prev => {
        // Para RENOVACAO_CLARO: linhas_atual SEMPRE vem da fatura (fonte de verdade)
        // Isso corrige o problema de mostrar 9 linhas quando a fatura diz 7
        const linhasAtualCorreto = (() => {
          if (tipoLead === 'RENOVACAO_CLARO' && dadosFatura.linhas) {
            return dadosFatura.linhas.toString();
          }
          // Para outros tipos: só preenche se falsy
          return isFalsy(prev.linhas_atual) ? (dadosFatura.linhas?.toString() || '') : prev.linhas_atual;
        })();
        
        return {
          ...prev,
          // Plano Atual
          linhas_atual: linhasAtualCorreto,
          gb_atual: isFalsy(prev.gb_atual) ? (dadosFatura.gb?.toString() || '') : prev.gb_atual,
          valor_atual: isFalsy(prev.valor_atual) ? (dadosFatura.valor?.toFixed(2).replace('.', ',') || '') : prev.valor_atual,
          // Plano Novo: preenche se valor atual for falsy
          linhas_novo: isFalsy(prev.linhas_novo) ? (dadosFatura.linhas?.toString() || '') : prev.linhas_novo,
          gb_novo: isFalsy(prev.gb_novo) ? (dadosFatura.gb_proposto?.toString() || '') : prev.gb_novo,
          valor_novo: isFalsy(prev.valor_novo) ? (dadosFatura.valor_proposto?.toFixed(2).replace('.', ',') || '') : prev.valor_novo,
        };
      });
    }
  }, [dadosFatura, leadCompleto, lead]);

  // 🆕 Auto-preencher proposta com dados do snapshot (PORTABILIDADE_VIVO)
  useEffect(() => {
    if (plantaVivoSnapshot && lead?.tipo_lead === 'PORTABILIDADE_VIVO') {
      const isFalsy = (val: string) => !val || val === '' || val === '0' || val === '0,00';
      
      setProposta(prev => ({
        ...prev,
        // Só preenche se estiver vazio (não sobrescreve edição manual)
        linhas_atual: isFalsy(prev.linhas_atual) ? plantaVivoSnapshot.total_linhas.toString() : prev.linhas_atual,
        gb_atual: isFalsy(prev.gb_atual) ? plantaVivoSnapshot.gb_total.toFixed(0) : prev.gb_atual,
        valor_atual: isFalsy(prev.valor_atual) ? plantaVivoSnapshot.valor_total.toFixed(2).replace('.', ',') : prev.valor_atual,
      }));
    }
  }, [plantaVivoSnapshot, lead?.tipo_lead]);
  
  // Estados editáveis
  const [contato, setContato] = useState({
    nome: '',
    telefone: '',
    cargo: '',
    email: '',
  });
  
  // Linhas inseridas manualmente pelo consultor (quando não há fatura)
  const [linhasManuaisRenovacao, setLinhasManuaisRenovacao] = useState<{numero: string; gbAtual: number; valorAtual: number}[]>([]);

  // Estado da proposta completa (inclui fibra_atual e tv_atual separado de obs_atual)
  const [proposta, setProposta] = useState({
    linhas_atual: '',
    gb_atual: '',
    valor_atual: '',
    fibra_atual: '', // Campo dedicado para fibra
    tv_atual: '', // Campo dedicado para TV
    obs_atual: '', // Mantém para observações gerais
    linhas_novo: '',
    gb_novo: '',
    valor_novo: '',
    diferencial_novo: '',
    mensagem_whats: DEFAULT_PROPOSTA_MESSAGE,
    mensagem_retorno: DEFAULT_RETORNO_MESSAGE,
    mensagem_fechamento: DEFAULT_FECHAMENTO_MESSAGE,
    mensagem_apresentacao: DEFAULT_APRESENTACAO_MESSAGE,
    mensagem_apresentacao_carteira: DEFAULT_APRESENTACAO_CARTEIRA_MESSAGE,
    mensagem_apresentacao_2: '',
    mensagem_apresentacao_3: '',
    ocultar_plano_atual: false, // Toggle para ocultar plano atual da proposta
    ocultar_plano_fixo: false, // Toggle para ocultar plano fixo da proposta
  });

  // Oi e Algar (Douglas 02/10/2026): a Apresentação do lead é o texto da mesma
  // régua do disparo — a mensagem aprovada da situação dele, já preenchida.
  const ehLeadLista = TIPOS_LEAD_LISTA_CPF.has(String(lead?.tipo_lead ?? ''));
  const { data: aberturaLista } = useAberturaListaCpf(lead?.id, !!open && ehLeadLista);
  const aberturaListaRef = useRef<string | null>(null);
  aberturaListaRef.current = aberturaLista?.texto ?? null;
  useEffect(() => {
    const texto = aberturaLista?.texto;
    if (!texto) return;
    setProposta(prev => (prev.mensagem_apresentacao === texto ? prev : { ...prev, mensagem_apresentacao: texto }));
  }, [aberturaLista?.texto]);

  // Helper para parsing de números em pt-BR (123,45 → 123.45)
  const parseNumeroBR = (str: string): number => {
    if (!str) return 0;
    // Remove tudo exceto dígitos, vírgula e ponto
    const limpo = str.replace(/[^\d,.\-]/g, '');
    // Troca vírgula por ponto (formato BR → formato JS)
    const normalizado = limpo.replace(',', '.');
    const resultado = parseFloat(normalizado);
    return isNaN(resultado) ? 0 : resultado;
  };

  // NOVO: Usar leadCompleto (do banco) como fonte de verdade, fallback para lead (da lista)
  const leadFonte = leadCompleto || lead;
  
  // 🆕 Estado para rastrear se contato veio do master
  const [contatoOrigemMaster, setContatoOrigemMaster] = useState(false);
  
  // 🔒 Ref para proteger campos de contato editados manualmente de serem sobrescritos pela hidratação
  const contatoEditadoManualmenteRef = useRef(false);
  
  // 🆕 Buscar master se lead não tem contato real (fallback por CNPJ)
  const { master: masterData } = useCnpjContatoMaster(
    !leadFonte?.contato_real_nome && leadFonte?.cnpj ? leadFonte.cnpj : null
  );
  
  // 🆕 Preencher contato do master se disponível e lead não tem
  useEffect(() => {
    if (masterData?.contato_real_nome && !contato.nome && !leadFonte?.contato_real_nome) {
      console.log('📇 [Modal] Preenchendo contato do master:', masterData.contato_real_nome);
      setContato({
        nome: masterData.contato_real_nome,
        telefone: masterData.contato_real_telefone || '',
        cargo: masterData.contato_real_cargo || '',
        email: masterData.contato_real_email || '',
      });
      setContatoOrigemMaster(true);
    }
  }, [masterData, leadFonte?.contato_real_nome]);
  
  // Carregar dados quando lead muda (incluindo composição salva)
  // IMPORTANTE: Usar leadCompleto quando disponível para garantir dados atualizados
  useEffect(() => {
    // Aguardar leadCompleto se ainda está carregando
    if (lead?.id && loadingLeadCompleto) {
      console.log('⏳ Aguardando lead completo do banco...');
      hidratandoRef.current = true;
      hidratadoRef.current = false;
      return;
    }
    
    const fonte = leadCompleto || lead;
    if (fonte) {
      // BLOQUEAR autosave durante hidratação para evitar race condition
      hidratandoRef.current = true;
      hidratadoRef.current = false;
      
      console.log('📥 Hidratando lead:', fonte.id, '| Fonte:', leadCompleto ? 'BANCO' : 'LISTA');
      
      // Resetar flag de origem master quando lead muda
      setContatoOrigemMaster(false);
      
      // 🔒 Só sobrescreve contato se o usuário NÃO editou manualmente
      if (!contatoEditadoManualmenteRef.current) {
        setContato({
          nome: fonte.contato_real_nome || '',
          telefone: fonte.contato_real_telefone || '',
          cargo: fonte.contato_real_cargo || '',
          email: fonte.contato_real_email || '',
        });
      }
      // Obter mensagens padrão conforme tipo de lead
      const defaultMsgs = getDefaultMessages(fonte.tipo_lead || '', fonte.tipo_pessoa);
      
      // Para RENOVACAO_CLARO, priorizar linhas da fatura analisada
      // Para PORTABILIDADE_VIVO, priorizar dados do snapshot
      const linhasAtualCalculado = (() => {
        if (fonte.tipo_lead === 'RENOVACAO_CLARO' && dadosFatura?.linhas) {
          return dadosFatura.linhas.toString();
        }
        if (fonte.tipo_lead === 'PORTABILIDADE_VIVO' && plantaVivoSnapshot) {
          return plantaVivoSnapshot.total_linhas.toString();
        }
        return fonte.qtd_linhas_voz?.toString() || '';
      })();
      
      const gbAtualCalculado = (() => {
        if (fonte.tipo_lead === 'PORTABILIDADE_VIVO' && plantaVivoSnapshot) {
          return plantaVivoSnapshot.gb_total.toFixed(0);
        }
        return fonte.proposta_gb_atual?.toString() || '';
      })();
      
      const valorAtualCalculado = (() => {
        if (fonte.tipo_lead === 'PORTABILIDADE_VIVO' && plantaVivoSnapshot) {
          return plantaVivoSnapshot.valor_total.toFixed(2).replace('.', ',');
        }
        return fonte.valor_fatura_atual?.toString() || '';
      })();
      
      setProposta({
        linhas_atual: linhasAtualCalculado,
        gb_atual: gbAtualCalculado,
        valor_atual: valorAtualCalculado,
        fibra_atual: (fonte as any).proposta_fibra_atual || '',
        tv_atual: (fonte as any).proposta_tv_atual || '',
        obs_atual: fonte.observacoes_consultor || '',
        linhas_novo: fonte.proposta_linhas_novo?.toString() || '',
        gb_novo: fonte.proposta_gb_novo?.toString() || '',
        valor_novo: fonte.valor_proposta?.toString() || '',
        diferencial_novo: fonte.proposta_diferencial || '',
        mensagem_whats: fonte.proposta_mensagem_whats || defaultMsgs.proposta,
        mensagem_retorno: (fonte as any).proposta_mensagem_retorno || defaultMsgs.retorno,
        mensagem_fechamento: defaultMsgs.fechamento,
        mensagem_apresentacao: (fonte as any).proposta_mensagem_apresentacao || defaultMsgs.apresentacao,
        mensagem_apresentacao_carteira: (fonte as any).proposta_mensagem_apresentacao_carteira || defaultMsgs.apresentacao_carteira,
        mensagem_apresentacao_2: (fonte as { proposta_mensagem_apresentacao_2?: string | null }).proposta_mensagem_apresentacao_2 || '',
        mensagem_apresentacao_3: (fonte as { proposta_mensagem_apresentacao_3?: string | null }).proposta_mensagem_apresentacao_3 || '',
        ocultar_plano_atual: (fonte as any).ocultar_plano_atual || false,
        ocultar_plano_fixo: (fonte as any).ocultar_plano_fixo || false,
      });
      
      // Hidratar composição salva do banco (se existir)
      const composicaoSalva = (fonte as any).proposta_composicao_cnpj;
      console.log('📦 Composição salva encontrada:', !!composicaoSalva, composicaoSalva?.linhas?.length || 0, 'linhas');
      
      if (composicaoSalva && Array.isArray(composicaoSalva.linhas) && composicaoSalva.linhas.length > 0) {
        try {
          const isRenovacao = fonte.tipo_lead === 'RENOVACAO_CLARO';
          const faturaLinhas = dadosFatura?.linhasDetalhadas;

          let composicaoHidratada: ComposicaoProposta;
          let forcarSincronizacaoFatura = false;

          if (isRenovacao && faturaLinhas && faturaLinhas.length > 0) {
            const composicaoPreparada: ComposicaoProposta = {
              ...composicaoSalva,
              linhas: composicaoSalva.linhas.map((linha: LinhaComposicao) => {
                const tipo = String(linha.tipo) === 'MOVEL' ? 'RENOVACAO' : linha.tipo;
                return {
                  ...linha,
                  tipo,
                  plano: tipo === 'RENOVACAO'
                    ? linha.plano
                    : linha.planoId ? resolverPlano(linha.planoId, tipo) : undefined,
                  adicionais: linha.adicionais || undefined,
                };
              }),
            };
            const metaRenovacao = {
              flagForaAreaCabeada: 'NAO_INFORMADO',
              flagBlFixaAtiva: 'NAO_INFORMADO',
              flagConvergenciaAto: 'NAO_INFORMADO',
              pedidoFixaVinculadoId: null,
              mesCompetencia: new Intl.DateTimeFormat('en-CA', {
                timeZone: 'America/Sao_Paulo',
                year: 'numeric',
                month: '2-digit',
              }).format(new Date()),
              modoAgrupamento: 'POR_LINHA',
              ...composicaoSalva.renovacao,
              faturaUploadId: dadosFatura?.faturaUploadId || null,
            } as RenovacaoSimulacao;
            const assinaturaCatalogo = planosRenovacao
              .map((plano) => `${plano.id}:${plano.gb}:${plano.valor}`)
              .join(';');
            const assinaturaFatura = `${assinaturaFaturaRenovacao(fonte.id, dadosFatura?.faturaUploadId, faturaLinhas)}|${assinaturaCatalogo}`;
            forcarSincronizacaoFatura = faturaRenovacaoSincronizadaRef.current !== assinaturaFatura;
            faturaRenovacaoSincronizadaRef.current = assinaturaFatura;
            const reconciliada = reconciliarRenovacaoComFatura(
              composicaoPreparada,
              faturaLinhas,
              planosRenovacao,
              metaRenovacao,
              carteiraRenovacaoRef.current?.tempo_contrato_voz ?? fonte.m_atual ?? fonte.tempo_contrato_voz_num ?? Number(String(fonte.tempo_contrato_voz || '').replace(/\D/g, '')),
              carteiraRenovacaoRef.current?.classificacao ?? null,
              { sugerirPlano: false },
            );
            if (!reconciliada) throw new Error('Não foi possível conciliar a proposta com a última fatura');
            composicaoHidratada = reconciliada;
            console.log('✅ [Hidratação] RENOVACAO_CLARO sincronizada com', faturaLinhas.length, 'linhas da última fatura');
          } else {
            const linhasHidratadas = composicaoSalva.linhas.map((l: any) => {
              const planoId = l.planoId || (l.tipo === 'RENOVACAO' ? 'ren-25' : l.tipo === 'PORTABILIDADE' ? 'port-70' : null);
              return {
                ...l,
                planoId,
                plano: planoId ? (resolverPlano(planoId, l.tipo) ?? l.plano) : undefined,
                adicionais: l.adicionais || undefined,
              };
            });
            const planoFibra = linhasHidratadas.find((l: any) => l.tipo === 'FIBRA')?.plano;
            const temFibra = linhasHidratadas.some((l: any) => l.tipo === 'FIBRA');
            composicaoHidratada = {
              renovacao: composicaoSalva.renovacao,
              linhas: linhasHidratadas,
              incluiFibra: temFibra,
              planoFibra,
              totalGB: calcularTotalGB(linhasHidratadas, temFibra),
              totalValor: calcularTotalValor(linhasHidratadas),
              economiaValor: 0,
              economiaPercent: 0,
            };
          }
          // Se esta é a primeira hidratação desta sessão do modal, forçar reset do flag
          // antes de verificar — isso garante que dados do banco são carregados mesmo
          // que o usuário tivesse editado na sessão anterior
          if (isFirstHydrationRef.current) {
            composicaoEditadaManualmenteRef.current = false;
            isFirstHydrationRef.current = false; // consumir o sinal
          }
          // Setar ambos: base (para Montador) e editando (para exibição)
          // Só re-hidratar se o usuário não editou manualmente (evita loop ao deletar linha)
          if (forcarSincronizacaoFatura || !composicaoEditadaManualmenteRef.current) {
            setComposicaoBase(composicaoHidratada);
            setComposicaoEditando(composicaoHidratada);
            composicaoParaExibirRef.current = composicaoHidratada;
          }
          
          console.log('✅ Composição hidratada com', composicaoHidratada.linhas.length, 'linhas');
          
          // Gerar mensagem de fechamento imediatamente com dados reais da composição
          try {
            const paramsFechamento = {
              nomeCliente: (fonte as any)?.contato_nome || (fonte as any)?.nome_fantasia || '',
              razaoSocial: (fonte as any)?.razao_social || '',
              consultorNome: nomeConsultorProposta || user?.user_metadata?.nome || 'Consultor',
              valorAtual: 0,
              composicaoNova: (fonte as any)?.tipo_pessoa === 'PF' ? { ...composicaoHidratada, tipoPessoa: 'PF' as const } : composicaoHidratada,
              tipoLead: (fonte as any)?.tipo_lead || '',
              clienteCpf: clienteCpfDoLead(fonte),
            };
            const msgFechamentoReal = gerarMensagemFechamentoCompleta(paramsFechamento);
            setProposta(prev => ({ ...prev, mensagem_fechamento: msgFechamentoReal }));
          } catch (e) {
            console.error('Erro ao gerar fechamento na hidratação:', e);
          }
          
          // Guardar referência da composição carregada para comparação no autosave
          composicaoCarregadaRef.current = JSON.stringify({
            linhas: composicaoHidratada.linhas.map(l => ({
              id: l.id,
              tipo: l.tipo,
              numero: l.numero,
              planoId: l.planoId,
              adicionais: l.adicionais || undefined,
              tipoFibra: l.tipoFibra || undefined,
            })),
          });
        } catch (e) {
          console.error('Erro ao hidratar composição salva:', e);
        }
      } else if (isFirstHydrationRef.current || !composicaoEditadaManualmenteRef.current) {
        // Limpar estados quando não há composição salva.
        // ⛔ NÃO limpar o que o consultor acabou de montar: enquanto o banco
        // ainda está sem composição (1º item da proposta, save em voo ou que
        // falhou), qualquer refetch do lead re-executa esta hidratação. Sem a
        // guarda, o item recém-adicionado sumia do ESTADO enquanto seguia na
        // tela do Montador — e o botão "Criar pedido" acusava "Adicione pelo
        // menos um produto" com a fibra visível na proposta (01/09/2026).
        // A mesma guarda já protege o ramo de cima; aqui faltava.
        console.log('⚠️ Sem composição salva, limpando estados');
        isFirstHydrationRef.current = false;
        setComposicaoBase(null);
        setComposicaoEditando(null);
        composicaoParaExibirRef.current = null;
        composicaoCarregadaRef.current = null;
      }

      // Hidratar composição 2 (Plano Novo 2 — Renovação com Incremento)
      const composicaoSalva2 = (fonte as any).proposta_composicao_cnpj_2;
      if (composicaoSalva2 && Array.isArray(composicaoSalva2.linhas) && composicaoSalva2.linhas.length > 0) {
        try {
          const linhasH2 = composicaoSalva2.linhas.map((l: any) => ({
            ...l,
            plano: l.planoId ? (resolverPlano(l.planoId, l.tipo) ?? l.plano) : undefined,
            adicionais: l.adicionais || undefined,
          }));
          const totalGB2 = calcularTotalGB(linhasH2, false);
          const totalValor2 = calcularTotalValor(linhasH2);
          const comp2: ComposicaoProposta = {
            linhas: linhasH2,
            tipoProposta: 'RENOVACAO_INCREMENTO',
            incluiFibra: false,
            totalGB: totalGB2,
            totalValor: totalValor2,
            economiaValor: 0,
            economiaPercent: 0,
          };
          setComposicaoBase2(comp2);
          setComposicaoEditando2(comp2);
        } catch (e) {
          console.error('Erro ao hidratar composição 2:', e);
        }
      } else {
        setComposicaoBase2(null);
        setComposicaoEditando2(null);
      }
      
      // Marcar como hidratado APÓS um delay — mais curto se sem composição (evita bloquear autosave)
      const composicaoSalvaParaDelay = leadCompleto?.proposta_composicao_cnpj as any;
      const delayHidratacao = 300; // Sempre 300ms — autosave tem 800ms, garantindo hidratação antes do primeiro save
      setTimeout(() => {
        hidratadoRef.current = true;
        hidratandoRef.current = false; // LIBERAR autosave
        console.log('🔓 Hidratação completa, autosave liberado (delay:', delayHidratacao, 'ms)');
      }, delayHidratacao);
    }
    
    // Cleanup: resetar hidratado quando trocar de lead
    return () => {
      hidratadoRef.current = false;
      hidratandoRef.current = false;
    };
  }, [lead?.id, leadCompleto, loadingLeadCompleto, plantaVivoSnapshot, dadosFatura, planosRenovacao, resolverPlano, nomeConsultorProposta]);

  // 🔒 Resetar proteção de contato APENAS ao trocar de lead (não a cada refetch)
  useEffect(() => {
    contatoEditadoManualmenteRef.current = false;
  }, [lead?.id]);

  // 🔒 Resetar proteção de composição ao trocar de lead OU ao reabrir o modal
  useEffect(() => {
    if (open) {
      isFirstHydrationRef.current = true; // sinalizar que próxima hidratação é nova sessão
      composicaoEditadaManualmenteRef.current = false; // reset antecipado (melhor esforço)
      reconciliacaoFaturaRef.current = null; // lead novo, fatura nova: pode reconciliar de novo
      hidratadoRef.current = false;
      hidratandoRef.current = false;
      // NÃO limpar composicaoBase/composicaoEditando aqui — a hidratação em useEffect A
      // cuida disso, e limpar aqui cria conflito de timing com o setComposicaoBase em A
    }
  }, [lead?.id, open]);

  // 🔁 Carrega variações A/B/C dos templates do banco e seleciona uma de forma
  // determinística pelo lead.id. Só substitui se a mensagem ainda for o default
  // hardcoded (ou seja, não foi personalizada e salva para este lead).
  useEffect(() => {
    if (!lead?.id || !open) return;
    let cancelado = false;
    (async () => {
      try {
        const all = await getDefaultMessagesFromDBComVariacoes(lead.tipo_lead || '', lead.tipo_pessoa, { creditoAprovado: (lead.dados_master_lead as Record<string, unknown> | null)?.credito_aprovado === true });
        if (cancelado) return;
        const pick = (variacoes: string[]) => selecionarVariacaoPorLead(variacoes, lead.id);
        setProposta(prev => {
          const next = { ...prev };
          // Apresentação — só sobrescreve se ainda está com o default hardcoded
          if (lead.tipo_pessoa === 'PF') {
            // CPF: Apresentação 1, 2 e 3 são as três variações do modelo do tipo
            // do lead. O slot só é trocado se ainda não foi personalizado.
            const variacoes = all.apresentacao;
            const livre = (t: string) => !t?.trim() || ehMensagemPadrao(t, 'apresentacao') || variacoes.includes(t);
            const v = (i: number) => variacoes[i] ?? variacoes[0] ?? '';
            // Retenção: a Apresentação 1 fala da assinatura com biometria — quem
            // parou em outra etapa recebe a 2 (a que diz onde parou).
            const semAssinatura = lead.tipo_lead === 'RETENCAO_CPF'
              && (lead.dados_master_lead as Record<string, unknown> | null)?.etapa_parada !== 'na assinatura do contrato';
            if (livre(prev.mensagem_apresentacao)) next.mensagem_apresentacao = v(semAssinatura ? 1 : 0);
            if (livre(prev.mensagem_apresentacao_2)) next.mensagem_apresentacao_2 = v(1);
            if (livre(prev.mensagem_apresentacao_3)) next.mensagem_apresentacao_3 = v(2);
          } else if (ehMensagemPadrao(prev.mensagem_apresentacao, 'apresentacao')) {
            next.mensagem_apresentacao = pick(all.apresentacao);
          }
          if (ehMensagemPadrao(prev.mensagem_apresentacao_carteira, 'apresentacao_carteira')) {
            next.mensagem_apresentacao_carteira = pick(all.apresentacao_carteira);
          }
          if (ehMensagemPadrao(prev.mensagem_whats, 'proposta')) {
            next.mensagem_whats = pick(all.proposta);
          }
          if (ehMensagemPadrao(prev.mensagem_retorno, 'retorno')) {
            next.mensagem_retorno = pick(all.retorno);
          }
          if (ehMensagemPadrao(prev.mensagem_fechamento, 'fechamento')) {
            next.mensagem_fechamento = pick(all.fechamento);
          }
          if (aberturaListaRef.current) next.mensagem_apresentacao = aberturaListaRef.current;
          return next;
        });
      } catch (e) {
        console.warn('[lead-templates] Falha ao carregar variações:', e);
      }
    })();
    return () => { cancelado = true; };
  }, [lead?.id, lead?.tipo_lead, open]);

  // Dados RF do cache local (fixos após primeira consulta)
  const cnpjLimpo = lead?.cnpj?.replace(/\D/g, '') || '';
  const dadosRFLocal = cnpjLimpo ? dadosRFCache[cnpjLimpo] : null;

  // Consultar Receita Federal apenas se não tiver em cache
  const rfConsultandoRef = useRef(false);

  useEffect(() => {
    if (activeTab === 'contato' && cnpjLimpo && !dadosRFCache[cnpjLimpo] && !rfConsultandoRef.current) {
      rfConsultandoRef.current = true;
      consultarCNPJ(lead.cnpj).then((result) => {
        setDadosRFCache(prev => ({
          ...prev,
          [cnpjLimpo]: result || { failed: true }
        }));
      }).finally(() => {
        rfConsultandoRef.current = false;
      });
    }
  }, [activeTab, cnpjLimpo]);

  // CORREÇÃO: Memoizar linhas atuais para evitar re-criação a cada render
  // Condicional por tipo de lead: RENOVACAO usa dados da fatura, TT usa dados_discadora
  // IMPORTANTE: Fallback robusto para RENOVAÇÃO mesmo sem fatura analisada
  const linhasAtuaisMemo = useMemo(() => {
    const linhas: string[] = [];
    
    // Para leads de PORTABILIDADE_VIVO, priorizar staging_parque_movel (mais atual)
    if (lead?.tipo_lead === 'PORTABILIDADE_VIVO') {
      // 1. Prioridade: staging_parque_movel (dados mais recentes)
      if (parqueMovelVivo && parqueMovelVivo.length > 0) {
        return parqueMovelVivo.map(l => l.nr_telefone).filter(Boolean);
      }
      // 2. Fallback: plantaVivoSnapshot (snapshot salvo no lead)
      if (plantaVivoSnapshot?.linhas_detalhadas?.length > 0) {
        return plantaVivoSnapshot.linhas_detalhadas.map(l => l.telefone).filter(Boolean);
      }
      // 3. Fallback: dados_master_lead.linhas_moveis
      const linhasMoveis = (lead.dados_master_lead as any)?.linhas_moveis;
      if (Array.isArray(linhasMoveis) && linhasMoveis.length > 0) {
        return linhasMoveis.map((l: any) => l.telefone).filter(Boolean);
      }
      return [];
    }
    
    // Para leads de RENOVAÇÃO, prioridade:
    // Para RENOVACAO_CLARO: APENAS dados da fatura analisada ou linhas manuais
    // NUNCA usar campos de contato/administrativos como fallback
    if (lead?.tipo_lead === 'RENOVACAO_CLARO') {
      // 1. Fatura analisada
      if (dadosFatura?.linhasDetalhadas?.length > 0) {
        return dadosFatura.linhasDetalhadas.map((l: any) => l.numero).filter(Boolean);
      }
      // 2. Linhas inseridas manualmente pelo consultor
      if (linhasManuaisRenovacao.length > 0) {
        return linhasManuaisRenovacao.map(l => l.numero).filter(n => n.replace(/\D/g, '').length >= 10);
      }
      // Sem fatura e sem linhas manuais = vazio
      return [];
    }
    
    // Para leads TT, usar dados_discadora (movel_1 até movel_6)
    if (lead?.dados_discadora?.movel_1) linhas.push(lead.dados_discadora.movel_1);
    if (lead?.dados_discadora?.movel_2) linhas.push(lead.dados_discadora.movel_2);
    if (lead?.dados_discadora?.movel_3) linhas.push(lead.dados_discadora.movel_3);
    if (lead?.dados_discadora?.movel_4) linhas.push(lead.dados_discadora.movel_4);
    if (lead?.dados_discadora?.movel_5) linhas.push(lead.dados_discadora.movel_5);
    if (lead?.dados_discadora?.movel_6) linhas.push(lead.dados_discadora.movel_6);
    return linhas;
  }, [
    lead?.tipo_lead,
    lead?.dados_discadora?.movel_1,
    lead?.dados_discadora?.movel_2,
    lead?.dados_discadora?.movel_3,
    lead?.dados_discadora?.movel_4,
    lead?.dados_discadora?.movel_5,
    lead?.dados_discadora?.movel_6,
    lead?.dados_master_lead?.linhas_moveis,
    dadosFatura?.linhasDetalhadas,
    plantaVivoSnapshot?.linhas_detalhadas,
    parqueMovelVivo,
    linhasManuaisRenovacao,
  ]);
  
  // Linhas detalhadas unificadas para Renovação e Portabilidade
  const linhasDetalhadasMemo = useMemo(() => {
    // Para RENOVACAO, usar fatura; fallback para linhas manuais
    if (lead?.tipo_lead === 'RENOVACAO_CLARO') {
      if (dadosFatura?.linhasDetalhadas) return dadosFatura.linhasDetalhadas;
      if (linhasManuaisRenovacao.length > 0) {
        return linhasManuaisRenovacao
          .filter(l => l.numero.replace(/\D/g, '').length >= 10)
          .map(l => ({ numero: l.numero, gbAtual: l.gbAtual, valorAtual: l.valorAtual ?? 0, planoAtual: '' }));
      }
      return undefined;
    }
    
    // Para PORTABILIDADE, priorizar staging_parque_movel (dados mais atuais)
    if (lead?.tipo_lead === 'PORTABILIDADE_VIVO') {
      // 1. Prioridade: staging_parque_movel
      // Linhas agregadas da base (grupos somados) vem SEM telefone — filtrar pra nao quebrar quem formata numero
      if (parqueMovelVivo && parqueMovelVivo.length > 0) {
        return parqueMovelVivo
          .filter(linha => !!linha.nr_telefone)
          .map(linha => ({
            numero: linha.nr_telefone,
            gbAtual: linha.qtd_gb_contratado_dados || 0,
            valorAtual: linha.fat_medio_03_meses || 0,
            planoAtual: linha.plano || '-',
          }));
      }
      // 2. Fallback: plantaVivoSnapshot
      if (plantaVivoSnapshot?.linhas_detalhadas) {
        return plantaVivoSnapshot.linhas_detalhadas.map(linha => ({
          numero: linha.telefone,
          gbAtual: linha.gb,
          valorAtual: linha.valor,
          planoAtual: linha.plano,
        }));
      }
    }
    
    return undefined;
  }, [lead?.tipo_lead, dadosFatura?.linhasDetalhadas, plantaVivoSnapshot?.linhas_detalhadas, parqueMovelVivo, linhasManuaisRenovacao]);
  
  // Quantidade de linhas esperadas (para criar placeholders se não tiver números)
  const qtdLinhasEsperadas = useMemo(() => {
    // Priorizar fatura analisada para RENOVACAO_CLARO
    if (lead?.tipo_lead === 'RENOVACAO_CLARO' && dadosFatura?.linhas) {
      return dadosFatura.linhas;
    }
    // Se já tem linhas detalhadas, usar essa quantidade
    if (linhasAtuaisMemo.length > 0) return linhasAtuaisMemo.length;
    // Senão, usar qtd_linhas_voz do lead ou default 1
    return lead?.qtd_linhas_voz || 1;
  }, [linhasAtuaisMemo.length, lead?.qtd_linhas_voz, lead?.tipo_lead, dadosFatura?.linhas]);

  // CORREÇÃO: Memoizar valor atual parseado para evitar recálculo
  const valorAtualParsed = useMemo(() => {
    return parseNumeroBR(proposta.valor_atual) || 
           lead?.valor_fatura_atual || 
           lead?.dados_discadora?.valor_combo || 
           0;
  }, [proposta.valor_atual, lead?.valor_fatura_atual, lead?.dados_discadora?.valor_combo]);

  // CORREÇÃO: Memoizar planoAtual para evitar re-criação a cada render
  // Condicional por tipo de lead: RENOVACAO usa dados da fatura, TT usa dados_discadora, PORTABILIDADE usa snapshot
  const planoAtualMemo = useMemo(() => {
    if (!lead) return null;
    
    // Para leads PORTABILIDADE_VIVO, usar dados do snapshot
    if (lead.tipo_lead === 'PORTABILIDADE_VIVO') {
      const linhasSnapshot = plantaVivoSnapshot?.linhas_detalhadas?.map(l => l.telefone) || [];
      
      // Calcular dados fixos
      const linhasFixas = parqueFixoVivo?.length || 0;
      const valorFixo = parqueFixoVivo?.reduce((sum, l) => sum + (l.vl_fat_bruto || 0), 0) || 0;
      const internetFixa = parqueFixoVivo?.find(l => l.ds_tipo_produto === 'DADOS');
      const fibraVelocidade = internetFixa ? `${internetFixa.ds_produto || ''}${internetFixa.tecnologia_origem ? ` (${internetFixa.tecnologia_origem})` : ''}`.trim() : undefined;
      const telefonesFixos = parqueFixoVivo
        ?.filter(l => l.designador && /^\d{10,11}$/.test(l.designador))
        ?.map(l => l.designador!)
        ?.filter((v, i, a) => a.indexOf(v) === i) || [];
      
      return {
        linhas: linhasSnapshot,
        qtdLinhas: plantaVivoSnapshot?.total_linhas || parseInt(proposta.linhas_atual) || 0,
        valor: plantaVivoSnapshot?.valor_total || valorAtualParsed,
        tipo: 'MÓVEL' as const,
        dataFatura: undefined,
        gb: plantaVivoSnapshot?.gb_total || (proposta.gb_atual ? parseInt(proposta.gb_atual) : undefined),
        fibra: proposta.fibra_atual || undefined,
        tv: proposta.tv_atual || undefined,
        origem: 'VIVO' as const,
        // Dados fixos
        linhasFixas: linhasFixas > 0 ? linhasFixas : undefined,
        valorFixo: valorFixo > 0 ? valorFixo : undefined,
        fibraVelocidade,
        telefonesFixos: telefonesFixos.length > 0 ? telefonesFixos : undefined,
      };
    }
    
    // Para leads RENOVAÇÃO, usar dados da fatura ou linhas manuais
    if (lead.tipo_lead === 'RENOVACAO_CLARO') {
      const linhasDetComparativo = dadosFatura?.linhasDetalhadas?.map(l => ({
        numero: l.numero,
        gb: l.gbAtual || 0,
      })) || (linhasManuaisRenovacao.length > 0
        ? linhasManuaisRenovacao
            .filter(l => l.numero.replace(/\D/g, '').length >= 10)
            .map(l => ({ numero: l.numero, gb: l.gbAtual }))
        : undefined);
      return {
        linhas: linhasAtuaisMemo,
        linhasDetalhadas: linhasDetComparativo,
        qtdLinhas: parseInt(proposta.linhas_atual) || qtdLinhasEsperadas,
        valor: dadosFatura?.valor || valorAtualParsed,
        tipo: 'MÓVEL' as const,
        dataFatura: undefined,
        gb: dadosFatura?.gb || (proposta.gb_atual ? parseInt(proposta.gb_atual) : undefined),
        fibra: proposta.fibra_atual || undefined,
        tv: proposta.tv_atual || undefined,
        origem: 'CNPJ' as const,
      };
    }
    
    // Para leads TT, manter lógica atual
    return {
      linhas: linhasAtuaisMemo,
      qtdLinhas: parseInt(proposta.linhas_atual) || qtdLinhasEsperadas,
      valor: valorAtualParsed,
      tipo: lead.dados_discadora?.tipo_cliente === 'COMBO' ? 'COMBO' as const : 
            lead.dados_discadora?.tipo_cliente === 'RESIDENCIAL' ? 'RESIDENCIAL' as const : 'MÓVEL' as const,
      dataFatura: lead.dados_discadora?.data_fatura,
      gb: proposta.gb_atual ? parseInt(proposta.gb_atual) : undefined,
      fibra: proposta.fibra_atual || undefined,
      tv: proposta.tv_atual || undefined,
      origem: 'PF' as const, // TT = origem PF
    };
  }, [
    lead,
    lead?.tipo_lead,
    linhasAtuaisMemo,
    valorAtualParsed,
    dadosFatura,
    plantaVivoSnapshot,
    lead?.dados_discadora?.tipo_cliente,
    lead?.dados_discadora?.data_fatura,
    proposta.gb_atual,
    proposta.fibra_atual,
    proposta.tv_atual,
    proposta.linhas_atual,
    qtdLinhasEsperadas,
    parqueFixoVivo,
    linhasManuaisRenovacao,
  ]);

  // CORREÇÃO: Callback estável para onComposicaoChange - SEMPRE atualiza composicaoEditando
  // Simplificado para garantir que mudanças do Montador sempre sejam capturadas
  const handleComposicaoChange = useCallback((comp: ComposicaoProposta) => {
    const anterior = composicaoParaExibirRef.current as ComposicaoProposta | null;
    const linhasAnteriores = new Map((anterior?.linhas || []).map((linha) => [linha.id, linha]));
    // Linha REN que o consultor APAGOU entra em renovacao.linhasExcluidas — é o
    // que impede o reconciliador da fatura de repor a linha (Douglas 29/08:
    // "ela apaga e volta"). Re-digitar o número numa linha nova tira da lista.
    const renovacaoBase = comp.renovacao ?? anterior?.renovacao;
    const numerosAgora = new Set(
      comp.linhas
        .filter((l) => l.tipo === 'RENOVACAO')
        .map((l) => normalizarMsisdn(String(l.numero || '')))
        .filter((n) => n.length >= 10),
    );
    const removidasAgora = (anterior?.linhas || [])
      .filter((l) => l.tipo === 'RENOVACAO')
      .map((l) => normalizarMsisdn(String(l.numero || '')))
      .filter((n) => n.length >= 10 && !numerosAgora.has(n));
    const linhasExcluidas = [...new Set([
      ...(renovacaoBase?.linhasExcluidas || []).filter((n) => !numerosAgora.has(normalizarMsisdn(n))),
      ...removidasAgora,
    ])];
    const renovacaoComExclusoes = (renovacaoBase || linhasExcluidas.length > 0)
      ? { ...(renovacaoBase as NonNullable<typeof renovacaoBase>), linhasExcluidas }
      : renovacaoBase;
    const compNormalizada: ComposicaoProposta = {
      ...comp,
      renovacao: renovacaoComExclusoes,
      linhas: comp.linhas.map((linha) => {
        if (linha.tipo !== 'RENOVACAO') return linha;
        const salva = linhasAnteriores.get(linha.id);
        const planoMudou = Boolean(salva?.planoId && salva.planoId !== linha.planoId);
        const receitaRenovada = planoMudou
          ? linha.plano?.valor ?? 0
          : linha.receitaRenovada ?? salva?.receitaRenovada;
        const receitaAdicionada = planoMudou
          ? 0
          : linha.receitaAdicionada ?? salva?.receitaAdicionada;
        return {
          ...linha,
          planoAtual: linha.planoAtual ?? salva?.planoAtual,
          valorAtual: linha.valorAtual ?? salva?.valorAtual,
          planoNovo: planoMudou ? linha.plano?.nome : linha.planoNovo ?? salva?.planoNovo,
          ticketNovo: planoMudou ? receitaRenovada + receitaAdicionada : linha.ticketNovo ?? salva?.ticketNovo,
          receitaRenovada,
          receitaAdicionada,
        };
      }),
    };
    if (anterior && JSON.stringify(anterior) === JSON.stringify(compNormalizada)) return;
    console.log('📥 [Modal] Recebendo composição do Montador:', compNormalizada.linhas.length, 'linhas, R$', compNormalizada.totalValor.toFixed(2));
    // Marcar que usuário editou — bloqueia re-hidratação ao autosave
    composicaoEditadaManualmenteRef.current = true;
    // SEMPRE atualizar para garantir sincronização - evita perda de dados
    setComposicaoBase(compNormalizada);
    setComposicaoEditando(compNormalizada);
    // Atualizar ref IMEDIATAMENTE (sem esperar render) para que executarSaveImediato sempre leia o valor correto
    composicaoParaExibirRef.current = compNormalizada;
    
    // Atualizar proposta com valores calculados imediatamente.
    // Devolver `prev` quando nada mudou evita um render a cada eco da composição
    // — mesma guarda de handleValoresChange, que já fazia assim.
    setProposta(prev => {
      const linhasNovo = String(compNormalizada.linhas.filter(l => ehLinhaDeVoz(l.tipo)).length);
      const gbNovo = String(compNormalizada.totalGB);
      const valorNovo = String(compNormalizada.totalValor.toFixed(2));
      if (prev.linhas_novo === linhasNovo && prev.gb_novo === gbNovo && prev.valor_novo === valorNovo) return prev;
      return { ...prev, linhas_novo: linhasNovo, gb_novo: gbNovo, valor_novo: valorNovo };
    });
  }, []);

  useEffect(() => {
    if (lead?.tipo_lead !== 'RENOVACAO_CLARO' || !dadosFatura?.linhasDetalhadas?.length) return;
    const atual = (composicaoParaExibirRef.current as ComposicaoProposta | null)
      || composicaoParaExibir;

    // ⛔ RECONCILIA UMA VEZ POR FATURA/CATALOGO, nunca "ate' o predicado fechar".
    // `renovacaoEstaSincronizadaComFatura` exige um numero distinto por linha da
    // fatura; fatura com dois numeros que normalizam igual (ou linha sem numero)
    // deixa o predicado FALSO para sempre e o efeito reconciliava a cada render.
    // A assinatura tambem protege o outro lado: depois de reconciliar, a edicao
    // do consultor nao e' mais desfeita por este efeito.
    //
    // ⚠️ A ASSINATURA E' ARMADA ANTES DA SAIDA POR "JA SINCRONIZADA" (02/09/2026).
    // Num lead que abre ja' batendo com a fatura — o caso normal — o efeito saia
    // aqui e a ref ficava nula a sessao inteira. Bastava o consultor adicionar uma
    // linha "+ Renov" ou corrigir um digito do telefone para o predicado abrir, a
    // trava nao segurar (nunca fora armada) e o reconciliador RECONSTRUIR a lista
    // a partir da fatura: a linha recem-criada sumia e o telefone digitado voltava
    // ao antigo. Armando aqui, a fatura reconcilia uma vez por assinatura e a
    // edicao do consultor deixa de ser desfeita.
    const assinaturaReconciliacao = `${assinaturaFaturaRenovacao(lead.id, dadosFatura.faturaUploadId, dadosFatura.linhasDetalhadas)}|${planosRenovacao.map((plano) => `${plano.id}:${plano.gb}:${plano.valor}`).join(';')}`;
    const jaReconciliada = reconciliacaoFaturaRef.current === assinaturaReconciliacao;
    reconciliacaoFaturaRef.current = assinaturaReconciliacao;
    if (jaReconciliada) return;
    if (renovacaoEstaSincronizadaComFatura(atual, dadosFatura.linhasDetalhadas, atual?.renovacao?.linhasExcluidas)) return;

    const mesCompetencia = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Sao_Paulo',
      year: 'numeric',
      month: '2-digit',
    }).format(new Date());
    const meta: RenovacaoSimulacao = {
      flagForaAreaCabeada: 'NAO_INFORMADO',
      flagBlFixaAtiva: 'NAO_INFORMADO',
      flagConvergenciaAto: 'NAO_INFORMADO',
      pedidoFixaVinculadoId: null,
      mesCompetencia,
      modoAgrupamento: 'POR_LINHA',
      ...atual?.renovacao,
      faturaUploadId: dadosFatura.faturaUploadId || null,
    };
    const reconciliada = reconciliarRenovacaoComFatura(
      atual,
      dadosFatura.linhasDetalhadas,
      planosRenovacao,
      meta,
      carteiraRenovacaoRef.current?.tempo_contrato_voz ?? lead.m_atual ?? lead.tempo_contrato_voz_num ?? Number(String(lead.tempo_contrato_voz || '').replace(/\D/g, '')),
      carteiraRenovacaoRef.current?.classificacao ?? null,
      { sugerirPlano: false },
    );
    if (!reconciliada) return;

    setComposicaoBase(reconciliada);
    setComposicaoEditando(reconciliada);
    composicaoParaExibirRef.current = reconciliada;
    setProposta((prev) => ({
      ...prev,
      linhas_atual: String(dadosFatura.linhas),
      gb_atual: String(dadosFatura.gb),
      valor_atual: dadosFatura.valor.toFixed(2).replace('.', ','),
      linhas_novo: String(reconciliada.linhas.filter((linha) => ehLinhaDeVoz(linha.tipo)).length),
      gb_novo: String(reconciliada.totalGB),
      valor_novo: reconciliada.totalValor.toFixed(2),
    }));
  }, [composicaoParaExibir, dadosFatura, lead?.m_atual, lead?.tempo_contrato_voz, lead?.tempo_contrato_voz_num, lead?.tipo_lead, planosRenovacao]);

  // "Aplicar nas linhas" da Conta atual: a sugestão da fatura só entra quando o
  // vendedor pede (Douglas 02/10/2026). Mesmo cálculo da reconciliação.
  const calcularSugestaoDaFatura = useCallback((): ComposicaoProposta | null => {
    if (!dadosFatura?.linhasDetalhadas?.length) return null;
    const atual = (composicaoParaExibirRef.current as ComposicaoProposta | null) || composicaoParaExibir;
    const mesCompetencia = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Sao_Paulo',
      year: 'numeric',
      month: '2-digit',
    }).format(new Date());
    const meta: RenovacaoSimulacao = {
      flagForaAreaCabeada: 'NAO_INFORMADO',
      flagBlFixaAtiva: 'NAO_INFORMADO',
      flagConvergenciaAto: 'NAO_INFORMADO',
      pedidoFixaVinculadoId: null,
      mesCompetencia,
      modoAgrupamento: 'POR_LINHA',
      ...atual?.renovacao,
      faturaUploadId: dadosFatura.faturaUploadId || null,
    };
    const aplicada = aplicarSugestaoFaturaRenovacao(
      atual,
      dadosFatura.linhasDetalhadas,
      planosRenovacao,
      meta,
      carteiraRenovacaoRef.current?.tempo_contrato_voz ?? lead?.m_atual ?? lead?.tempo_contrato_voz_num ?? Number(String(lead?.tempo_contrato_voz || '').replace(/\D/g, '')),
      carteiraRenovacaoRef.current?.classificacao ?? null,
    );
    return aplicada || null;
  }, [composicaoParaExibir, dadosFatura, lead?.m_atual, lead?.tempo_contrato_voz, lead?.tempo_contrato_voz_num, planosRenovacao]);

  const aplicarSugestaoDaFatura = useCallback(() => {
    const aplicada = calcularSugestaoDaFatura();
    if (!aplicada) return;
    setComposicaoEditando(aplicada);
    composicaoParaExibirRef.current = aplicada;
    setProposta((prev) => ({
      ...prev,
      linhas_novo: String(aplicada.linhas.filter((linha) => ehLinhaDeVoz(linha.tipo)).length),
      gb_novo: String(aplicada.totalGB),
      valor_novo: aplicada.totalValor.toFixed(2),
    }));
  }, [calcularSugestaoDaFatura]);

  // PRÉVIA DE PROPOSTA POR TOP (Douglas 05/10/2026): "Usar esta proposta" monta a
  // composição com os itens da prévia e entrega ao montador, como o "Aplicar
  // sugestão da fatura". Na renovação as linhas saem da MESMA sugestão da fatura;
  // a prévia acrescenta aparelho, Bloco de Dados e fibra.
  const usarPropostaPronta = useCallback((dados: PreviaDoLead) => {
    const { previa, fonte } = dados;
    const faltando: string[] = [];
    const nova = (tipo: LinhaComposicao['tipo'], numero: string, planoId: string | null | undefined, extra: Partial<LinhaComposicao> = {}): LinhaComposicao | null => {
      const plano = planoId ? resolverPlano(planoId, tipo) : undefined;
      if (planoId && !plano) { faltando.push(planoId); return null; }
      return { id: `${tipo.toLowerCase()}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`, linha_id: crypto.randomUUID(),
        numero, tipo, planoId: planoId ?? null, plano, ...extra };
    };
    const telefonesVivo = (plantaVivoSnapshot?.linhas_detalhadas ?? []).map((l) => String(l.telefone || '').replace(/\D/g, ''));
    const numeroCompleto = (n?: string | null) => {
      const d = String(n || '');
      if (!d.startsWith('…')) return d;
      return telefonesVivo.find((t) => t.endsWith(d.slice(1))) ?? '';
    };

    let base: ComposicaoProposta | null = null;
    const linhas: LinhaComposicao[] = [];
    if (fonte === 'RENOVACAO' && previa.itens.some((i) => i.tipo === 'RENOVACAO')) {
      base = calcularSugestaoDaFatura();
      if (base) linhas.push(...base.linhas.filter((l) => l.tipo === 'RENOVACAO'));
    }
    const fixo = previa.itens.some((i) => i.tipo === 'FIXO');
    for (const i of previa.itens) {
      let l: LinhaComposicao | null = null;
      if (i.tipo === 'TT') l = nova('TT', i.numero || '', i.codigo);
      else if (i.tipo === 'LINHA_NOVA') l = nova('LINHA_NOVA', 'Linha Nova', i.codigo);
      else if (i.tipo === 'PORTABILIDADE') l = nova('PORTABILIDADE', numeroCompleto(i.numero), i.codigo);
      else if (i.tipo === 'RENOVACAO' && !base) l = nova('RENOVACAO', i.numero || 'Renovação', i.codigo,
        { gbAtual: i.gb_atual ?? undefined, valorAtual: i.valor_atual ?? undefined, planoAtual: i.plano_atual ?? undefined });
      else if (i.tipo === 'BLOCO') l = nova('NOVA', 'Bloco de Dados', i.codigo, { tipoBloco: fonte === 'RENOVACAO' ? 'INCREMENTO' : 'NOVO' });
      else if (i.tipo === 'FIBRA') l = nova('FIBRA', 'Fibra', i.codigo, { tipoFibra: 'CNPJ', ...(fixo && { adicionais: { 'fibra-claro-fixo': 1 } }) });
      if (l) linhas.push(l);
    }
    // O aparelho vai na linha de MAIOR plano da renovação (é o que dá o maior desconto).
    const aparelho = previa.itens.find((i) => i.tipo === 'APARELHO');
    if (aparelho) {
      const alvo = [...linhas].filter((l) => l.tipo === 'RENOVACAO').sort((a, b) => (b.plano?.gb ?? 0) - (a.plano?.gb ?? 0))[0];
      if (alvo) alvo.aparelho = { slug: String(aparelho.codigo), nome: aparelho.descricao.replace(/^Aparelho /, '').split(' · ')[0],
        forma: '24x', preco: Number(aparelho.preco_total ?? 0), parcela: aparelho.valor, grupoUsado: 'RENOVACAO', faixaGb: aparelho.gb ?? null };
    }
    if (!linhas.length) {
      toast.error('Não deu para montar esta proposta', { description: 'Monte no montador abaixo.' });
      return;
    }
    const temFibra = linhas.some((l) => l.tipo === 'FIBRA');
    const totalValor = calcularTotalValor(linhas);
    const valorAtualRef = Number(valorAtualParsed || 0);
    const comp: ComposicaoProposta = {
      ...(base ?? {}),
      linhas,
      incluiFibra: temFibra,
      planoFibra: linhas.find((l) => l.tipo === 'FIBRA')?.plano,
      totalGB: calcularTotalGB(linhas, temFibra),
      totalValor,
      economiaValor: valorAtualRef - totalValor,
      economiaPercent: valorAtualRef > 0 ? ((valorAtualRef - totalValor) / valorAtualRef) * 100 : 0,
    };
    setComposicaoEditando(comp);
    composicaoParaExibirRef.current = comp;
    setProposta((prev) => ({
      ...prev,
      linhas_novo: String(comp.linhas.filter((linha) => ehLinhaDeVoz(linha.tipo)).length),
      gb_novo: String(comp.totalGB),
      valor_novo: comp.totalValor.toFixed(2),
    }));
    toast.success('Proposta do TOP no montador', {
      description: faltando.length ? `Confira e salve. Sem preço no catálogo: ${faltando.join(', ')}.` : 'Confira as linhas e salve.',
    });
  }, [calcularSugestaoDaFatura, plantaVivoSnapshot, resolverPlano, valorAtualParsed]);

  // Callback para Montador 2 (Plano Novo 2 — Renovação com Incremento)
  const handleComposicaoChange2 = useCallback((comp: ComposicaoProposta) => {
    setComposicaoEditando2({ ...comp, tipoProposta: 'RENOVACAO_INCREMENTO' });
  }, []);

  // Campo do "Plano atual" vindo dos painéis por tipo de lead (TT, Portabilidade,
  // Renovação). Precisa ser ESTÁVEL e precisa devolver `prev` quando o valor não
  // mudou: os painéis preenchem esses campos DENTRO de efeitos, e um callback
  // novo a cada render (era uma arrow inline) fazia o efeito rodar de novo a cada
  // render; como o setProposta criava objeto novo mesmo escrevendo o MESMO valor,
  // render e efeito se alimentavam — a tela tremia e, no limite, quebrava com
  // "Maximum update depth". Vale para todo tipo de lead. (Douglas 01/09/2026)
  const handlePropostaChange = useCallback((field: string, value: string) => {
    setProposta(prev => (
      (prev as Record<string, unknown>)[field] === value ? prev : { ...prev, [field]: value }
    ));
  }, []);
  const handleToggleOcultarPlanoAtual = useCallback(() => {
    setProposta(prev => ({ ...prev, ocultar_plano_atual: !prev.ocultar_plano_atual }));
  }, []);
  const handleToggleOcultarPlanoFixo = useCallback(() => {
    setProposta(prev => ({ ...prev, ocultar_plano_fixo: !prev.ocultar_plano_fixo }));
  }, []);

  // CORREÇÃO: Callback estável para onValoresChange
  const handleValoresChange = useCallback((valores: { linhas: number; gb: number; valor: number }) => {
    setProposta(prev => {
      const newLinhas = String(valores.linhas);
      const newGb = String(valores.gb);
      const newValor = String(valores.valor.toFixed(2));
      // Só atualiza se realmente mudou
      if (prev.linhas_novo === newLinhas && prev.gb_novo === newGb && prev.valor_novo === newValor) {
        return prev;
      }
      return {
        ...prev,
        linhas_novo: newLinhas,
        gb_novo: newGb,
        valor_novo: newValor,
      };
    });
  }, []);

  // CORREÇÃO: Callback estável para seleção de cenário - Atualiza AMBOS
  // composicaoBase (para Montador receber) e composicaoEditando (para exibição)
  const handleSelecionarCenario = useCallback((composicao: ComposicaoProposta) => {
    // Atualizar base (Montador vai sincronizar com isso)
    setComposicaoBase(composicao);
    // Atualizar editando (para exibição imediata)
    setComposicaoEditando(composicao);
    
    setCenarioSelecionadoId(prev => {
      if (prev === 'economia') return undefined;
      if (composicao.linhas.some(l => l.tipo === 'NOVA')) return 'upgrade';
      if (composicao.linhas[0]?.plano?.gb === 11) return 'economia';
      return 'equilibrado';
    });
    setProposta(prev => ({
      ...prev,
      linhas_novo: String(composicao.linhas.filter(l => ehLinhaDeVoz(l.tipo)).length),
      gb_novo: String(composicao.totalGB),
      valor_novo: String(composicao.totalValor.toFixed(2)),
    }));
  }, []);

  // CORREÇÃO: Memoizar cálculos de economia para evitar recálculo a cada render
  // DEVE estar ANTES do return null para garantir ordem de hooks consistente
  const economiaCalculada = useMemo(() => {
    const atual = parseNumeroBR(proposta.valor_atual);
    const novo = parseNumeroBR(proposta.valor_novo);
    const economia = atual - novo;
    const economiaPercent = atual > 0 ? ((atual - novo) / atual) * 100 : 0;
    return { economia, economiaPercent };
  }, [proposta.valor_atual, proposta.valor_novo]);

  // As variáveis das apresentações CPF — as mesmas que o backend usa para os
  // modelos da Meta (services/venda-ia-cpf/apresentacoes-cpf.ts).
  const varsApresentacaoCpf = useMemo(() => {
    const d = ((lead?.dados_master_lead as Record<string, unknown> | null) ?? {});
    const brl = (v: unknown) => {
      const n = Number(v);
      return Number.isFinite(n) && n > 0 ? formatarMoeda(n) : '';
    };
    const titulo = (t: unknown) => String(t ?? '').toLowerCase().replace(/(?:^|\s)\S/g, (m) => m.toUpperCase()).trim();
    return {
      qtd_linhas: Number(lead?.qtd_linhas_voz) > 0 ? String(lead?.qtd_linhas_voz) : '',
      valor_fatura: brl(lead?.valor_fatura_atual),
      empresa_origem: titulo(d.razao_social_origem),
      valor_pedido: brl(d.valor_no_cnpj),
      etapa_parada: String(d.etapa_parada ?? ''),
    } as Record<string, string>;
  }, [lead?.dados_master_lead, lead?.qtd_linhas_voz, lead?.valor_fatura_atual]);

  // NOVO: Regenerar mensagens de RETORNO e FECHAMENTO quando composição muda
  // As mensagens são dinâmicas e refletem EXATAMENTE o que está na proposta
  useEffect(() => {
    // Só regenerar se:
    // 1. Composição existe e tem linhas
    // 2. Já foi hidratado (evita sobrescrever durante carregamento)
    // 3. Não está no processo de hidratação
    if (!composicaoParaExibir || composicaoParaExibir.linhas.length === 0) return;
    if (!hidratadoRef.current || hidratandoRef.current) return;
    
    const params = {
      nomeCliente: contato.nome || lead?.nome_fantasia || '',
      razaoSocial: lead?.razao_social || '',
      consultorNome: nomeConsultorProposta || user?.user_metadata?.nome || 'Consultor',
      valorAtual: parseNumeroBR(proposta.valor_atual),
      composicaoNova: lead?.tipo_pessoa === 'PF' ? { ...composicaoParaExibir, tipoPessoa: 'PF' as const } : composicaoParaExibir,
      tipoLead: lead?.tipo_lead || '',
      clienteCpf: clienteCpfDoLead(lead, contato.telefone, contato.email),
    };
    
    const novaMsgRetorno = gerarMensagemRetornoCompleta(params);
    const novaMsgFechamento = gerarMensagemFechamentoCompleta(params);
    
    setProposta(prev => ({
      ...prev,
      mensagem_retorno: novaMsgRetorno,
      mensagem_fechamento: novaMsgFechamento,
    }));
  }, [
    composicaoParaExibir,
    contato.nome,
    lead?.nome_fantasia,
    lead?.razao_social,
    lead?.tipo_lead,
    proposta.valor_atual,
    nomeConsultorProposta,
    user?.user_metadata?.nome,
  ]);

  // CORREÇÃO: Memoizar contagem de linhas para evitar IIFE no render
  const qtdLinhasAtuais = useMemo(() => {
    let count = 0;
    if (lead?.dados_discadora?.movel_1) count++;
    if (lead?.dados_discadora?.movel_2) count++;
    if (lead?.dados_discadora?.movel_3) count++;
    return count;
  }, [lead?.dados_discadora?.movel_1, lead?.dados_discadora?.movel_2, lead?.dados_discadora?.movel_3]);

  // CORREÇÃO: Memoizar Fibra e TV do plano novo a partir da composição
  const planoNovoInfo = useMemo(() => {
    if (!composicaoParaExibir) return { fibra: '-', tv: '-' };
    
    const linhaFibra = composicaoParaExibir.linhas.find(l => l.tipo === 'FIBRA');
    const linhaTV = composicaoParaExibir.linhas.find(l => l.tipo === 'TV');
    
    return {
      fibra: linhaFibra?.plano?.velocidade || linhaFibra?.plano?.nome || '-',
      tv: linhaTV?.plano?.nome || '-'
    };
  }, [composicaoParaExibir]);

  // Frases de benefício escritas em Configurações > Produtos, dos produtos que
  // estão nesta composição (Douglas 06/08).
  const beneficiosDosProdutos = useBeneficiosDaComposicao(composicaoParaExibir);
  const apresentacaoProposta = {
    planoAtual: { qtdLinhas: parseInt(proposta.linhas_atual) || qtdLinhasAtuais, gb: planoAtualMemo?.gb,
      fibra: planoAtualMemo?.fibra, tv: planoAtualMemo?.tv, valor: planoAtualMemo?.valor ?? 0 },
    apresentacao: { ocultarPlanoAtual: proposta.ocultar_plano_atual, beneficiosDosProdutos },
  };
  const apresentacaoPropostaRef = useRef(apresentacaoProposta);
  apresentacaoPropostaRef.current = apresentacaoProposta;
  const previaTopQuery = usePreviaPropostaLead(lead?.tipo_pessoa === 'PF' ? null : lead?.id, activeTab === 'proposta');

  // ── PROPOSTA E-MAIL: o que vai é o que se vê (Douglas 05/10/2026) ─────────
  // Os dados da proposta que montam o e-mail — os MESMOS na prévia e no envio.
  // A proposta montada vence a prévia do TOP (Douglas 24/10/2026): o TOP só
  // monta o e-mail quando o consultor não montou proposta.
  const dadosEmailMontada = useMemo((): DadosEmailProposta | null => {
    if (!lead?.id || !composicaoParaExibir || composicaoParaExibir.linhas.length === 0) return null;
    const linhasMoveis = composicaoParaExibir.linhas.filter((l) => ehLinhaDeVoz(l.tipo));
    const linhaFibra = composicaoParaExibir.linhas.find((l) => l.tipo === 'FIBRA');
    const linhaTv = composicaoParaExibir.linhas.find((l) => l.tipo === 'TV');
    const comparativo = [
      { rotulo: 'Operações', atual: null, novo: operacoesDaProposta(composicaoParaExibir).join(' · ') },
      { rotulo: 'Blocos de dados', atual: null, novo: composicaoParaExibir.linhas.some((l) => l.tipo === 'NOVA') ? String(composicaoParaExibir.linhas.filter((l) => l.tipo === 'NOVA').length) : null },
      { rotulo: 'Linhas móveis', atual: String(parseInt(proposta.linhas_atual) || qtdLinhasAtuais || 0), novo: linhasMoveis.length ? String(linhasMoveis.length) : null },
      { rotulo: 'Internet móvel', atual: planoAtualMemo?.gb ? `${planoAtualMemo.gb} GB` : null, novo: composicaoParaExibir.totalGB > 0 ? `${composicaoParaExibir.totalGB + megabonusDaProposta(composicaoParaExibir)} GB` : null },
      { rotulo: 'Fibra', atual: planoAtualMemo?.fibra || null, novo: linhaFibra?.plano?.velocidade || linhaFibra?.plano?.nome || null },
      { rotulo: 'TV', atual: planoAtualMemo?.tv || null, novo: linhaTv?.plano?.nome || null },
    ].filter((l) => l.atual || l.novo);
    const servicosPorOpcao = new Map<string, { nome: string; licencas: number; valorUnitario: number; linhaVinculada?: string | null }>();
    for (const l of composicaoParaExibir.linhas) {
      if (l.tipo !== 'SERVICO' || !l.plano) continue;
      const chave = `${l.categoriaCustom ?? ''}::${l.planoId ?? l.plano.nome}`;
      const atual = servicosPorOpcao.get(chave);
      const licencas = Math.max(1, Math.floor(Number(l.quantidade) || 1));
      if (atual) atual.licencas += licencas;
      else servicosPorOpcao.set(chave, { nome: l.plano.nome, licencas, valorUnitario: l.plano.valor, linhaVinculada: l.linhaVinculada || null });
    }
    return {
      lead_id: lead.id,
      razao_social: lead.razao_social,
      contato_nome: contato.nome || lead.contato_real_nome || undefined,
      comparativo,
      valor_atual: planoAtualMemo?.valor ?? 0,
      valor_novo: composicaoParaExibir.totalValor,
      servicos: Array.from(servicosPorOpcao.values()),
      beneficios: beneficiosDosProdutos,
    };
  }, [lead?.id, lead?.razao_social, lead?.contato_real_nome, contato.nome, composicaoParaExibir, planoAtualMemo, proposta.linhas_atual, qtdLinhasAtuais, beneficiosDosProdutos]);
  const emailDoTop = !!previaTopQuery.data && !(dadosEmailMontada && temPropostaMontada(dadosEmailMontada));
  const dadosEmailProposta = useMemo((): DadosEmailProposta | null => {
    if (lead?.id && emailDoTop) {
      return {
        lead_id: lead.id,
        razao_social: lead.razao_social,
        contato_nome: contato.nome || lead.contato_real_nome || undefined,
        comparativo: [],
        valor_atual: 0,
        valor_novo: 0,
        servicos: [],
        beneficios: [],
      };
    }
    return dadosEmailMontada;
  }, [emailDoTop, dadosEmailMontada, lead?.id, lead?.razao_social, lead?.contato_real_nome, contato.nome]);

  const emailAtivo = activeTab === 'proposta' && tipoMensagemAtivo === 'proposta_email';
  const comImagemEmail = !emailDoTop && !!planoAtualMemo;
  const previaEmailQuery = useQuery({
    queryKey: ['previa-proposta-email', dadosEmailProposta, comImagemEmail, emailDoTop ? modeloEmail : null],
    enabled: emailAtivo && !!dadosEmailProposta,
    staleTime: 60_000,
    placeholderData: keepPreviousData,
    queryFn: () => buscarPreviaPropostaEmail({ ...(dadosEmailProposta as DadosEmailProposta), com_imagem: comImagemEmail, modelo: modeloEmail }),
  });
  const previaEmail = previaEmailQuery.data;
  const metodoEmailAtual: MetodoEnvioEmail = metodoEmail ?? (previaEmail?.smtp.disponivel ? 'smtp' : 'sendgrid');
  const assuntoEmailAtual = assuntoEmail ?? previaEmail?.assunto_padrao ?? '';
  const aberturaEmailAtual = aberturaEmail ?? previaEmail?.abertura_padrao ?? '';
  const fechamentoEmailAtual = fechamentoEmail ?? previaEmail?.fechamento_padrao ?? '';
  // Texto pronto mudou (ex.: o nome do contato) e ninguém escreveu por cima:
  // a prévia é remontada para mostrar o texto novo.
  const editouTextoEmail = aberturaEmail !== null || fechamentoEmail !== null;
  useEffect(() => {
    if (!editouTextoEmail) setVersaoTextoEmail((v) => v + 1);
  }, [previaEmail?.abertura_padrao, previaEmail?.fechamento_padrao, editouTextoEmail]);

  // A imagem da prévia é a MESMA arte do Proposta Imagem, gerada do card ao
  // lado. Só é refeita quando a proposta muda, nunca a cada render.
  const chaveImagemEmail = useMemo(() => JSON.stringify([
    composicaoParaExibir?.totalValor,
    composicaoParaExibir?.linhas.map((l) => [l.tipo, l.planoId, l.numero, l.plano?.valor, l.quantidade, l.adicionais]),
    planoAtualMemo?.valor, planoAtualMemo?.gb, proposta.ocultar_plano_atual, proposta.ocultar_plano_fixo,
  ]), [composicaoParaExibir, planoAtualMemo, proposta.ocultar_plano_atual, proposta.ocultar_plano_fixo]);
  useEffect(() => {
    if (!emailAtivo || !comImagemEmail) return;
    let cancelado = false;
    const t = setTimeout(async () => {
      try {
        const blob = await comparativoRef.current?.gerarImagemBlob();
        if (!blob || cancelado) return;
        const url = URL.createObjectURL(blob);
        if (imagemPreviaEmailRef.current) URL.revokeObjectURL(imagemPreviaEmailRef.current);
        imagemPreviaEmailRef.current = url;
        setImagemPreviaEmail(url);
      } catch (e) {
        console.warn('[proposta-email] imagem da prévia não gerada', e);
      }
    }, 700);
    return () => { cancelado = true; clearTimeout(t); };
  }, [emailAtivo, comImagemEmail, chaveImagemEmail]);
  useEffect(() => () => {
    if (imagemPreviaEmailRef.current) URL.revokeObjectURL(imagemPreviaEmailRef.current);
  }, []);

  // Valor ou GB escrito no texto que a proposta não tem: aviso, nunca trava.
  const avisoTextoEmail = useMemo(() => {
    if (emailDoTop || !composicaoParaExibir) return null;
    const valoresLinhas = composicaoParaExibir.linhas.flatMap((l) => {
      const v = Number(l.plano?.valor) || 0;
      const q = Math.max(1, Number(l.quantidade) || 1);
      return [v, v * q, Number(l.plano?.valorAposPromocao) || 0];
    });
    const atual = planoAtualMemo?.valor ?? 0;
    const novo = composicaoParaExibir.totalValor;
    return avisoValoresDoTexto(`${assuntoEmailAtual}\n${aberturaEmailAtual}\n${fechamentoEmailAtual}`, {
      valorNovo: novo,
      valores: [novo, atual, Math.abs(novo - atual), ...valoresLinhas],
      gbNovo: composicaoParaExibir.totalGB,
      gbs: [
        composicaoParaExibir.totalGB,
        composicaoParaExibir.totalGB + megabonusDaProposta(composicaoParaExibir),
        Number(planoAtualMemo?.gb) || 0,
        ...composicaoParaExibir.linhas.map((l) => Number(l.plano?.gb) || 0),
      ],
    });
  }, [emailDoTop, composicaoParaExibir, planoAtualMemo, assuntoEmailAtual, aberturaEmailAtual, fechamentoEmailAtual]);

  const trocarModeloEmail = (novo: ModeloEmailProposta) => {
    if (novo === modeloEmail) return;
    textosPorModeloEmail.current[modeloEmail] = { assunto: assuntoEmail, abertura: aberturaEmail, fechamento: fechamentoEmail };
    const guardado = textosPorModeloEmail.current[novo];
    setAssuntoEmail(guardado?.assunto ?? null);
    setAberturaEmail(guardado?.abertura ?? null);
    setFechamentoEmail(guardado?.fechamento ?? null);
    setModeloEmail(novo);
    setVersaoTextoEmail((v) => v + 1);
  };

  // 67/Proposta — COMISSÃO ESTIMADA do resumo: a régua real da renovação
  // (mesmas queries do montador; a queryKey compartilhada reusa o cache).
  // Só existe régua para linhas RENOVACAO — os demais tipos mostram '—'.
  const linhasRenResumo = (composicaoParaExibir?.linhas || []).filter((l) => l.tipo === 'RENOVACAO');
  const mesAtualComissao = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit' });
  const { data: paramsRenResumo } = useRenovacaoParametros(linhasRenResumo.length > 0 ? mesAtualComissao : '');
  const { data: matrizRenResumo } = useQuery({
    queryKey: ['renovacao-matriz-consultor-lead'],
    staleTime: 5 * 60_000,
    enabled: linhasRenResumo.length > 0,
    queryFn: async () => {
      const { data: rules, error } = await supabase
        .from('commission_rules')
        .select('id, faixa_faturamento, competencia')
        .eq('cargo', 'CONSULTOR')
        .eq('ativo', true)
        .is('usuario_id', null)
        .order('competencia', { ascending: false });
      if (error) throw error;
      const porFaixa = new Map<number, { id: string; faixa_faturamento: number }>();
      for (const r of (rules || []) as Array<{ id: string; faixa_faturamento: number }>) {
        if (!porFaixa.has(r.faixa_faturamento)) porFaixa.set(r.faixa_faturamento, r);
      }
      const vigentes = [...porFaixa.values()].sort((a, b) => a.faixa_faturamento - b.faixa_faturamento);
      const ids = vigentes.map((r) => r.id);
      if (ids.length === 0) return { faixasFat: [] as number[], pct: new Map<string, number>() };
      const { data: celulas, error: e2 } = await supabase
        .from('commission_rule_renovacao_delta' as never)
        .select('commission_rule_id, faixa_delta, percentual')
        .in('commission_rule_id', ids);
      if (e2) throw e2;
      const pct = new Map<string, number>();
      for (const c of (celulas || []) as Array<{ commission_rule_id: string; faixa_delta: number; percentual: number }>) {
        const rule = vigentes.find((r) => r.id === c.commission_rule_id);
        if (rule) pct.set(`${rule.faixa_faturamento}:${c.faixa_delta}`, Number(c.percentual));
      }
      return { faixasFat: vigentes.map((r) => r.faixa_faturamento), pct };
    },
  });
  const comissaoEstimadaResumo = useMemo(() => {
    if (linhasRenResumo.length === 0 || !paramsRenResumo || !matrizRenResumo) return null;
    let total = 0;
    let n = 0;
    for (const linha of linhasRenResumo) {
      const valorAtualLinha = Number(linha.valorAtual || 0);
      const receitaInformada = Number(linha.receitaRenovada || 0);
      const valorNovo = receitaInformada > 0 ? receitaInformada : Number(linha.plano?.valor || 0);
      if (!(valorNovo > 0)) continue;
      const deltas = deltasDaRenovacao(valorAtualLinha, valorNovo);
      const delta = paramsRenResumo.deltaFormulaSign === 'LITERAL_REGULAMENTO' ? deltas.literal : deltas.economico;
      if (delta == null) continue;
      const faixa = (paramsRenResumo.faixas || []).filter((f: RenovacaoFaixaParametro) => Number(f.tabela) === 1).find((f: RenovacaoFaixaParametro) =>
        (f.delta_min === null || delta >= Number(f.delta_min))
        && (f.delta_max === null || delta <= Number(f.delta_max)),
      )?.faixa ?? null;
      if (!faixa) continue;
      const pct = matrizRenResumo.pct.get(`1000:${faixa}`);
      if (pct == null) continue;
      total += (valorNovo * pct) / 100;
      n += 1;
    }
    return n > 0 ? { total, linhas: n } : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [composicaoParaExibir, paramsRenResumo, matrizRenResumo]);

  // Gerar mensagem completa de proposta quando há composição válida
  const mensagemPropostaGerada = useMemo(() => {
    if (!composicaoParaExibir || !planoAtualMemo || composicaoParaExibir.linhas.length === 0) {
      // §7 — a prévia deriva do que EXISTE: com parque medido e sem itens
      // montados, gera a variante "hoje você paga X pelas N linhas" em vez
      // do aviso. O aviso fica só quando não há dado nenhum.
      const valorAtualDerivado = Number(valorAtualParsed || 0);
      const qtdDerivada = parseInt(proposta.linhas_atual) || qtdLinhasAtuais || 0;
      if (valorAtualDerivado > 0 && qtdDerivada > 0) {
        return lead?.tipo_pessoa === 'PF'
          ? `⚠️ Monte a proposta no comparativo para gerar a mensagem.\n\nNo CPF a proposta é o comparativo "Hoje você tem" × "Proposta", linha por linha. O valor da base (R$ ${valorAtualDerivado.toFixed(2).replace('.', ',')}) não é a conta do cliente.`
          : `Olá! Sou *${nomeConsultorProposta || 'Consultor'}*, da *Empresarial Prime – Claro Empresas*.\n\nFiz um levantamento para *${lead?.razao_social || 'sua empresa'}*: hoje você paga *R$ ${valorAtualDerivado.toFixed(2).replace('.', ',')}/mês* pelas ${qtdDerivada} linha(s).\n\nPosso te mostrar quanto esse pacote fica na Claro Empresas?`;
      }
      return null;
    }
    
    return gerarMensagemPropostaCompleta({
      nomeCliente: lead?.nome_fantasia || lead?.razao_social,
      razaoSocial: lead?.razao_social,
      origemLabel: planoAtualMemo.origem || 'PF',
      planoAtual: {
        linhas: planoAtualMemo.linhas,
        qtdLinhas: parseInt(proposta.linhas_atual) || qtdLinhasAtuais,
        gb: planoAtualMemo.gb,
        fibra: planoAtualMemo.fibra,
        tv: planoAtualMemo.tv,
        valor: planoAtualMemo.valor,
      },
      composicaoNova: lead?.tipo_pessoa === 'PF' ? { ...composicaoParaExibir, tipoPessoa: 'PF' as const } : composicaoParaExibir,
      consultorNome: nomeConsultorProposta,
      ocultarPlanoAtual: proposta.ocultar_plano_atual,
      beneficiosDosProdutos,
    });
  }, [composicaoParaExibir, planoAtualMemo, lead?.razao_social, lead?.nome_fantasia, nomeConsultorProposta, proposta.linhas_atual, qtdLinhasAtuais, proposta.ocultar_plano_atual, beneficiosDosProdutos, valorAtualParsed]);

  // CORREÇÃO: Getter memoizado para mensagem ativa
  const mensagemAtiva = useMemo(() => {
    return textoDoTipoMensagem(proposta, tipoMensagemAtivo);
  }, [tipoMensagemAtivo, proposta]);

  // CORREÇÃO: Usar useDeferredValue para o preview (evita travar digitação)
  const mensagemDeferida = useDeferredValue(mensagemAtiva);

  // Para tipo PROPOSTA: usar APENAS mensagem gerada do comparativo
  // Para APRESENTACAO, RETORNO e FECHAMENTO: usar template com variáveis
  const previewMensagem = useMemo(() => {
    // PROPOSTA TEXTO: usar exclusivamente a mensagem gerada
    if (tipoMensagemAtivo === 'proposta') {
      if (mensagemPropostaGerada) {
        return mensagemPropostaGerada;
      }
      // Sem composição válida: mostrar orientação
      return '⚠️ Monte a proposta no comparativo para gerar a mensagem.\n\nUse o Montador de Proposta para adicionar linhas, e a mensagem será gerada automaticamente baseada no comparativo.';
    }

    // 🆕 PROPOSTA IMAGEM: preview indicativo. Cliente vai receber a IMAGEM do card visual
    // (mesmo que aparece aqui acima na aba Proposta) + legenda curta.
    if (tipoMensagemAtivo === 'proposta_imagem') {
      return `Vai a IMAGEM da proposta (igual está acima), com o texto da proposta na legenda:\n\n${mensagemPropostaGerada || 'Monte a proposta no comparativo antes de enviar.'}`;
    }
    
    // APRESENTAÇÃO, RETORNO e FECHAMENTO: usar template com variáveis
    const { economia, economiaPercent } = economiaCalculada;
    
    return mensagemDeferida
      .replace(/{consultor_nome}/g, nomeConsultorProposta || 'Consultor')
      .replace(/{consultor_email}/g, profile?.email || user?.email || '')
      .replace(/{razao_social}/g, lead?.razao_social || '')
      .replace(/{cnpj}/g, formatarCNPJ(lead?.cnpj) || '')
      .replace(/{uf}/g, lead?.uf || '')
      .replace(/{(qtd_linhas|valor_fatura|empresa_origem|valor_pedido|etapa_parada)}/g, (m, k: string) => varsApresentacaoCpf[k] || m)
      .replace(/{primeiro_nome}/g, primeiroNomeDoCliente(contato.nome || (lead?.tipo_pessoa === 'PF' ? lead?.razao_social : '')) || 'Cliente')
      .replace(/{contato_nome}/g, contato.nome || 'Cliente')
      .replace(/{contato_telefone}/g, contato.telefone || '')
      .replace(/{contato_email}/g, contato.email || '')
      .replace(/{contato_cargo}/g, contato.cargo || '')
      .replace(/{linhas_atual}/g, proposta.linhas_atual || '-')
      .replace(/{gb_atual}/g, proposta.gb_atual || '-')
      .replace(/{valor_atual}/g, proposta.valor_atual ? formatarMoeda(parseNumeroBR(proposta.valor_atual)) : '-')
      .replace(/{fibra_atual}/g, proposta.fibra_atual || '-')
      .replace(/{tv_atual}/g, proposta.tv_atual || '-')
      .replace(/{linhas_novo}/g, proposta.linhas_novo || '-')
      .replace(/{gb_novo}/g, proposta.gb_novo || '-')
      .replace(/{valor_novo}/g, proposta.valor_novo ? formatarMoeda(parseNumeroBR(proposta.valor_novo)) : '-')
      .replace(/{fibra_novo}/g, planoNovoInfo.fibra)
      .replace(/{tv_novo}/g, planoNovoInfo.tv)
      .replace(/{economia}/g, economia > 0 ? formatarMoeda(economia) : '-')
      .replace(/{economia_percent}/g, economiaPercent > 0 ? `${economiaPercent.toFixed(0)}%` : '-');
  }, [tipoMensagemAtivo, mensagemPropostaGerada, mensagemDeferida, economiaCalculada, nomeConsultorProposta, profile, user, lead, contato, varsApresentacaoCpf, proposta.linhas_atual, proposta.gb_atual, proposta.valor_atual, proposta.fibra_atual, proposta.tv_atual, proposta.linhas_novo, proposta.gb_novo, proposta.valor_novo, planoNovoInfo]);

  // Versão síncrona para envio
  // PROPOSTA: usa mensagem gerada OU bloqueia (retorna vazio)
  // APRESENTACAO/RETORNO/FECHAMENTO: substitui variáveis
  const substituirVariaveis = useCallback((texto: string, tipo?: TipoMensagemLead) => {
    const tipoAtual = tipo || tipoMensagemAtivo;
    
    // PROPOSTA: usar exclusivamente mensagem gerada
    if (tipoAtual === 'proposta') {
      // Se tem mensagem gerada, usa ela
      if (mensagemPropostaGerada) {
        return mensagemPropostaGerada;
      }
      // Bloquear envio se não tem proposta montada
      return '';
    }
    
    // APRESENTAÇÃO, RETORNO e FECHAMENTO: substituir variáveis normalmente
    const { economia, economiaPercent } = economiaCalculada;
    
    // BKO/Qualidade/Gestores usam nome do consultor do lead, não o próprio
    const nomeConsultorParaMensagem = nomeConsultorProposta || 'Consultor';
    
    return texto
      .replace(/{consultor_nome}/g, nomeConsultorParaMensagem)
      .replace(/{consultor_email}/g, profile?.email || user?.email || '')
      .replace(/{razao_social}/g, lead?.razao_social || '')
      .replace(/{cnpj}/g, formatarCNPJ(lead?.cnpj) || '')
      .replace(/{uf}/g, lead?.uf || '')
      .replace(/{(qtd_linhas|valor_fatura|empresa_origem|valor_pedido|etapa_parada)}/g, (m, k: string) => varsApresentacaoCpf[k] || m)
      .replace(/{primeiro_nome}/g, primeiroNomeDoCliente(contato.nome || (lead?.tipo_pessoa === 'PF' ? lead?.razao_social : '')) || 'Cliente')
      .replace(/{contato_nome}/g, contato.nome || 'Cliente')
      .replace(/{contato_telefone}/g, contato.telefone || '')
      .replace(/{contato_email}/g, contato.email || '')
      .replace(/{contato_cargo}/g, contato.cargo || '')
      .replace(/{linhas_atual}/g, proposta.linhas_atual || '-')
      .replace(/{gb_atual}/g, proposta.gb_atual || '-')
      .replace(/{valor_atual}/g, proposta.valor_atual ? formatarMoeda(parseNumeroBR(proposta.valor_atual)) : '-')
      .replace(/{fibra_atual}/g, proposta.fibra_atual || '-')
      .replace(/{tv_atual}/g, proposta.tv_atual || '-')
      .replace(/{linhas_novo}/g, proposta.linhas_novo || '-')
      .replace(/{gb_novo}/g, proposta.gb_novo || '-')
      .replace(/{valor_novo}/g, proposta.valor_novo ? formatarMoeda(parseNumeroBR(proposta.valor_novo)) : '-')
      .replace(/{fibra_novo}/g, planoNovoInfo.fibra)
      .replace(/{tv_novo}/g, planoNovoInfo.tv)
      .replace(/{economia}/g, economia > 0 ? formatarMoeda(economia) : '-')
      .replace(/{economia_percent}/g, economiaPercent > 0 ? `${economiaPercent.toFixed(0)}%` : '-');
  }, [tipoMensagemAtivo, mensagemPropostaGerada, economiaCalculada, nomeConsultorProposta, profile, user, lead, contato, varsApresentacaoCpf, proposta.linhas_atual, proposta.gb_atual, proposta.valor_atual, proposta.fibra_atual, proposta.tv_atual, proposta.linhas_novo, proposta.gb_novo, proposta.valor_novo, planoNovoInfo]);

  // Sincronizar refs SINCRONAMENTE no corpo do componente (não via useEffect)
  // Isso garante que os refs sempre refletem o valor atual no momento de qualquer callback
  composicaoParaExibirRef.current = composicaoParaExibir;
  composicaoParaExibir2Ref.current = composicaoParaExibir2;
  propostaRef.current = proposta;

  // CORREÇÃO: Setter estável para mensagem ativa
  const setMensagemAtiva = useCallback((newText: string) => {
    setProposta(prev => {
      if (tipoMensagemAtivo === 'apresentacao') {
        if (prev.mensagem_apresentacao === newText) return prev;
        return { ...prev, mensagem_apresentacao: newText };
      } else if (tipoMensagemAtivo === 'apresentacao_2') {
        if (prev.mensagem_apresentacao_2 === newText) return prev;
        return { ...prev, mensagem_apresentacao_2: newText };
      } else if (tipoMensagemAtivo === 'apresentacao_3') {
        if (prev.mensagem_apresentacao_3 === newText) return prev;
        return { ...prev, mensagem_apresentacao_3: newText };
      } else if (tipoMensagemAtivo === 'apresentacao_carteira') {
        if (prev.mensagem_apresentacao_carteira === newText) return prev;
        return { ...prev, mensagem_apresentacao_carteira: newText };
      } else if (tipoMensagemAtivo === 'retorno') {
        if (prev.mensagem_retorno === newText) return prev;
        return { ...prev, mensagem_retorno: newText };
      } else if (tipoMensagemAtivo === 'fechamento') {
        if (prev.mensagem_fechamento === newText) return prev;
        return { ...prev, mensagem_fechamento: newText };
      } else {
        if (prev.mensagem_whats === newText) return prev;
        return { ...prev, mensagem_whats: newText };
      }
    });
  }, [tipoMensagemAtivo]);

  // Função para executar save imediato (usada pelo autosave e pelo flush)
  // USA REFS para evitar closure stale — sempre acessa o valor mais recente de composição e proposta
  const executarSaveImediato = useCallback(async () => {
    // Ler valores SEMPRE dos refs (nunca da closure) para garantir dado mais recente
    const composicao = composicaoParaExibirRef.current;
    const composicao2 = composicaoParaExibir2Ref.current;
    const prop = propostaRef.current;

    console.log('🔵 [SAVE] Iniciando save...');
    console.log('🔵 [SAVE] lead?.id:', lead?.id, '| user?.id:', user?.id);
    console.log('🔵 [SAVE] composicao (ref):', composicao?.linhas?.length || 0, 'linhas');
    console.log('🔵 [SAVE] hidratandoRef:', hidratandoRef.current, '| hidratadoRef:', hidratadoRef.current);
    
    if (!lead?.id || !user?.id) return false;
    
    // CORREÇÃO: Permitir save se composição tem linhas, mesmo durante hidratação
    if (hidratandoRef.current && (!composicao || composicao.linhas.length === 0)) {
      console.warn('⚠️ Save bloqueado: hidratação em andamento e sem composição válida');
      return false;
    }
    
    // PROTEÇÃO: Não salvar se ainda está carregando lead completo E não tem composição
    if (loadingLeadCompleto && (!composicao || composicao.linhas.length === 0)) {
      console.warn('⚠️ Save bloqueado: ainda carregando lead completo');
      return false;
    }
    
    try {
      // Serializar composição para salvar (dados mínimos + adicionais + linha_id)
      // 🛡️ dedup por telefone ao salvar: 1 telefone = 1 linha (nunca persiste duplicado). (25/06)
      const _dedupTel = (arr: any[]) => { const seen = new Set<string>(); return arr.filter((l: any) => { const t = String(l.numero ?? '').replace(/\D/g, ''); if (t.length < 8) return true; if (seen.has(t)) return false; seen.add(t); return true; }); };
      const composicaoParaSalvar = composicao ? {
        renovacao: composicao.renovacao,
        totalGB: composicao.totalGB,
        totalValor: composicao.totalValor,
        ...apresentacaoPropostaRef.current,
        linhas: _dedupTel(composicao.linhas.map(l => ({
          id: l.id,
          linha_id: l.linha_id || crypto.randomUUID(),
          tipo: l.tipo,
          numero: l.numero,
          planoId: l.planoId,
          plano: l.plano,
          adicionais: l.adicionais || undefined,
          tipoFibra: l.tipoFibra || undefined,
          // categoria custom (Serviço Digital etc.): sem ela a conversão perde o
          // fallback por categoria e fica dependendo só do catálogo em runtime.
          categoriaCustom: l.categoriaCustom || undefined,
          // ⛔ CAMPO NOVO NA LINHA = ACRESCENTE AQUI TAMBEM (Douglas 21/08/2026).
          // Estes dois serializadores listam os campos UM A UM, e o que nao esta
          // aqui e' DESCARTADO no save — a tela mostra "Salvo" e o dado some.
          // Foi o que matou o APARELHO: o seletor existe desde 08/08, a conversao
          // sabe criar o item, mas `aparelho` nunca chegava ao banco. Em 90 dias:
          // ZERO itens de aparelho vindos da linha.
          tipoBloco: l.tipoBloco || undefined,          // Bloco Novo/Incremento/Renovacao
          quantidade: l.quantidade ?? undefined,        // licencas do servico digital
          linhaVinculada: l.linhaVinculada || undefined,// telefone do servico
          linhaVinculadaId: l.linhaVinculadaId || undefined, // linha dona (vale ate sem telefone)
          aparelho: l.aparelho || undefined,            // modelo + forma de pagamento
          planoAtual: l.planoAtual || undefined,
          gbAtual: l.gbAtual ?? undefined,
          valorAtual: l.valorAtual ?? undefined,
          planoNovo: l.planoNovo || l.plano?.nome || undefined,
          titularLinhaId: l.titularLinhaId || undefined,
          ticketNovo: l.ticketNovo ?? undefined,
          receitaRenovada: l.receitaRenovada ?? undefined,
          receitaAdicionada: l.receitaAdicionada ?? undefined,
          sugestaoRenovacao: l.sugestaoRenovacao ?? undefined,
        }))),
      } : null;
      
      // PROTEÇÃO 1: Não sobrescrever com composição vazia se já tinha dados carregados na ref
      if (composicaoCarregadaRef.current && composicaoParaSalvar?.linhas.length === 0) {
        console.warn('⚠️ Save bloqueado: composição vazia, mantendo dados originais (ref)');
        return true;
      }
      
      // PROTEÇÃO 2: Não salvar null se o lead já tinha proposta no banco
      const leadTinhaComposicaoBanco = (leadCompleto?.proposta_composicao_cnpj as any)?.linhas?.length > 0;
      if (composicaoParaSalvar === null && leadTinhaComposicaoBanco) {
        console.warn('⚠️ Save bloqueado: tentativa de apagar proposta existente no banco');
        return true;
      }

      const { error } = await supabase
        .from('leads_carteira')
        .update({
          // Plano Atual
          qtd_linhas_voz: prop.linhas_atual ? parseInt(prop.linhas_atual) : null,
          proposta_gb_atual: prop.gb_atual ? parseInt(prop.gb_atual) : null,
          valor_fatura_atual: prop.valor_atual ? parseNumeroBR(prop.valor_atual) : null,
          observacoes_consultor: prop.obs_atual || null,
          proposta_fibra_atual: prop.fibra_atual || null,
          proposta_tv_atual: prop.tv_atual || null,
          // Plano Novo
          proposta_linhas_novo: composicaoParaSalvar ? composicaoParaSalvar.linhas.filter(l => ehLinhaDeVoz(l.tipo)).length : prop.linhas_novo ? parseInt(prop.linhas_novo) : null,
          proposta_gb_novo: prop.gb_novo ? parseInt(prop.gb_novo) : null,
          valor_proposta: prop.valor_novo ? parseNumeroBR(prop.valor_novo) : null,
          proposta_diferencial: prop.diferencial_novo || null,
          // Composição do montador (JSONB)
          proposta_composicao_cnpj: composicaoParaSalvar,
          // Composição 2 (Plano Novo 2 — Renovação com Incremento)
          proposta_composicao_cnpj_2: composicao2 ? {
            linhas: composicao2.linhas.map(l => ({
              id: l.id,
              linha_id: l.linha_id || crypto.randomUUID(),
              tipo: l.tipo,
              numero: l.numero,
              planoId: l.planoId,
              adicionais: l.adicionais || undefined,
              tipoProposta: 'RENOVACAO_INCREMENTO',
            })),
          } : null,
          // Mensagens WhatsApp
          proposta_mensagem_whats: prop.mensagem_whats || null,
          proposta_mensagem_retorno: prop.mensagem_retorno || null,
          proposta_mensagem_fechamento: prop.mensagem_fechamento || null,
          proposta_mensagem_apresentacao_carteira: prop.mensagem_apresentacao_carteira || null,
          proposta_mensagem_apresentacao_2: prop.mensagem_apresentacao_2 || null,
          proposta_mensagem_apresentacao_3: prop.mensagem_apresentacao_3 || null,
          // Visibilidade dos planos (botão do olho)
          ocultar_plano_atual: prop.ocultar_plano_atual ?? false,
          ocultar_plano_fixo: prop.ocultar_plano_fixo ?? false,
        })
        .eq('id', lead.id);
        
      if (error) {
        console.error('❌ Save erro:', error);
        return false;
      }
      
      console.log('✅ Save: proposta salva com sucesso');
      return true;
    } catch (error) {
      console.error('❌ Save exceção:', error);
      return false;
    }
  // Deps estáveis: composicao/proposta removidos — agora lidos via refs, sem closure stale
  }, [lead?.id, user?.id, leadCompleto, loadingLeadCompleto, queryClient]);

  // Função flush para salvar imediatamente antes de fechar
  const flushAutosave = useCallback(async () => {
    // Cancelar timeout pendente
    if (autosaveTimeoutRef.current) {
      clearTimeout(autosaveTimeoutRef.current);
      autosaveTimeoutRef.current = null;
    }
    
    // Usar ref para verificar composição mais recente (evita closure stale)
    const composicaoAtual = composicaoParaExibirRef.current;
    if (hidratandoRef.current && (!composicaoAtual || composicaoAtual.linhas.length === 0)) return;
    
    setStatusSalvamento('salvando');
    const sucesso = await executarSaveImediato();
    
    if (sucesso) {
      setStatusSalvamento('salvo');
    } else {
      setStatusSalvamento('erro');
      toast.error('Houve um erro ao salvar. Tente novamente.');
    }
  }, [executarSaveImediato]);

  // AUTOSAVE: Salvar automaticamente a proposta quando houver mudanças
  useEffect(() => {
    // Não fazer autosave se ainda não hidratou, se está hidratando, ou se não tem lead
    // Isso previne race condition onde autosave sobrescreve dados durante hidratação
    if (!hidratadoRef.current || hidratandoRef.current || !lead?.id || !user?.id) return;
    
    // Limpar timeout anterior
    if (autosaveTimeoutRef.current) {
      clearTimeout(autosaveTimeoutRef.current);
    }
    
    // Debounce REDUZIDO para 800ms para salvamento mais responsivo
    autosaveTimeoutRef.current = setTimeout(async () => {
      setStatusSalvamento('salvando');
      
      const sucesso = await executarSaveImediato();
      
      if (sucesso) {
        setStatusSalvamento('salvo');
        // Voltar para idle após 3 segundos
        setTimeout(() => setStatusSalvamento('idle'), 3000);
      } else {
        setStatusSalvamento('erro');
        toast.error('Erro ao salvar automaticamente. Clique em "Salvar Tudo" para tentar novamente.');
      }
    }, 800);
    
    // Cleanup
    return () => {
      if (autosaveTimeoutRef.current) {
        clearTimeout(autosaveTimeoutRef.current);
      }
    };
  }, [
    lead?.id,
    user?.id,
    proposta.linhas_atual,
    proposta.gb_atual,
    proposta.valor_atual,
    proposta.fibra_atual,
    proposta.tv_atual,
    proposta.obs_atual,
    proposta.linhas_novo,
    proposta.gb_novo,
    proposta.valor_novo,
    proposta.diferencial_novo,
    proposta.mensagem_whats,
    // mensagem_retorno e mensagem_fechamento removidas das deps: são geradas automaticamente
    // e criavam loop: composição → mensagens → autosave bloqueado pela hidratação
    composicaoParaExibir,
    proposta.ocultar_plano_atual,
    proposta.ocultar_plano_fixo,
    executarSaveImediato,
  ]);

  // Handler para fechar o modal com flush
  // CORREÇÃO: Sempre tentar salvar se tem composição, independente de hidratadoRef
  // CORREÇÃO #5: Em modo revisão, mostrar AlertDialog ao invés de fechar direto
  const handleCloseModal = useCallback(async (isOpen: boolean) => {
    if (!isOpen) {
      // Em modo revisão, interceptar e mostrar AlertDialog
      if (emModoRevisao && lead?.id) {
        setShowCancelRevisaoDialog(true);
        return; // Não fecha o modal ainda
      }
      
      // Usar ref para garantir valor mais recente da composição (evita closure stale)
      const composicaoAtual = composicaoParaExibirRef.current;
      
      // SEMPRE tentar salvar se tem composição com linhas (mesmo se hidratação não completou)
      if (composicaoAtual && composicaoAtual.linhas.length > 0) {
        console.log('💾 [Modal] Salvando antes de fechar...', composicaoAtual.linhas.length, 'linhas');
        setStatusSalvamento('salvando');
        
        // Forçar save imediato mesmo sem hidratação completa
        try {
          const sucesso = await executarSaveImediato();
          if (sucesso) {
            console.log('✅ [Modal] Salvo com sucesso ao fechar');
            setStatusSalvamento('salvo');
          } else {
            console.warn('⚠️ [Modal] Falha ao salvar ao fechar');
            setStatusSalvamento('erro');
          }
        } catch (e) {
          console.error('❌ [Modal] Erro ao salvar ao fechar:', e);
        }
      } else if (hidratadoRef.current) {
        // Fallback: flush normal se já hidratou mas não tem composição nova
        await flushAutosave();
      }
    }
    onOpenChange(isOpen);
  }, [flushAutosave, onOpenChange, executarSaveImediato, emModoRevisao, lead?.id]);

  // === NAVEGAÇÃO CARROSSEL ===
  
  // Resetar dirty quando lead muda
  useEffect(() => {
    if (lead?.id) {
      setIsDirty(false);
    }
  }, [lead?.id]);
  
  // Marcar dirty quando editar dados
  const handleContatoChange = useCallback((updates: Partial<typeof contato>) => {
    setContato(prev => ({ ...prev, ...updates }));
    setIsDirty(true);
  }, []);
  
  // Handler para tentar navegar (verifica dirty state)
  const handleTentarNavegar = useCallback((direcao: 'anterior' | 'proximo') => {
    if (isDirty) {
      setPendingNavigation(direcao);
      setShowNavigationGuard(true);
    } else {
      onNavegar?.(direcao);
    }
  }, [isDirty, onNavegar]);
  
  // Confirmar navegação com save
  const handleConfirmarNavegacao = useCallback(async () => {
    await flushAutosave();
    setShowNavigationGuard(false);
    if (pendingNavigation) {
      onNavegar?.(pendingNavigation);
      setPendingNavigation(null);
      setIsDirty(false);
    }
  }, [flushAutosave, pendingNavigation, onNavegar]);
  
  // Descartar e navegar
  const handleDescartarENavegar = useCallback(() => {
    setShowNavigationGuard(false);
    if (pendingNavigation) {
      onNavegar?.(pendingNavigation);
      setPendingNavigation(null);
      setIsDirty(false);
    }
  }, [pendingNavigation, onNavegar]);
  
  // Prefetch próximo e anterior para navegação instantânea
  useEffect(() => {
    if (!open || !onNavegar || !leadIdsFrozen) return;
    
    const idAnterior = indiceAtual !== undefined && indiceAtual > 0 ? leadIdsFrozen[indiceAtual - 1] : null;
    const idProximo = indiceAtual !== undefined && totalLeads !== undefined && indiceAtual < totalLeads - 1 
      ? leadIdsFrozen[indiceAtual + 1] 
      : null;
    
    // Prefetch anterior
    if (idAnterior) {
      queryClient.prefetchQuery({
        queryKey: ['lead-completo', idAnterior],
        queryFn: async () => {
          const { data } = await supabase
            .from('leads_carteira')
            .select('*')
            .eq('id', idAnterior)
            .maybeSingle();
          return data;
        },
        staleTime: 30000,
      });
    }
    
    // Prefetch próximo
    if (idProximo) {
      queryClient.prefetchQuery({
        queryKey: ['lead-completo', idProximo],
        queryFn: async () => {
          const { data } = await supabase
            .from('leads_carteira')
            .select('*')
            .eq('id', idProximo)
            .maybeSingle();
          return data;
        },
        staleTime: 30000,
      });
    }
  }, [open, lead?.id, indiceAtual, totalLeads, leadIdsFrozen, onNavegar, queryClient]);
  
  // Atalhos de teclado para navegação
  useEffect(() => {
    if (!open || !onNavegar) return;
    
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ignorar se estiver em campo de input
      const target = e.target as HTMLElement;
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.tagName === 'SELECT' ||
        target.isContentEditable
      ) return;
      
      if (e.key === 'ArrowLeft' && canNavigate?.anterior) {
        e.preventDefault();
        handleTentarNavegar('anterior');
      } else if (e.key === 'ArrowRight' && canNavigate?.proximo) {
        e.preventDefault();
        handleTentarNavegar('proximo');
      } else if (e.key === 'Enter' && !e.shiftKey && canNavigate?.proximo) {
        e.preventDefault();
        handleTentarNavegar('proximo');
      } else if (e.key === 'Enter' && e.shiftKey && canNavigate?.anterior) {
        e.preventDefault();
        handleTentarNavegar('anterior');
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open, onNavegar, canNavigate, handleTentarNavegar]);
  
  // === FIM NAVEGAÇÃO CARROSSEL ===

  // CORREÇÃO #4: Função para cancelar revisão com validação de pedido
  const cancelarRevisao = useCallback(async (): Promise<boolean> => {
    if (!lead?.id || !revisaoPedidoId) return false;
    
    setCancelandoRevisao(true);
    try {
      // Buscar dados do lead incluindo revisao_pedido_id para validação
      const { data: leadData, error: errBusca } = await supabase
        .from('leads_carteira')
        .select('status_lead_anterior, revisao_pedido_id')
        .eq('id', lead.id)
        .single();

      if (errBusca || !leadData) {
        toast.error('Não carreguei os dados do lead. Atualize a tela.');
        return false;
      }

      // FIX #3 (25/06): NAO bloquear mais por mismatch de ponteiro. Quando a revisao
      // grudava num gemeo duplicado, o usuario ficava preso (sem salvar nem cancelar).
      // Cancelar so reverte o lead (nada foi salvo) — seguro limpar sempre.
      if (leadData.revisao_pedido_id && leadData.revisao_pedido_id !== revisaoPedidoId) {
        console.warn('[cancelarRevisao] ponteiro divergente — limpando mesmo assim', { lead: leadData.revisao_pedido_id, sessao: revisaoPedidoId });
      }

      const statusFinal = leadData.status_lead_anterior || 'CONVERTIDO';

      // Reverter status e limpar campos de revisão
      const { error: errUpdate } = await supabase
        .from('leads_carteira')
        .update({
          status_lead: statusFinal,
          status_lead_anterior: null,
          revisao_pedido_id: null,
          revisao_iniciada_em: null,
          proposta_status: 'CONVERTIDA',
          proposta_fechada: true,
        })
        .eq('id', lead.id);

      if (errUpdate) {
        toast.error('Erro ao cancelar revisão', {
          description: errUpdate.message,
        });
        return false;
      }

      // Invalidar queries
      queryClient.invalidateQueries({ queryKey: ['leads'] });
      queryClient.invalidateQueries({ queryKey: ['lead-completo', lead.id] });
      queryClient.invalidateQueries({ queryKey: ['lead-detail', lead.id] });
      queryClient.invalidateQueries({ queryKey: ['meus-leads-carteira-optimized'] });

      toast.info('Revisão cancelada', {
        description: 'O lead voltou ao status anterior.',
      });
      
      return true;
    } catch (error) {
      console.error('Erro ao cancelar revisão:', error);
      toast.error('Não cancelou a revisão. Atualize a tela e tente de novo.');
      return false;
    } finally {
      setCancelandoRevisao(false);
    }
  }, [lead?.id, revisaoPedidoId, queryClient]);

  // Handler para confirmar cancelamento e voltar ao pedido
  const handleConfirmarCancelRevisao = useCallback(async () => {
    const sucesso = await cancelarRevisao();
    if (sucesso) {
      setShowCancelRevisaoDialog(false);
      onVoltarParaPedido?.();
    }
  }, [cancelarRevisao, onVoltarParaPedido]);

  // 🆕 Buscar nome da campanha vinculada ao lead (ANTES do guard — regra dos hooks)
  const { data: campanhaNome } = useQuery({
    queryKey: ['campanha-nome', lead?.campanha_id],
    queryFn: async () => {
      if (!lead?.campanha_id) return null;
      const { data } = await supabase
        .from('campanhas_prospeccao')
        .select('nome')
        .eq('id', lead.campanha_id)
        .maybeSingle();
      return data?.nome ?? null;
    },
    enabled: !!lead?.campanha_id,
    staleTime: 10 * 60 * 1000,
  });

  // GUARD: Só renderiza o resto se tiver lead
  if (!lead) return null;

  const cnpjDaOrigem = String((lead.dados_master_lead as Record<string, unknown> | null)?.cnpj_origem ?? '').replace(/\D/g, '');
  const telefone = lead.contato_real_telefone || lead.telefone;

  const abrirWhatsappDoLead = async (janela?: Window | null) => {
    if (!telefone) return;
      // Abre a conversa que JÁ EXISTE (qualquer conexão), pelo telefone — não cria nova.
      const win = janela ?? window.open('', '_blank');
      try {
        const d8 = (telefone || '').replace(/\D/g, '').slice(-8);
        let convId: string | null = null;
        if (d8.length === 8) {
          const { data } = await supabase
            .from('whatsapp_conversations')
            .select('id')
            .ilike('telefone_canonico', `%${d8}`)
            .order('last_message_at', { ascending: false, nullsFirst: false })
            .limit(1);
          convId = (data as any)?.[0]?.id || null;
        }
        if (convId) {
          if (win) win.location.href = `/whatsapp-inbox?conversation=${convId}`;
        } else {
          win?.close();
          abrirConversa(telefone, { novaAba: true }); // sem conversa: inicia uma
        }
      } catch {
        win?.close();
        abrirConversa(telefone, { novaAba: true });
      }
  };

  const atualizarLeadDepoisDeReabrir = () => {
    setTimeout(() => queryClient.invalidateQueries({ queryKey: ['lead-completo', lead.id] }), 2500);
  };
  
  // Normalizar telefone para uso interno
  const telefoneNormalizado = telefone ? (() => {
    const digits = keepOnlyDigits(telefone);
    if (digits.length === 12 && digits.startsWith('55')) return digits;
    if (digits.length === 13 && digits.startsWith('55')) return digits.slice(0, 4) + digits.slice(5);
    if (digits.length === 11) return `55${digits.slice(0, 2)}${digits.slice(3)}`;
    if (digits.length === 10) return `55${digits}`;
    return digits;
  })() : null;
  
  
  
  const tipoLabels: Record<string, string> = {
    'RENOVACAO_CLARO': 'Renovação Claro',
    'PORTABILIDADE_VIVO': 'Portabilidade Vivo',
    'PORTABILIDADE_CPF': 'Portabilidade CPF',
    'RENOVACAO_CPF': 'Renovação CPF',
    'RETENCAO_CPF': 'Retenção CPF',
    'OI_CPF': 'Oi fibra CPF',
    'ALGAR_CPF': 'Algar CPF',
    'RF_CPF': 'Diários RF CPF',
    'TT_CPF_CNPJ': 'TT CPF→CNPJ',
    'OI': 'Oi',
    'TAB': 'Tabulação',
    'URA': 'URA · dígito 1',
  };
  const tipoLabel = tipoLabels[lead.tipo_lead || ''] || 'Lead';

  // A URA é a PORTA, não a origem: o lead continua sendo da lista que o gerou
  // (OI, ALGAR PROPOSTA, ALGAR URA, RF…). Qualquer estratégia nova aparece aqui
  // sozinha — o rótulo sai do próprio valor gravado, sem lista chumbada.
  const origemMailingLead = String(
    (lead.dados_discadora as Record<string, unknown> | null)?.origem_mailing || ''
  ).trim().replace(/_/g, ' ').toUpperCase() || null;

  const documentoLead = lead.tipo_pessoa === 'PF' ? lead.cpf : lead.cnpj;
  const tipoDocumentoLead = lead.tipo_pessoa === 'PF' ? 'CPF' : 'CNPJ';
  const documentoLeadFormatado = lead.tipo_pessoa === 'PF' ? formatarCPF(documentoLead) : formatarCNPJ(documentoLead);
  const copiarDocumento = () => {
    navigator.clipboard.writeText(documentoLead || '');
    toast.success(`${tipoDocumentoLead} copiado!`);
  };

  const salvarContato = async () => {
    // Contato Real é o telefone DO CLIENTE. Linha nossa aqui transforma a
    // proposta em mensagem para nós mesmos — foi o atalho encontrado em 05/08.
    if (await ehNumeroDaCasa(contato.telefone)) {
      const conexao = await nomeDaConexaoDoNumero(contato.telefone);
      toast.error('Esse número é do CRM, não do cliente', {
        description: conexao
          ? `${MENSAGEM_NUMERO_DA_CASA} (linha "${conexao}")`
          : MENSAGEM_NUMERO_DA_CASA,
        duration: 9000,
      });
      return;
    }

    setSaving(true);
    try {
      const { error } = await supabase
        .from('leads_carteira')
        .update({
          contato_real_encontrado: !!contato.nome,
          contato_real_nome: contato.nome || null,
          contato_real_telefone: contato.telefone?.replace(/\D/g, '') || null,
          contato_real_cargo: contato.cargo || null,
          contato_real_email: contato.email || null,
          data_contato_encontrado: contato.nome ? new Date().toISOString() : null,
        })
        .eq('id', lead.id);
      
      if (error) throw error;
      
      // 🆕 Normalizar CNPJ antes de invalidar cache do master
      const cnpjLimpo = lead.cnpj?.replace(/\D/g, '') || '';
      
      // 🆕 Invalidar + refetch com await para garantir UI atualizada (trigger atualiza master)
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['cnpj-contato-master', cnpjLimpo] }),
        queryClient.invalidateQueries({ queryKey: ['meus-leads-carteira'] }),
        queryClient.invalidateQueries({ queryKey: ['gestao-leads'] }),
        queryClient.invalidateQueries({ queryKey: ['leads-carteira'] }),
        queryClient.invalidateQueries({ queryKey: ['lead-completo', lead.id] }),
        // ⛔ A 2ª barreira do "Criar pedido" valida o lead desta query, e ela não
        // era invalidada aqui: o consultor salvava o contato, via "Contato
        // salvo!", clicava em criar pedido e levava "Contato Real obrigatório"
        // com o nome preenchido na tela. (Douglas 02/09/2026)
        queryClient.invalidateQueries({ queryKey: ['lead-detail-modal', lead.id] }),
      ]);
      
      // 🆕 Forçar refetch do master com await para garantir cache atualizado
      await queryClient.refetchQueries({ queryKey: ['cnpj-contato-master', cnpjLimpo] });
      
      // Resetar flag de origem master após salvar
      setContatoOrigemMaster(false);
      
      toast.success('Contato salvo!');
    } catch (error: any) {
      console.error('Erro ao salvar contato:', error);
      toast.error(error.message || 'Erro ao salvar contato');
    } finally {
      setSaving(false);
    }
  };

  const salvarProposta = async () => {
    setSaving(true);
    try {
      // Serializar composição para salvar (dados mínimos + adicionais + tipoFibra + linha_id)
      // ✅ CORREÇÃO: Usar refs em vez de closures — garante valor mais recente mesmo sem re-render
      const composicaoAtual = composicaoParaExibirRef.current;
      const _dedupTel2 = (arr: any[]) => { const seen = new Set<string>(); return arr.filter((l: any) => { const t = String(l.numero ?? '').replace(/\D/g, ''); if (t.length < 8) return true; if (seen.has(t)) return false; seen.add(t); return true; }); };
      const composicaoParaSalvar = composicaoAtual ? {
        renovacao: composicaoAtual.renovacao,
        totalGB: composicaoAtual.totalGB,
        totalValor: composicaoAtual.totalValor,
        ...apresentacaoPropostaRef.current,
        linhas: _dedupTel2(composicaoAtual.linhas.map(l => ({
          id: l.id,
          tipo: l.tipo,
          numero: l.numero,
          planoId: l.planoId,
          plano: l.plano,
          adicionais: l.adicionais || undefined,
          tipoFibra: l.tipoFibra || undefined,
          linha_id: l.linha_id, // CRÍTICO para preservar operacionais na regeneração
          categoriaCustom: l.categoriaCustom || undefined,
          // ⛔ CAMPO NOVO NA LINHA = ACRESCENTE AQUI TAMBEM (Douglas 21/08/2026).
          // Estes dois serializadores listam os campos UM A UM, e o que nao esta
          // aqui e' DESCARTADO no save — a tela mostra "Salvo" e o dado some.
          // Foi o que matou o APARELHO: o seletor existe desde 08/08, a conversao
          // sabe criar o item, mas `aparelho` nunca chegava ao banco. Em 90 dias:
          // ZERO itens de aparelho vindos da linha.
          tipoBloco: l.tipoBloco || undefined,          // Bloco Novo/Incremento/Renovacao
          quantidade: l.quantidade ?? undefined,        // licencas do servico digital
          linhaVinculada: l.linhaVinculada || undefined,// telefone do servico
          linhaVinculadaId: l.linhaVinculadaId || undefined, // linha dona (vale ate sem telefone)
          aparelho: l.aparelho || undefined,            // modelo + forma de pagamento
          planoAtual: l.planoAtual || undefined,
          gbAtual: l.gbAtual ?? undefined,
          valorAtual: l.valorAtual ?? undefined,
          planoNovo: l.planoNovo || l.plano?.nome || undefined,
          titularLinhaId: l.titularLinhaId || undefined,
          ticketNovo: l.ticketNovo ?? undefined,
          receitaRenovada: l.receitaRenovada ?? undefined,
          receitaAdicionada: l.receitaAdicionada ?? undefined,
          sugestaoRenovacao: l.sugestaoRenovacao ?? undefined,
        }))),
      } : null;
      
      // PROTEÇÃO: nunca apagar uma proposta que existe, gravando vazio por cima.
      //
      // (Douglas 03/08) Consultora montava a proposta, clicava em "Enviar
      // Fechamento" e a proposta sumia — o "Criar Pedido" logo depois batia em
      // "Adicione pelo menos um produto". Aconteceu mais de uma vez.
      //
      // A causa: o autosave (`executarSaveImediato`) ABORTA o save quando a
      // composição está vazia e o lead já tem proposta; este save manual — que
      // é o que o "Enviar Fechamento" e o "Salvar Tudo" chamam — só emitia um
      // toast e gravava `null` por cima. Bastava a ref estar vazia no instante
      // do clique (remount do modal, refetch do lead no meio do envio) para a
      // proposta ser apagada no banco.
      //
      // Agora os dois caminhos se comportam igual: sem itens, a composição do
      // banco é PRESERVADA — o resto da proposta (textos, valores) salva
      // normalmente. Apagar de propósito continua possível pelo botão de
      // remover linha, que passa por outro fluxo.
      const leadTinhaComposicao = (leadCompleto?.proposta_composicao_cnpj as any)?.linhas?.length > 0;
      const composicaoVazia = !composicaoParaSalvar || composicaoParaSalvar.linhas.length === 0;
      const preservarComposicao = leadTinhaComposicao && composicaoVazia;

      if (preservarComposicao) {
        console.warn('⚠️ Save manual: composição vazia sobre proposta existente — mantendo a do banco');
      }

      // ✅ CORREÇÃO: Usar ref para composicaoParaExibir2 também
      const composicaoAtual2 = composicaoParaExibir2Ref.current;

      const { error } = await supabase
        .from('leads_carteira')
        .update({
          // Plano Atual
          qtd_linhas_voz: proposta.linhas_atual ? parseInt(proposta.linhas_atual) : null,
          proposta_gb_atual: proposta.gb_atual ? parseInt(proposta.gb_atual) : null,
          valor_fatura_atual: proposta.valor_atual ? parseNumeroBR(proposta.valor_atual) : null,
          observacoes_consultor: proposta.obs_atual || null,
          proposta_fibra_atual: proposta.fibra_atual || null,
          proposta_tv_atual: proposta.tv_atual || null, // Salvar TV do plano atual
          // Plano Novo
          ...(preservarComposicao ? {} : { proposta_linhas_novo: composicaoParaSalvar ? composicaoParaSalvar.linhas.filter(l => ehLinhaDeVoz(l.tipo)).length : proposta.linhas_novo ? parseInt(proposta.linhas_novo) : null }),
          proposta_gb_novo: proposta.gb_novo ? parseInt(proposta.gb_novo) : null,
          valor_proposta: proposta.valor_novo ? parseNumeroBR(proposta.valor_novo) : null,
          proposta_diferencial: proposta.diferencial_novo || null,
          // Composição do montador (JSONB)
          // Vazio sobre proposta existente = mantém a do banco (ver PROTEÇÃO acima).
          ...(preservarComposicao ? {} : { proposta_composicao_cnpj: composicaoParaSalvar }),
          // Composição 2 (Plano Novo 2 — Renovação com Incremento)
          proposta_composicao_cnpj_2: composicaoAtual2 ? {
            linhas: composicaoAtual2.linhas.map(l => ({
              id: l.id,
              linha_id: l.linha_id || crypto.randomUUID(),
              tipo: l.tipo,
              numero: l.numero,
              planoId: l.planoId,
              adicionais: l.adicionais || undefined,
              tipoProposta: 'RENOVACAO_INCREMENTO',
            })),
          } : null,
          // Mensagens WhatsApp (3 tipos)
          proposta_mensagem_whats: proposta.mensagem_whats || null,
          proposta_mensagem_retorno: proposta.mensagem_retorno || null,
          proposta_mensagem_fechamento: proposta.mensagem_fechamento || null,
          proposta_mensagem_apresentacao: proposta.mensagem_apresentacao || null,
          proposta_mensagem_apresentacao_carteira: proposta.mensagem_apresentacao_carteira || null,
          proposta_mensagem_apresentacao_2: proposta.mensagem_apresentacao_2 || null,
          proposta_mensagem_apresentacao_3: proposta.mensagem_apresentacao_3 || null,
        })
        .eq('id', lead.id);
      
      if (error) throw error;
      
      // Salvar NÃO gera evento na timeline — o rastro nasce no ENVIO, com o
      // valor junto. Antes cada "Salvar Tudo" virava um "Valores da proposta
      // salvos" sem número, duplicando a timeline. (Douglas 29/08)

      // Invalidar queries de leads para refletir mudanças
      queryClient.invalidateQueries({ queryKey: ['meus-leads-carteira'] });
      queryClient.invalidateQueries({ queryKey: ['gestao-leads'] });
      queryClient.invalidateQueries({ queryKey: ['gestao-leads-optimized'] }); // CRÍTICO: query usada na página
      queryClient.invalidateQueries({ queryKey: ['gestao-carteira-optimized'] }); // Para aba Carteira
      queryClient.invalidateQueries({ queryKey: ['leads-carteira'] });
      queryClient.invalidateQueries({ queryKey: ['lead-historico', lead.id] });
      // ✅ CORREÇÃO: Invalidar lead-completo para garantir refetch correto ao reabrir modal
      queryClient.invalidateQueries({ queryKey: ['lead-completo', lead.id] });
      
      // UPDATE OTIMISTA: Atualizar diretamente o cache das listas com os novos dados
      // Isso garante que ao reabrir o modal, os dados já estão atualizados
      const dadosAtualizados = {
        // Mesma proteção do update no banco: se a composição veio vazia sobre uma
        // proposta que existe, NÃO sobrescreve o cache — senão a tela zera mesmo
        // com o banco preservado, e o "Criar Pedido" logo depois bate na trava de
        // "adicione pelo menos um produto". (Douglas 03/08)
        ...(preservarComposicao
          ? { proposta_composicao_cnpj: (leadCompleto as { proposta_composicao_cnpj?: unknown } | null)?.proposta_composicao_cnpj }
          : { proposta_composicao_cnpj: composicaoParaSalvar }),
        proposta_fibra_atual: proposta.fibra_atual || null,
        proposta_tv_atual: proposta.tv_atual || null,
        proposta_gb_atual: proposta.gb_atual ? parseInt(proposta.gb_atual) : null,
        proposta_gb_novo: proposta.gb_novo ? parseInt(proposta.gb_novo) : null,
        valor_proposta: proposta.valor_novo ? parseNumeroBR(proposta.valor_novo) : null,
        proposta_mensagem_whats: proposta.mensagem_whats || null,
        proposta_mensagem_retorno: proposta.mensagem_retorno || null,
        proposta_mensagem_fechamento: proposta.mensagem_fechamento || null,
        proposta_mensagem_apresentacao: proposta.mensagem_apresentacao || null,
        proposta_mensagem_apresentacao_carteira: proposta.mensagem_apresentacao_carteira || null,
        proposta_mensagem_apresentacao_2: proposta.mensagem_apresentacao_2 || null,
        proposta_mensagem_apresentacao_3: proposta.mensagem_apresentacao_3 || null,
      };
      
      // Atualizar cache de gestao-leads-optimized (useInfiniteQuery - formato páginas)
      queryClient.setQueriesData({ queryKey: ['gestao-leads-optimized'] }, (oldData: any) => {
        if (!oldData?.pages) return oldData;
        return {
          ...oldData,
          pages: oldData.pages.map((page: any) => ({
            ...page,
            leads: page.leads?.map((l: any) => 
              l.id === lead.id ? { ...l, ...dadosAtualizados } : l
            ) || []
          }))
        };
      });
      
      // Atualizar cache de gestao-carteira-optimized (useInfiniteQuery - formato páginas)
      queryClient.setQueriesData({ queryKey: ['gestao-carteira-optimized'] }, (oldData: any) => {
        if (!oldData?.pages) return oldData;
        return {
          ...oldData,
          pages: oldData.pages.map((page: any) => ({
            ...page,
            leads: page.leads?.map((l: any) => 
              l.id === lead.id ? { ...l, ...dadosAtualizados } : l
            ) || []
          }))
        };
      });
      
      // Atualizar referência da composição carregada
      composicaoCarregadaRef.current = JSON.stringify(composicaoParaSalvar);
      
      console.log('✅ Proposta salva e cache atualizado');
      toast.success('Proposta salva!');
      return true;
    } catch (error: any) {
      console.error('Erro ao salvar proposta:', error);
      toast.error(error.message || 'Erro ao salvar proposta');
      return false;
    } finally {
      setSaving(false);
    }
  };

  // Salvar proposta E regenerar itens do pedido (modo revisão)
  const handleSalvarEAplicar = async () => {
    if (!emModoRevisao || !revisaoPedidoId || !lead?.id || !user?.id) {
      console.warn('handleSalvarEAplicar: pré-condições não atendidas');
      return;
    }

    // Conflito CONFIRMADO produto × operadora não passa (Douglas 07/08). Linha
    // sem consulta não entra aqui — só o que a API afirmou.
    if (conflitosOperadora.length > 0) {
      const diagnostico = {
        ok: false as const,
        codigo: 'conflito_produto_operadora' as const,
        motivo: 'A operadora consultada não corresponde ao tipo de produto de uma ou mais linhas.',
        acao: 'Corrija o produto ou a operadora indicada antes de aplicar a proposta.',
        detalhes: { conflitos: conflitosOperadora },
      };
      await registrarDiagnosticoRevisao({ leadId: lead.id, pedidoId: revisaoPedidoId, userId: user.id, diagnostico });
      toast.error(`Proposta não aplicada · ${diagnostico.codigo}`, {
        description: `${diagnostico.motivo} ${diagnostico.acao} ${conflitosOperadora.join(' · ')}`,
        duration: 12000,
      });
      return;
    }

    setSaving(true);
    try {
      // 1. Salvar proposta primeiro
      if (!await salvarProposta()) {
        const diagnostico = {
          ok: false as const, codigo: 'falha_salvar_proposta' as const,
          motivo: 'A proposta não foi salva; por segurança, nenhum item foi aplicado ao pedido.',
          acao: 'Confira os campos da proposta e tente salvar novamente.', detalhes: {},
        };
        await registrarDiagnosticoRevisao({ leadId: lead.id, pedidoId: revisaoPedidoId, userId: user.id, diagnostico });
        throw new Error(`${diagnostico.codigo}: ${diagnostico.motivo} ${diagnostico.acao}`);
      }

      // 2. Regenerar itens do pedido
      const resultado = await regenerar(revisaoPedidoId, lead.id, user.id, undefined, isRevisaoCancelado
        ? { ficamCancelados, motivoFicamId: motivoFicamId === MANTER_MOTIVO_ATUAL ? null : motivoFicamId }
        : undefined);

      if (resultado.success) {
        const eraRevisaoCancelado = (leadCompleto as any)?.revisao_de_cancelado === true;
        toast.success('Proposta aplicada ao pedido!', {
          description: `${resultado.itensRegenerados} item(ns) atualizado(s), ${resultado.operacionaisPreservados} com dados preservados. ${eraRevisaoCancelado ? 'O pedido foi para PEDIDO RECUPERADO.' : 'Agora dispare o pedido para PEDIDO FECHADO.'}`,
        });

        // 3. Invalidar queries do pedido
        queryClient.invalidateQueries({ queryKey: ['pedido-itens-completo', revisaoPedidoId] });
        queryClient.invalidateQueries({ queryKey: ['pedido', revisaoPedidoId] });
        
        // 4. Voltar para o pedido — é lá que fica o "Enviar ao BKO" (manda os
        // itens pra PEDIDO FECHADO), mesmo caminho do fluxo normal do COMERCIAL.
        // Fallback: se a página não cuidar da volta, abrimos o painel daqui.
        if (onVoltarParaPedido) {
          onVoltarParaPedido();
        } else {
          onOpenChange(false);
          openPedido(revisaoPedidoId, 'planilha');
        }
      } else {
        const diagnostico = {
          ok: false as const, codigo: 'falha_aplicar_pedido' as const,
          motivo: resultado.error || 'A proposta foi salva, mas o CRM não conseguiu aplicar os itens ao pedido.',
          acao: 'Os itens do pedido não foram confirmados como atualizados. Siga a orientação acima.',
          detalhes: { erro: String(resultado.error || 'erro não informado').slice(0, 500) },
        };
        await registrarDiagnosticoRevisao({ leadId: lead.id, pedidoId: revisaoPedidoId, userId: user.id, diagnostico });
        toast.error(`Proposta não aplicada · ${diagnostico.codigo}`, {
          description: `${diagnostico.motivo} ${diagnostico.acao}`,
        });
      }
    } catch (error: any) {
      console.error('Erro ao salvar e aplicar:', error);
      toast.error(error.message || 'Erro ao aplicar proposta');
    } finally {
      setSaving(false);
    }
  };


  // Enviar proposta via WhatsApp (Evolution)
  /**
   * PROPOSTA E-MAIL (Douglas 06/08 e 05/10/2026) — sai por SMTP (a caixa do
   * consultor), SendGrid ou os dois, com o supervisor em cópia. O consultor
   * escreve a abertura e o fechamento direto na prévia; a imagem e os valores
   * saem da proposta montada.
   */
  // A MESMA imagem da proposta vai no WhatsApp (Proposta Imagem) e no e-mail
  // (Proposta E-mail). Sobe uma vez e devolve o caminho e o link público.
  const subirImagemDaProposta = async (): Promise<{ path: string; url: string }> => {
    const blob = await comparativoRef.current?.gerarImagemBlob();
    if (!blob) throw new Error('Card visual indisponível — monte a proposta antes.');
    const safeLeadId = (lead.id || 'lead').replace(/[^a-zA-Z0-9-]/g, '');
    const path = `propostas/${safeLeadId}-${Date.now()}.png`;
    const { error: upErr } = await supabase.storage
      .from('whatsapp-media')
      .upload(path, blob, { contentType: 'image/png', upsert: false });
    if (upErr) throw new Error(`Upload falhou: ${upErr.message}`);
    const { data: pub } = supabase.storage.from('whatsapp-media').getPublicUrl(path);
    if (!pub?.publicUrl) throw new Error('Não consegui URL pública da imagem.');
    return { path, url: pub.publicUrl };
  };

  const handleEnviarPropostaEmail = async () => {
    // Sem trava de Contato Real (Douglas 02/10/2026): sem ele, vai para todos os
    // e-mails do CNPJ que a régua do banco devolve — os marcados na lista.
    const paraEmails = emailsMarcados;
    if (destinosQuery.isLoading) {
      toast.error('Ainda buscando os e-mails deste cliente', { description: 'Aguarde um instante e envie de novo.' });
      return;
    }
    if (paraEmails.length === 0) {
      toast.error((destinosQuery.data?.emails ?? []).length === 0 ? 'Nenhum e-mail encontrado para este cliente' : 'Marque ao menos um e-mail', {
        description: (destinosQuery.data?.emails ?? []).length === 0
          ? 'Não há e-mail deste CNPJ no CRM. Cadastre o e-mail do Contato Real na aba Contato.'
          : 'Escolha no Para quem recebe a proposta.',
        duration: 7000,
      });
      return;
    }
    if (!dadosEmailProposta) {
      toast.error('Proposta vazia', { description: 'Monte a proposta antes de enviar por e-mail.' });
      return;
    }
    const enviaDoTop = !!previaEmail?.top;
    if (previaEmail && !aberturaEmailAtual.trim()) {
      toast.error('O texto do e-mail está vazio', { description: 'Escreva a abertura na prévia, ou clique em "Texto pronto".' });
      return;
    }
    if (previaEmail && !assuntoEmailAtual.trim()) {
      toast.error('O assunto do e-mail está vazio', { description: 'Escreva o assunto, ou clique em "Texto pronto".' });
      return;
    }
    if (metodoEmailAtual !== 'sendgrid' && previaEmail && !previaEmail.smtp.disponivel) {
      toast.error('Sem SMTP para este consultor', { description: 'Escolha SendGrid, ou cadastre o e-mail próprio (SMTP) em Usuários.' });
      return;
    }

    setEnviandoProposta(true);
    const rotuloMetodo = ROTULO_METODO_EMAIL[metodoEmailAtual];
    const toastId = toast.loading(`Enviando a proposta por e-mail (${rotuloMetodo})...`);
    try {
      // Com a proposta do TOP o e-mail sai dela: não há montador para salvar nem imagem.
      let imagemPath: string | null = null;
      if (!enviaDoTop) {
        if (!await salvarProposta()) throw new Error('A proposta não foi salva. O envio foi interrompido.');
        try {
          imagemPath = (await subirImagemDaProposta()).path;
        } catch (e) {
          console.warn('[proposta-email] imagem da proposta não gerada; segue só com a tabela', e);
        }
      }

      // Sem a prévia carregada, o servidor usa o texto pronto (undefined).
      const dados = await enviarPropostaEmailLead({
        ...dadosEmailProposta,
        destinatarios: paraEmails,
        imagem_path: imagemPath,
        metodo: metodoEmailAtual,
        assunto: previaEmail ? assuntoEmailAtual : undefined,
        abertura_texto: previaEmail ? aberturaEmailAtual : undefined,
        fechamento_texto: previaEmail ? fechamentoEmailAtual : undefined,
        modelo: enviaDoTop ? modeloEmail : undefined,
      });

      toast.dismiss(toastId);
      const enviadosEmail = dados.enviados ?? [];
      const falhasEmail = dados.falhas ?? [];
      const parciaisEmail = dados.parciais ?? [];
      toast.success(enviadosEmail.length === 1 ? `Proposta enviada por e-mail · ${rotuloMetodo}` : `Proposta enviada para ${enviadosEmail.length} e-mails · ${rotuloMetodo}`, {
        description: [
          enviadosEmail.join(', '),
          dados.copia_supervisor ? 'com cópia para o supervisor' : null,
          dados.responder_para ? `as respostas vão para ${dados.responder_para}` : null,
          parciaisEmail.length ? `um dos caminhos falhou em ${parciaisEmail.map((f) => `${f.email} (${f.erro})`).join(', ')}` : null,
          falhasEmail.length ? `não saiu para: ${falhasEmail.map((f) => `${f.email} (${f.erro})`).join(', ')}` : null,
        ].filter(Boolean).join(' · '),
        duration: 9000,
      });
      // A timeline do lead é gravada no backend (PROPOSTA_ENVIADA, canal e-mail).
      queryClient.invalidateQueries({ queryKey: ['destinos-proposta', lead.id] });
      queryClient.invalidateQueries({ queryKey: ['lead-historico', lead.id] });
      queryClient.invalidateQueries({ queryKey: ['lead-envios-mensagem', lead.id] });
    } catch (err) {
      toast.dismiss(toastId);
      toast.error('A proposta NÃO foi enviada', {
        description: err instanceof Error ? err.message : 'Tente novamente em instantes.',
        duration: 9000,
      });
    } finally {
      setEnviandoProposta(false);
    }
  };

  const handleEnviarSmsProposta = async () => {
    if (destinosQuery.isLoading) {
      toast.error('Ainda buscando os celulares deste cliente', { description: 'Aguarde um instante e envie de novo.' });
      return;
    }
    if (telefonesMarcados.length === 0) {
      toast.error((destinosQuery.data?.telefones ?? []).length === 0 ? 'Nenhum celular encontrado para este cliente' : 'Marque ao menos um celular');
      return;
    }
    const texto = textoSmsAtual.trim();
    if (!texto.includes('{link}')) {
      toast.error('O SMS precisa ter o {link}', { description: 'É ele que leva o cliente ao WhatsApp do consultor.' });
      return;
    }
    if (tamanhoSms(texto) > LIMITE_SMS) {
      toast.error(`O SMS ficou com ${tamanhoSms(texto)} caracteres`, { description: `O máximo é ${LIMITE_SMS}: acima disso chega em duas mensagens. Encurte o texto.` });
      return;
    }

    setEnviandoProposta(true);
    const toastId = toast.loading('Enviando SMS...');
    try {
      const modelo = modelosSms.find((m) => m.texto === texto)?.id ?? 'editado';
      const r = await enviarSmsPropostaLead(lead.id, telefonesMarcados, texto, modelo);
      toast.dismiss(toastId);
      toast.success(`SMS enviado para ${r.enviados.length} ${r.enviados.length === 1 ? 'celular' : 'celulares'}`, {
        description: [
          r.falhas.length ? `não saiu para: ${r.falhas.map((f) => formatarTelefone(f.telefone)).join(', ')}` : 'registrado na timeline do lead',
          r.ja_receberam?.length ? `${r.ja_receberam.length} já tinham recebido nos últimos 7 dias e ficaram de fora` : null,
        ].filter(Boolean).join(' · '),
        duration: 8000,
      });
      // A lista volta mostrando "enviado agora" — é o que impede o segundo clique.
      setTelefonesEscolhidos(null);
      queryClient.invalidateQueries({ queryKey: ['destinos-proposta', lead.id] });
      queryClient.invalidateQueries({ queryKey: ['lead-historico', lead.id] });
      queryClient.invalidateQueries({ queryKey: ['lead-detail-modal', lead.id] });
    } catch (err) {
      toast.dismiss(toastId);
      toast.error('O SMS NÃO foi enviado', { description: err instanceof Error ? err.message : 'Tente novamente.', duration: 9000 });
    } finally {
      setEnviandoProposta(false);
    }
  };

  const handleEnviarProposta = async () => {
    if (tipoMensagemAtivo === 'proposta_email') return handleEnviarPropostaEmail();
    if (tipoMensagemAtivo === 'apresentacao_sms') return handleEnviarSmsProposta();
    // VALIDAÇÃO: Contato Real obrigatório antes de enviar proposta
    if (!contato.nome?.trim()) {
      toast.error('Contato Real obrigatório', {
        description: 'Preencha o nome do Contato Real antes de enviar proposta.',
        duration: 6000
      });
      return;
    }
    
    const telefoneEnvio = contato.telefone || lead.telefone;
    const telefoneDigits = telefoneEnvio?.replace(/\D/g, '');
    
    if (!telefoneDigits || telefoneDigits.length < 10) {
      toast.error('Telefone do Contato Real obrigatório', {
        description: 'Preencha um telefone válido do Contato Real (mínimo 10 dígitos) antes de enviar proposta.',
        duration: 6000
      });
      return;
    }
    
    if (!telefoneEnvio) {
      toast.error('Nenhum telefone disponível');
      return;
    }

    // A proposta tem que SAIR PARA O CLIENTE. Barrado na origem: sem isso o
    // consultor gera a interação mandando para a própria linha, e o pedido
    // nasce com tudo "em ordem" sem o cliente ter recebido nada.
    if (await ehNumeroDaCasa(telefoneEnvio)) {
      const conexao = await nomeDaConexaoDoNumero(telefoneEnvio);
      toast.error('Não dá para enviar: esse número é do CRM', {
        description: conexao
          ? `${MENSAGEM_NUMERO_DA_CASA} (linha "${conexao}")`
          : MENSAGEM_NUMERO_DA_CASA,
        duration: 9000,
      });
      return;
    }

    if (enviandoPropostaRef.current) return;
    enviandoPropostaRef.current = true;
    setEnviandoProposta(true);
    const toastId = toast.loading('📱 Enviando proposta...');
    
    try {
      // Salvar proposta antes
      if (!await salvarProposta()) throw new Error('A proposta não foi salva. O envio foi interrompido.');

      // 🆕 PROPOSTA IMAGEM — captura o card visual e sobe pro Storage antes de enviar.
      // O envio continua usando whatsapp-send-tabulacao (que agora aceita media_url).
      let mediaUrlProposta: string | null = null;
      if (tipoMensagemAtivo === 'proposta_imagem') {
        try {
          mediaUrlProposta = (await subirImagemDaProposta()).url;
        } catch (e: any) {
          toast.error('❌ Falha ao gerar/subir imagem da proposta', {
            id: toastId,
            description: e?.message || String(e),
            duration: 7000,
          });
          setEnviandoProposta(false);
          return;
        }
      }

      // Montar mensagem já processada (variáveis substituídas)
      // Pra proposta_imagem, o texto vira CAPTION curta da imagem.
      const legendaCurta = lead.tipo_pessoa === 'PF'
          ? `Olá! Sou ${nomeConsultorProposta || 'Consultor'} da Prime Conecta. Segue a sua proposta Claro. Qualquer dúvida estou por aqui.`
          : `Olá! Sou ${nomeConsultorProposta || 'Consultor'} da Empresarial Prime. Segue a proposta visual para a *${lead.razao_social || lead.nome_fantasia || 'sua empresa'}*. Qualquer dúvida estou por aqui.`;
      // A legenda da imagem é o texto completo da proposta (o detalhe do plano).
      // O WhatsApp corta legenda acima de 1.024 caracteres: aí vai a curta.
      const mensagemFinal = tipoMensagemAtivo === 'proposta_imagem'
        ? (mensagemPropostaGerada && mensagemPropostaGerada.length <= 1024 ? mensagemPropostaGerada : legendaCurta)
        : substituirVariaveis(mensagemAtiva);

      // Determinar tabulacao_id e nome baseado no tipo de mensagem
      const tabulacaoId = ehTipoApresentacao(tipoMensagemAtivo) ? 'apresentacao_comercial'
                        : tipoMensagemAtivo === 'apresentacao_carteira' ? 'apresentacao_carteira'
                        : tipoMensagemAtivo === 'retorno' ? 'retorno_comercial'
                        : tipoMensagemAtivo === 'fechamento' ? 'fechamento_comercial'
                        : 'proposta_comercial';

      const tabulacaoNome = ehTipoApresentacao(tipoMensagemAtivo) ? 'Apresentacao Comercial'
                          : tipoMensagemAtivo === 'apresentacao_carteira' ? 'Apresentacao Carteira'
                          : tipoMensagemAtivo === 'retorno' ? 'Retorno Comercial'
                          : tipoMensagemAtivo === 'fechamento' ? 'Fechamento Comercial'
                          : tipoMensagemAtivo === 'proposta_imagem' ? 'Proposta Comercial (Imagem)'
                          : 'Proposta Comercial';

      // Gerar request_id para rastreabilidade ponta a ponta
      const requestId = crypto.randomUUID();
      console.log('🔗 Envio Proposta - Request ID:', requestId);

      // Formatar telefone para envio
      const telefoneDigits = telefoneEnvio.replace(/\D/g, '');
      const telefoneFormatado = `+${normalizePhoneCountryBR(telefoneDigits)}`;

      // Criar registro de histórico ANTES de enviar (para ter historico_id)
      let historicoId: string | null = null;
      try {
        const { data: historicoData, error: historicoError } = await supabase
          .from('discadora_historico_tabulacao')
          .insert({
            usuario_id: user?.id,
            motivo_id: tabulacaoId,
            fila_id: null, // Comercial não usa fila
            lead_data: {
              cliente_id: lead.cliente_id,
              lead_id: lead.id,
              razao_social: lead.razao_social,
              cnpj: lead.cnpj,
              telefone: telefoneFormatado,
              request_id: requestId,
            },
            observacao: `${tabulacaoNome} via modal comercial`,
          })
          .select('id')
          .single();
        
        if (historicoError) {
          console.warn('⚠️ Erro ao criar histórico pré-envio:', historicoError);
        } else {
          historicoId = historicoData?.id || null;
          console.log('✅ Histórico criado com ID:', historicoId);
        }
      } catch (histErr) {
        console.warn('⚠️ Falha ao criar histórico:', histErr);
      }

      // Chamar edge function whatsapp-send-tabulacao
      const { data, error } = await supabase.functions.invoke('whatsapp-send-tabulacao', {
        body: {
          // Dados do consultor
          // BKO/Qualidade/Gestores enviam em nome do consultor do lead
          consultor_nome: nomeConsultorProposta || 'Consultor',
          consultor_id: canHaveOwnSales(profile?.role) 
            ? user?.id 
            : (dadosLead?.consultor_id || user?.id),
          // ID do executor para fallback de inbox (BKO pode ter inbox configurado)
          executor_id: user?.id,
          fila_nome: 'COMERCIAL',
          
          // ID do histórico para salvar url_conversa
          historico_id: historicoId,
          
          // Request ID para rastreabilidade
          request_id: requestId,
          
          // Dados da "tabulação" - identificador para n8n
          tabulacao_id: tabulacaoId,
          tabulacao_nome: tabulacaoNome,
          message_source: ehTipoApresentacao(tipoMensagemAtivo) ? 'apresentacao_lead'
                        : tipoMensagemAtivo === 'apresentacao_carteira' ? 'apresentacao_carteira_lead'
                        : tipoMensagemAtivo === 'retorno' ? 'retorno_lead'
                        : tipoMensagemAtivo === 'fechamento' ? 'fechamento_lead'
                        : 'proposta_lead',
          
          // MENSAGEM JÁ PROCESSADA (variáveis já substituídas)
          mensagem_template: mensagemFinal,
          ...(lead.tipo_pessoa === 'PF' && ehTipoApresentacao(tipoMensagemAtivo) ? {
            apresentacao_numero: tipoMensagemAtivo === 'apresentacao_3' ? 3 : tipoMensagemAtivo === 'apresentacao_2' ? 2 : 1,
            apresentacao_lead_id: lead.id,
          } : {}),
          ...(tipoMensagemAtivo === 'proposta' && composicaoParaExibir?.linhas.length ? {
            lead_id: lead.id,
            proposta_gerada_backend: true,
          } : {}),
          ...(tipoMensagemAtivo === 'proposta_imagem' && composicaoParaExibir?.linhas.length ? {
            lead_id: lead.id,
          } : {}),

          // 🆕 PROPOSTA IMAGEM — quando presente, edge envia como mídia (image)
          // com caption = mensagemFinal. Sem isso, envia normal como texto.
          ...(mediaUrlProposta ? {
            media_url: mediaUrlProposta,
            media_type: 'image',
            mime_type: 'image/png',
          } : {}),
          
          // Dados do lead
          nome: lead.razao_social,
          cnpj: lead.cnpj,
          razao_social: lead.razao_social,
          telefone: telefoneFormatado,
          numero_tel: telefoneDigits,
          cidade: (lead as any).cidade || '',
          uf: lead.uf || '',
          
          // Dados extras
          email: lead.email || '',
          mei: (lead as any).mei || false,
          
          // Dados de faturamento/proposta
          qtd_linha_movel: parseInt(proposta.linhas_atual) || 0,
          valor_fat_movel: parseFloat(proposta.valor_atual) || 0,
          
          // Dados da proposta - Plano Atual
          linhas_atual: parseInt(proposta.linhas_atual) || 0,
          gb_atual: parseFloat(proposta.gb_atual) || 0,
          valor_atual: parseFloat(proposta.valor_atual) || 0,
          operadora_atual: lead.operadora_atual || '',
          
          // Dados da proposta - Plano Proposto (usando nomes corretos do state)
          linhas_proposto: parseInt(proposta.linhas_novo) || 0,
          gb_proposto: parseFloat(proposta.gb_novo) || 0,
          valor_proposto: parseFloat(proposta.valor_novo) || 0,
          
          // Dados da proposta - Economia (calculados automaticamente)
          economia_mensal: (parseFloat(proposta.valor_atual) || 0) - (parseFloat(proposta.valor_novo) || 0),
          percentual_economia: (parseFloat(proposta.valor_atual) || 0) > 0 
            ? (((parseFloat(proposta.valor_atual) - parseFloat(proposta.valor_novo)) / parseFloat(proposta.valor_atual)) * 100)
            : 0,
          
          // Dados do contato REAL (do lead de renovação)
          contato_real_nome: lead.contato_real_nome || contato.nome || '',
          contato_real_telefone: lead.contato_real_telefone || contato.telefone || '',
          contato_real_email: lead.contato_real_email || contato.email || '',
          contato_real_cargo: lead.contato_real_cargo || contato.cargo || '',
          
          // Dados adicionais do lead de renovação
          status_aptidao: lead.status_aptidao || '',
          status_lead: lead.status_lead || '',
          tempo_contrato_meses: lead.tempo_contrato_voz_num || (lead as any).tempo_contrato_voz || '',
          segmento: (lead as any).segmento || '',
          tipo_lead: lead.tipo_lead || '',
          
          // Mensagem privada baseada no tipo de envio
          mensagem_privada: tipoMensagemAtivo === 'retorno' 
            ? 'Enviado Retorno'
            : tipoMensagemAtivo === 'fechamento'
              ? 'Enviado Fechamento'
              : tipoMensagemAtivo === 'apresentacao_carteira'
                ? 'Enviado Ap. Carteira'
                : `📋 *DADOS DO LEAD*
━━━━━━━━━━━━━━━━━

${lead.tipo_pessoa === 'PF' ? '👤 *Cliente:*' : '🏢 *Empresa:*'} ${lead.razao_social}
📄 *${lead.tipo_pessoa === 'PF' ? 'CPF' : 'CNPJ'}:* ${lead.tipo_pessoa === 'PF' ? (lead as { cpf?: string | null }).cpf || '' : lead.cnpj}
📍 *UF:* ${lead.uf || 'N/A'}

📊 *STATUS*
✅ Aptidão: ${lead.status_aptidao || 'N/A'}
📌 Status: ${lead.status_lead || 'N/A'}
📅 Meses Contrato: ${lead.tempo_contrato_voz_num || (lead as any).tempo_contrato_voz || 'N/A'}

💰 *VALORES*
📱 Linhas: ${proposta.linhas_atual || 0}
💵 Valor Atual: R$ ${proposta.valor_atual || '0'}
💚 Valor Proposta: R$ ${proposta.valor_novo || '0'}
📉 Economia: R$ ${((parseFloat(String(proposta.valor_atual)) || 0) - (parseFloat(String(proposta.valor_novo)) || 0)).toFixed(2)}

👤 *CONTATO REAL*
👤 Nome: ${lead.contato_real_nome || contato.nome || 'N/A'}
📞 Tel: ${lead.contato_real_telefone || contato.telefone || 'N/A'}
📧 Email: ${lead.contato_real_email || contato.email || 'N/A'}`,
        }
      });

      // Determinar tipo de ação para o histórico do lead
      const tipoAcao = ehTipoApresentacao(tipoMensagemAtivo) ? 'APRESENTACAO_ENVIADA'
                     : tipoMensagemAtivo === 'apresentacao_carteira' ? 'APRESENTACAO_CARTEIRA_ENVIADA'
                     : tipoMensagemAtivo === 'retorno' ? 'RETORNO_ENVIADO' 
                     : tipoMensagemAtivo === 'fechamento' ? 'FECHAMENTO_ENVIADO'
                     : 'PROPOSTA_ENVIADA';

      // Detecta falha em DOIS caminhos:
      //  1) `error` setado pelo supabase-js (HTTP non-2xx do gateway)
      //  2) edge retornou 200 mas com `success:false` no body (envio falhou,
      //     ex.: instância Evolution caiu, número não tem WhatsApp etc.)
      // Trata os dois e mostra o erro REAL (não "Edge Function non-2xx").
      const edgeFalhou = !!error || (data && (data as any).success === false);
      if (edgeFalhou) {
        const errMsg =
          (data as any)?.erro_detalhe
          || (data as any)?.error
          || (error as any)?.context?.error
          || (error as any)?.context?.message
          || (error as any)?.message
          || 'Erro ao enviar proposta';
        const logStatusErro = (data as any)?.log_status || (error as any)?.context?.log_status;
        console.error('Erro ao enviar proposta:', error || data, '| Request ID:', requestId);
        if (logStatusErro === 'duplicate_blocked') {
          toast.warning('⚠️ Mensagem já enviada', {
            id: toastId,
            description: 'Essa mensagem já foi enviada pra esse cliente há menos de 1 minuto. Aguarde antes de mandar de novo.',
            duration: 6000,
          });
        } else if (['mesma_proposta_ja_enviada', 'mesma_mensagem_ja_enviada', 'oficial_ja_usada_hoje'].includes(logStatusErro)) {
          toast.warning('Envio segurado', {
            id: toastId,
            description: String(errMsg).slice(0, 300),
            duration: 9000,
          });
        } else {
          toast.error('❌ Falha no envio da proposta', {
            id: toastId,
            description: String(errMsg).slice(0, 300),
            duration: 9000,
          });
        }
        // NÃO grava o tipoAcao quando falhou — evita registro inválido no histórico.
      } else {
        // Sucesso - registrar no histórico do lead
        const logStatus = data?.log_status || 'unknown';
        const urlConversa = data?.url_conversa;
        
        // ✅ REGISTRAR NO HISTÓRICO DO LEAD
        const { error: histError } = data?.historico_lead_registrado === true ? { error: null } : await supabase.from('leads_carteira_historico').insert({
          lead_id: lead.id,
          acao: tipoAcao,
          observacao: urlConversa 
            ? `${tabulacaoNome} enviado via WhatsApp. Status: ${logStatus}`
            : `${tabulacaoNome} enviado via WhatsApp (aguardando url_conversa). Status: ${logStatus}. Request: ${requestId}`,
          usuario_id: user?.id || null,
          dados: {
            tipo: tipoMensagemAtivo,
            telefone_destino: telefoneFormatado,
            request_id: requestId,
            url_conversa: urlConversa || null,
          }
        });
        
        if (histError) {
          console.error('❌ Erro ao registrar histórico:', histError);
          toast.error('⚠️ Histórico não registrado', { description: histError.message });
        } else {
          console.log('✅ Histórico registrado:', tipoAcao);
          queryClient.invalidateQueries({ queryKey: ['lead-envios-mensagem', lead.id] });
          
          // ✅ REGISTRAR NA TIMELINE (tabela movimento) para Proposta, Retorno e Fechamento
          if (['PROPOSTA_ENVIADA', 'RETORNO_ENVIADO', 'FECHAMENTO_ENVIADO'].includes(tipoAcao)) {
            const tipoMovimentoMap: Record<string, string> = {
              'PROPOSTA_ENVIADA': 'proposta_bee',
              'RETORNO_ENVIADO': 'retorno_bee',
              'FECHAMENTO_ENVIADO': 'fechamento_bee',
            };
            const descricaoMap: Record<string, string> = {
              'PROPOSTA_ENVIADA': 'Proposta enviada via WhatsApp',
              'RETORNO_ENVIADO': 'Retorno enviado via WhatsApp',
              'FECHAMENTO_ENVIADO': 'Fechamento enviado via WhatsApp',
            };

            // O evento leva a prévia da proposta: itens, valor novo e economia
            const compEnvio = composicaoParaExibirRef.current;
            const valorNovoEnvio = Number(compEnvio?.totalValor || 0);
            const gbNovoEnvio = Number(compEnvio?.totalGB || 0);
            const valorAtualEnvio = Number(valorAtualParsed || 0);
            const economiaEnvio = valorAtualEnvio > 0 && valorAtualEnvio - valorNovoEnvio > 0 ? valorAtualEnvio - valorNovoEnvio : 0;
            const resumoEnvio = valorNovoEnvio > 0
              ? ` — ${compEnvio!.linhas.length} ${compEnvio!.linhas.length === 1 ? 'item' : 'itens'} · R$ ${valorNovoEnvio.toFixed(2).replace('.', ',')}/mês${economiaEnvio > 0 ? ` · economia R$ ${economiaEnvio.toFixed(2).replace('.', ',')}/mês` : ''}`
              : '';

            const movimentoInsert = {
              cnpj: lead.cnpj || null,
              tipo: tipoMovimentoMap[tipoAcao],
              descricao: `${descricaoMap[tipoAcao]}${resumoEnvio}`,
              usuario_id: user?.id || null,
              entidade: 'lead',
              entidade_id: lead.id,
              payload: {
                ...(lead.pedido_id ? { pedido_id: lead.pedido_id } : {}),
                ...(valorNovoEnvio > 0 ? { valor_novo: valorNovoEnvio, itens: compEnvio!.linhas.length } : {}),
                ...(gbNovoEnvio > 0 ? { gb_novo: gbNovoEnvio } : {}),
                ...(economiaEnvio > 0 ? { economia_mes: economiaEnvio } : {}),
              } as any,
            };
            
            const { error: movError } = await supabase.from('movimento').insert(movimentoInsert);
            if (movError) {
              console.error('❌ Erro ao registrar movimento na timeline:', movError);
            } else {
              console.log('✅ Movimento registrado na timeline:', tipoMovimentoMap[tipoAcao]);
            }
          }
        }

        // ✅ ATUALIZAÇÃO AUTOMÁTICA DE STATUS E DATA DE INTERAÇÃO

        // Atualizar data de interação para TODOS os tipos de mensagem
        const updateData: Record<string, any> = {
          data_ultima_interacao: new Date().toISOString(),
        };
        // Só atualizar tabulacao_id se tivermos um valor válido (nunca sobrescrever com null)
        if (historicoId) {
          updateData.tabulacao_id = historicoId;
        }
        // Salvar URL da conversa interna quando disponível
        if (urlConversa) {
          updateData.url_conversa_bee = urlConversa;
        }

        // PROPOSTA_ENVIADA muda o status_lead para PROPOSTA — nunca em lead que
        // ja virou pedido: o status do lead segue o pedido, e o envio de uma
        // oferta nova (upsell) nao desfaz a venda ja fechada.
        if (tipoAcao === 'PROPOSTA_ENVIADA') {
          if (!leadJaVirouPedido(dadosLead)) {
            updateData.status_lead = 'PROPOSTA';
          }
          updateData.proposta_enviada = true;
        }

        const { error: statusError } = await supabase
          .from('leads_carteira')
          .update(updateData)
          .eq('id', lead.id);
          
        if (statusError) {
          console.error('❌ Erro ao atualizar status:', statusError);
        } else {
          console.log('✅ Lead atualizado:', updateData);
        }

        if (urlConversa) {
          window.open(urlConversa, '_blank');
          toast.success('✅ Proposta enviada! Conversa aberta no Inbox.', { id: toastId });
        } else {
          // Envio sem url_conversa retornada - informar usuário
          toast.success('✅ Proposta enviada!', { id: toastId });
          toast.info('💡 Abra o Inbox manualmente para ver a conversa', {
            duration: 6000,
            description: `Status: ${logStatus}. Request: ${requestId.slice(0, 8)}...`
          });
        }
      }

      // ✅ Invalidar caches CORRETOS para atualizar a UI imediatamente
      queryClient.invalidateQueries({ queryKey: ['lead-historico', lead.id] });
      queryClient.invalidateQueries({ queryKey: ['lead-completo', lead.id], refetchType: 'active' });
      
      // Queries usadas na tela /comercial → Prospecção
      queryClient.invalidateQueries({ queryKey: ['meus-leads-carteira-optimized'], exact: false, refetchType: 'active' });
      queryClient.invalidateQueries({ queryKey: ['leads-prospeccao-hierarquia'], exact: false, refetchType: 'active' });
      
      // Outras queries relacionadas
      queryClient.invalidateQueries({ queryKey: ['gestao-leads'] });
      queryClient.invalidateQueries({ queryKey: ['meus-leads-carteira'] });
      queryClient.invalidateQueries({ queryKey: ['gestao-carteira'] });
      queryClient.invalidateQueries({ queryKey: ['produtividade-consultores'] });
      queryClient.invalidateQueries({ queryKey: ['discadora-historico'] });
    } catch (error) {
      console.error('Erro ao preparar proposta:', error);
      toast.error('Erro ao preparar proposta', { id: toastId });
    } finally {
      enviandoPropostaRef.current = false;
      setEnviandoProposta(false);
      queryClient.invalidateQueries({ queryKey: ['envio-proposta', lead.id] });
    }
  };

  // Função removida - status_lead agora é exibido apenas via BadgeStatusLead

  const InfoRow = ({ label, value, icon: Icon }: { label: string; value?: string | number | null; icon?: React.ElementType }) => (
    <div className="flex items-center justify-between py-2 border-b border-border/50 last:border-0">
      <span className="text-sm text-muted-foreground flex items-center gap-2">
        {Icon && <Icon className="w-4 h-4" />}
        {label}
      </span>
      <span className="text-sm font-medium">{value || '-'}</span>
    </div>
  );

  return (
    <>
    <Dialog open={open} onOpenChange={handleCloseModal}>
      {/* NO CELULAR A FICHA É UMA TELA CHEIA (Douglas 10/10/2026, maquete
          aprovada): abaixo de md a seta volta, o nome da empresa aparece
          inteiro, os botões do topo descem para baixo dele (a Linha 1 vira
          "contents" e cada peça ganha a sua ordem), as abas rolam de lado e
          o rodapé quebra linha. Acima de md nada muda. */}
      <DialogContent className="h-[min(900px,calc(100vh-2rem))] w-[calc(100vw-2rem)] max-w-[1180px] max-h-[calc(100vh-2rem)] flex flex-col p-0 gap-0 overflow-hidden rounded-2xl [&>button.absolute]:hidden max-md:h-[100dvh] max-md:max-h-[100dvh] max-md:w-screen max-md:max-w-none max-md:rounded-none max-md:border-0">
        {/* HEADER — hero vinho (58/59): não inverte com o tema */}
        <DialogHeader className="shrink-0 space-y-0 bg-[linear-gradient(135deg,#4A1320,#5B0A0D_62%,#6E1626)] p-5 pb-4 text-left max-md:px-4 max-md:pb-3 max-md:pt-[max(0.875rem,env(safe-area-inset-top))]">
          {/* Linha 1: Título + Badges + Ações */}
          <div className="flex items-start justify-between gap-3 max-md:contents">
            <DialogTitle className="text-lg font-bold truncate flex-1 flex items-center gap-2 text-white max-md:order-1 max-md:items-start max-md:overflow-visible max-md:whitespace-normal">
              <button
                type="button"
                onClick={() => onOpenChange(false)}
                aria-label="Fechar a ficha"
                title="Fechar"
                className="-ml-1 grid h-7 w-7 flex-shrink-0 place-items-center rounded-lg text-white/90 hover:text-white md:hidden"
              >
                <ArrowLeft className="h-4 w-4" />
              </button>
              {lead.lead_numero && (
                <span className="font-display text-[15px] font-bold text-[#E8B7BE] max-md:mt-[5px] max-md:text-[13px]">#L{lead.lead_numero}</span>
              )}
              <span className="font-display text-[19px] max-md:text-[16px] max-md:leading-snug">{lead.razao_social}</span>
            </DialogTitle>
            
            {/* Badges + Botões de ação */}
            <div className="flex items-center gap-3 shrink-0 max-md:order-3 max-md:mt-2.5 max-md:flex-wrap max-md:gap-2">
              {/* Badge Aptidão — status real (APTO / MKT / NÃO APTO / PROSPECT) */}
              <div className="flex items-center gap-2">
                <BadgeStatusAptidao statusAptidao={lead.status_aptidao || 'PROSPECT'} tipoLead={lead.tipo_lead} sobreVinho />
                <SeloPnPedido desfecho={pnDesfecho} className="h-6 px-2 text-[11px]" />
              </div>
              
              {/* Separador visual */}
              <div className="h-6 w-px bg-white/20" />

              {/* Botões de comunicação compactos - sempre visíveis, desabilitados quando necessário */}
              <div className="flex items-center gap-1.5">
                {telefone && (
                  <Button
                    variant="ghost"
                    size="icon"
                    className="h-8 w-8 rounded-lg border border-white/[0.16] bg-white/[0.10] text-white/90 hover:bg-white/[0.18] hover:text-white"
                    onClick={() => abrirWhatsappDoLead()}
                    title="Abrir conversa no WhatsApp (nova aba)"
                  >
                    <MessageSquare className="w-4 h-4" />
                  </Button>
                )}
                {telefone && <WhatsappBadge telefone={telefone} />}
                <LeadSmsDialog lead={lead as unknown as Record<string, unknown> & { id: string }} />
                {telefone ? (
                  <ClickToCall
                    telefone={telefone}
                    leadId={lead.id}
                    onClick={() => onLigar(telefone)}
                  >
                    <Button 
                      variant="ghost" 
                      size="icon" 
                      className="h-8 w-8 rounded-lg border border-white/[0.16] bg-white/[0.10] text-white/90 hover:bg-white/[0.18] hover:text-white"
                      title="Ligar"
                    >
                      <Phone className="w-4 h-4" />
                    </Button>
                  </ClickToCall>
                ) : (
                  <Button 
                    variant="ghost" 
                    size="icon" 
                    className="h-8 w-8 rounded-lg border border-white/[0.10] bg-white/[0.04] text-white/30 cursor-not-allowed"
                    disabled={true}
                    title="Sem telefone"
                  >
                    <Phone className="w-4 h-4" />
                  </Button>
                )}
                <Button
                  variant="ghost" 
                  size="icon" 
                  className="h-8 w-8 rounded-lg border border-white/[0.16] bg-white/[0.10] text-white/90 hover:bg-white/[0.18] hover:text-white"
                  onClick={copiarDocumento}
                  title={`Copiar ${tipoDocumentoLead}`}
                >
                  <Copy className="w-4 h-4" />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 rounded-lg border border-white/[0.16] bg-white/[0.10] text-white/90 hover:bg-white/[0.18] hover:text-white max-md:hidden"
                  onClick={() => onOpenChange(false)}
                  title="Fechar"
                >
                  <X className="w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>
          
          {/* Linha 2: Info secundária + indicador de salvamento */}
          <div className="flex items-center justify-between mt-2 max-md:order-2 max-md:mt-1.5">
            <p className="text-sm text-white/[0.72] flex items-center gap-2 flex-wrap max-md:gap-x-1.5 max-md:gap-y-0.5 max-md:text-[12.5px]">
              <span className="font-mono">{tipoDocumentoLead} {documentoLeadFormatado}</span>
              <span className="text-white/30">•</span>
              <span>{lead.uf}</span>
              <span className="text-white/30">•</span>
              <span className="flex items-center gap-1">
                {lead.tipo_lead === 'TT_CPF_CNPJ' 
                  ? (() => {
                      const qtdLinhas = [
                        lead.dados_discadora?.movel_1,
                        lead.dados_discadora?.movel_2,
                        lead.dados_discadora?.movel_3,
                        lead.dados_discadora?.movel_4,
                        lead.dados_discadora?.movel_5,
                        lead.dados_discadora?.movel_6
                      ].filter(Boolean).length;
                      return `${qtdLinhas} linhas`;
                    })()
                  : (() => {
                      // Priorizar fatura analisada como fonte de verdade
                      const linhasFatura = dadosFatura?.linhas || 0;
                      const linhasClaro = lead.qtd_linhas_voz || 0;
                      const linhasExibir = linhasFatura > 0 ? linhasFatura : linhasClaro;
                      
                      // Indicador de discrepância
                      const temDiscrepancia = linhasFatura > 0 && linhasClaro > 0 && linhasFatura !== linhasClaro;
                      
                      return (
                        <>
                          {`${linhasExibir} linhas`}
                          {temDiscrepancia && (
                            <Tooltip>
                              <TooltipTrigger asChild>
                                <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-warning text-white text-[10px] font-bold cursor-help">
                                  !
                                </span>
                              </TooltipTrigger>
                              <TooltipContent side="bottom" className="max-w-xs">
                                <p className="text-xs">
                                  <strong>Atenção:</strong> Planilha Claro indica {linhasClaro} linhas, 
                                  mas fatura analisada mostra {linhasFatura}. O cliente pode ter outra conta separada.
                                </p>
                              </TooltipContent>
                            </Tooltip>
                          )}
                        </>
                      );
                    })()
                }
              </span>
              <span className="text-white/30">•</span>
              <span>{tipoLabel}</span>
              {origemMailingLead && (
                <>
                  <span className="text-white/30">•</span>
                  <Badge variant="outline" className="rounded-full border-white/[0.16] bg-white/[0.10] px-1.5 py-0 text-[10px] font-medium text-white">{origemMailingLead}</Badge>
                </>
              )}
              {mapaParqueHeader?.tp_produto && (
                <>
                  <span className="text-white/30">•</span>
                  <Badge variant="outline" className="rounded-full border-white/[0.16] bg-white/[0.10] px-1.5 py-0 text-[10px] text-white">{mapaParqueHeader.tp_produto}</Badge>
                </>
              )}
              {(mapaParqueHeader?.qt_basica_linas ?? 0) > 0 && (
                <>
                  <span className="text-white/30">•</span>
                  <span>{mapaParqueHeader.qt_basica_linas} fixas</span>
                </>
              )}
              {/* Campanha vinculada ao lead */}
              {campanhaNome && (
                <>
                  <span className="text-white/30">•</span>
                  <span className="flex items-center gap-1">
                    <FileText className="h-3 w-3 text-white/45" />
                    <Badge variant="outline" className="rounded-full border-white/[0.16] bg-white/[0.10] px-1.5 py-0 text-[10px] font-medium text-white">{campanhaNome}</Badge>
                  </span>
                </>
              )}
              {/* Consultor responsável */}
              {lead.consultor_nome && (
                <>
                  <span className="text-white/30">•</span>
                  <span className="flex items-center gap-1">
                    <User className="h-3 w-3" />
                    <span className="font-medium">{lead.consultor_nome}</span>
                  </span>
                </>
              )}

              {/* Equipe do consultor */}
              {lead.equipe_nome && (
                <>
                  <span className="text-white/30">•</span>
                  <span className="flex items-center gap-1">
                    <Users className="h-3 w-3" />
                    <span className="font-medium">{lead.equipe_nome}</span>
                  </span>
                </>
              )}
            </p>
            
            {/* Indicador de status de salvamento */}
            <div className="flex items-center gap-1.5 text-xs">
              {statusSalvamento === 'salvando' && (
                <span className="text-white/60 flex items-center gap-1">
                  <Loader2 className="h-3 w-3 animate-spin" />
                  Salvando...
                </span>
              )}
              {statusSalvamento === 'salvo' && (
                <span className="text-[#25D366] flex items-center gap-1">
                  <Check className="h-3 w-3" />
                  Salvo
                </span>
              )}
              {statusSalvamento === 'erro' && (
                <span className="text-[#E88A8A] flex items-center gap-1">
                  <CloudOff className="h-3 w-3" />
                  Erro ao salvar
                </span>
              )}
            </div>
          </div>
        </DialogHeader>

        {/* FAIXA MODO REVISÃO - Visível independente da aba ativa */}
        {emModoRevisao && (
          <div className="flex items-center gap-2 px-6 py-3 bg-warning/5 dark:bg-warning/20 border-b border-warning/40 dark:border-warning shrink-0">
            <AlertTriangle className="h-4 w-4 text-warning shrink-0" />
            <span className="text-sm text-warning dark:text-warning flex-1">
              {isRevisaoCancelado ? (
                <>Corrija a proposta e clique em <strong>Recuperar Pedido</strong>. Não precisa reenviar a proposta: o cliente recebe a confirmação do pedido recuperado com o que ficou.<br /><span className="text-[#7A2235] dark:text-[#C87484]">Linha que o cliente não quer mais: marque e clique em <strong>Deixar canceladas</strong>.</span></>
              ) : (
                <>Corrija a proposta na aba <strong>PROPOSTA</strong> e clique em <strong>"Salvar e Aplicar ao Pedido"</strong>. Não precisa reenviar a proposta: o cliente recebe a confirmação do pedido quando ele for ao BKO.</>
              )}
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={() => setShowCancelRevisaoDialog(true)}
              disabled={cancelandoRevisao || saving || regenerando}
              className="gap-2"
            >
              {cancelandoRevisao ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <ArrowLeft className="h-4 w-4" />
              )}
              Cancelar Revisão
            </Button>
          </div>
        )}

        {dadosLead.status_lead === 'NEGADO' && (
          <div className="shrink-0 px-5 pt-3">
            <LeadNegadoVoltarTrabalhar
              leadId={lead.id}
              motivoNegacao={dadosLead.motivo_negacao}
              confirmando={voltarTrabalharAberto}
              onConfirmandoChange={setVoltarTrabalharAberto}
              temTelefone={!!telefone}
              onLigar={() => { if (telefone) onLigar(telefone); atualizarLeadDepoisDeReabrir(); }}
              onWhatsapp={(janela) => { abrirWhatsappDoLead(janela); atualizarLeadDepoisDeReabrir(); }}
              onProposta={() => setActiveTab('proposta')}
            />
          </div>
        )}

        {/* TABS - conteúdo scrollável */}
        <Tabs value={activeTab} onValueChange={async (tab) => {
          // Forçar save ao sair da aba proposta com composição pendente
          if (activeTab === 'proposta' && tab !== 'proposta' && composicaoParaExibir?.linhas && composicaoParaExibir.linhas.length > 0) {
            console.log('🔀 Saindo da aba proposta — forçando save imediato');
            await executarSaveImediato();
          }
          setActiveTab(tab);
        }} className="flex-1 flex flex-col min-h-0 min-w-0">
          <div className="shrink-0 px-5 pt-3 max-md:px-3 max-md:pt-2">
            {/* Tabs dinâmicas: mostrar PEDIDOS para leads CARTEIRIZADO, CONVERTIDO ou REVISANDO */}
            {(['CARTEIRIZADO', 'CONVERTIDO', 'REVISANDO'].includes(lead.status_lead || '')) ? (
              <TabsList className="h-auto min-w-0 flex-1 justify-center gap-0 overflow-x-auto rounded-none border-b border-border bg-transparent p-0 max-md:flex max-md:w-full max-md:justify-start max-md:[scrollbar-width:none] max-md:[&::-webkit-scrollbar]:hidden">
                <TabsTrigger value="dados" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">DADOS</TabsTrigger>
                <TabsTrigger value="complementar" className="gap-1 rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">
                  <Database className="w-3 h-3" />
                  COMPLEMENTAR
                </TabsTrigger>
                <TabsTrigger value="contato" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">CONTATO</TabsTrigger>
                <TabsTrigger value="proposta" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">PROPOSTA</TabsTrigger>
                <TabsTrigger value="fatura" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">FATURA</TabsTrigger>
                <TabsTrigger value="pedidos" className="gap-1 rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">
                  <FileText className="w-3 h-3" />
                  PEDIDOS
                </TabsTrigger>
                <TabsTrigger value="historico" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">TIMELINE</TabsTrigger>
              </TabsList>
            ) : lead.tipo_lead === 'PORTABILIDADE_VIVO' && lead.dados_master_lead ? (
              <TabsList className="h-auto min-w-0 flex-1 justify-center gap-0 overflow-x-auto rounded-none border-b border-border bg-transparent p-0 max-md:flex max-md:w-full max-md:justify-start max-md:[scrollbar-width:none] max-md:[&::-webkit-scrollbar]:hidden">
                <TabsTrigger value="dados" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">DADOS</TabsTrigger>
                <TabsTrigger value="base-linhas" className="gap-1 rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">
                  <Database className="w-3 h-3" />
                  BASE LINHAS
                </TabsTrigger>
                <TabsTrigger value="complementar" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">COMPLEMENTAR</TabsTrigger>
                <TabsTrigger value="contato" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">CONTATO</TabsTrigger>
                <TabsTrigger value="proposta" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">PROPOSTA</TabsTrigger>
                <TabsTrigger value="fatura" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">FATURA</TabsTrigger>
                <TabsTrigger value="historico" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">TIMELINE</TabsTrigger>
              </TabsList>
            ) : (
              <TabsList className="h-auto min-w-0 flex-1 justify-center gap-0 overflow-x-auto rounded-none border-b border-border bg-transparent p-0 max-md:flex max-md:w-full max-md:justify-start max-md:[scrollbar-width:none] max-md:[&::-webkit-scrollbar]:hidden">
                <TabsTrigger value="dados" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">DADOS</TabsTrigger>
                <TabsTrigger value="complementar" className="gap-1 rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">
                  <Database className="w-3 h-3" />
                  COMPLEMENTAR
                </TabsTrigger>
                <TabsTrigger value="contato" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">CONTATO</TabsTrigger>
                <TabsTrigger value="proposta" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">PROPOSTA</TabsTrigger>
                <TabsTrigger value="fatura" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">FATURA</TabsTrigger>
                <TabsTrigger value="historico" className="rounded-none border-b-2 border-transparent bg-transparent px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground shadow-none transition-colors data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none">TIMELINE</TabsTrigger>
              </TabsList>
            )}
            {lead.tipo_lead === 'RENOVACAO_CLARO' && (dadosFatura?.linhas || 0) > 0 && (() => {
              const comp = (dadosFatura as { competencia?: string } | null)?.competencia;
              const compFmt = comp && /^\d{4}-\d{2}/.test(comp) ? `${comp.slice(5, 7)}/${comp.slice(0, 4)}` : comp || null;
              return (
                <span className="hidden flex-shrink-0 items-center gap-1 border-b border-border pb-2 text-[10.5px] text-muted-foreground md:flex">
                  <FileText className="h-3 w-3" />
                  fatura{compFmt ? <> de <b className="font-semibold text-foreground">{compFmt}</b></> : null} lida pela IA · {dadosFatura!.linhas} linhas
                </span>
              );
            })()}
          </div>

          <div className="min-h-0 flex-1 overflow-auto p-4 max-md:p-3">
            {/* ABA DADOS */}
            <TabsContent value="dados" className="m-0 space-y-4">
              {lead.cpf && !dadosPadrao.data?.camada1 ? <LeadDadosCpfAssertiva cpf={lead.cpf} /> : null}
              {String(lead.tipo_lead) === 'URA' ? <LeadDadosDaLista lead={lead} /> : null}
              {/* DADOS 360 PARA PORTABILIDADE_VIVO */}
              {(lead.tipo_lead === 'RENOVACAO_CPF' || lead.tipo_lead === 'PORTABILIDADE_CPF')
                && (lead.dados_master_lead as { origem_cpf?: string } | null)?.origem_cpf !== 'BASE_VIVO_PF'
                ? <LeadPreviaVendaIaCpf leadId={lead.id} /> : null}
              {TIPOS_LEAD_LISTA_CPF.has(String(lead.tipo_lead)) ? <LeadAberturaListaCpf leadId={lead.id} oi={String(lead.tipo_lead) === 'OI_CPF'} rf={String(lead.tipo_lead) === 'RF_CPF'} /> : null}
              {dadosPadrao.isLoading ? (
                <p className="text-[12px] text-muted-foreground">Carregando os dados do lead…</p>
              ) : dadosPadrao.data?.camada1 ? (
                <LeadDadosPadrao dados={dadosPadrao.data} leadId={lead.id} completando={dadosPadrao.completando} onLigar={onLigar} />
              ) : String(lead.tipo_lead) === 'RETENCAO_CPF' ? (
                <LeadDados360RetencaoCpf lead={lead} onLigar={onLigar} />
              ) : lead.tipo_lead === 'RENOVACAO_CPF' ? (
                <LeadDados360RenovacaoCpf lead={lead} onLigar={onLigar} />
              ) : lead.tipo_lead === 'PORTABILIDADE_CPF' ? (
                <LeadDados360PortabilidadeCpf lead={lead} onLigar={onLigar} />
              ) : lead.tipo_lead === 'PORTABILIDADE_VIVO' ? (
                <LeadDados360Portabilidade lead={lead} onLigar={onLigar} campanhaNome={campanhaNome} />
              ) : lead.tipo_lead === 'TAB' && lead.dados_discadora ? (
                <div className="space-y-4">
                  {/* 67 — Dados da Tabulação no molde: tabulação é origem, não desfecho
                      (o verde estrutural sai); pares de 30px com hairline, sem ícone
                      por linha — só o Phone como ação de ligar. */}
                  {(() => {
                    const dd = lead.dados_discadora;
                    const cepDigits = String(dd.cep || '').replace(/\D/g, '');
                    const cepFmt = cepDigits.length === 8 ? `${cepDigits.slice(0, 5)}-${cepDigits.slice(5)}` : (dd.cep || null);
                    const norm = (t: string) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase();
                    const enderecoLimpo = (() => {
                      let s = String(dd.endereco_completo || '').trim();
                      if (!s) return null;
                      if (cepDigits) s = s.replace(cepDigits, '');
                      const ufTx = String(dd.uf || lead.uf || '').trim();
                      if (ufTx) s = s.replace(new RegExp(`\\s+${ufTx}\\s*$`, 'i'), '');
                      const cidadeTx = String(dd.cidade || '').trim();
                      if (cidadeTx) {
                        const idx = norm(s).lastIndexOf(norm(cidadeTx));
                        if (idx >= 0) s = s.slice(0, idx) + s.slice(idx + cidadeTx.length);
                      }
                      return s.replace(/\s{2,}/g, ' ').trim().replace(/[,\s]+$/, '') || null;
                    })();
                    const comCobertura = norm(String(dd.cobertura || '')).includes('COM COBERTURA');
                    const Par = ({ label, valor, acao }: { label: string; valor?: React.ReactNode; acao?: React.ReactNode }) => (
                      <div className="flex h-[30px] items-center justify-between gap-3 border-b border-[#F0E9E1] last:border-b-0 dark:border-white/[0.05] max-md:h-auto max-md:min-h-[30px] max-md:py-1">
                        <span className="flex-shrink-0 text-[11px] text-muted-foreground">{label}</span>
                        <span className="flex min-w-0 items-center gap-1.5 text-right text-xs font-semibold tabular-nums text-[#2E2019] dark:text-[#E8DEDE] max-md:[overflow-wrap:anywhere]">
                          {valor ?? <span className="font-normal text-muted-foreground/40">—</span>}
                          {acao}
                        </span>
                      </div>
                    );
                    return (
                      <section className="overflow-hidden rounded-xl border border-border bg-card">
                        <div className="flex min-h-[34px] items-center gap-2 border-b bg-[#FBFAF9] px-3.5 py-1.5 dark:bg-white/[0.02]">
                          <h3 className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.08em] text-card-foreground">
                            <Database className="h-3 w-3 text-muted-foreground" /> Dados da Tabulação
                          </h3>
                          <span className="inline-flex items-center rounded-full border border-border bg-[#F2EEE8] px-2 py-0.5 text-[9px] font-bold uppercase tracking-wide text-muted-foreground dark:bg-white/[0.06]">Discadora</span>
                        </div>
                        <div className="grid gap-x-6 px-3.5 py-2 md:grid-cols-2">
                          <div className="min-w-0">
                            <p className="pt-1 text-[9.5px] font-bold uppercase tracking-[0.08em] text-muted-foreground">Empresa</p>
                            <Par label="CNPJ" valor={lead.cnpj ? formatarCNPJ(lead.cnpj) : null} />
                            <Par label="Razão social" valor={lead.razao_social || null} />
                            <Par
                              label="Operadora atual"
                              valor={dd.operadora ? (
                                <span className="inline-flex items-center gap-1"><ShieldCheck className="h-[11px] w-[11px] text-muted-foreground" />{dd.operadora}</span>
                              ) : null}
                            />
                            <Par
                              label="Cobertura"
                              valor={dd.cobertura ? (
                                comCobertura ? (
                                  <span className="inline-flex items-center gap-1.5 text-[10px] font-bold lowercase text-[#075E54] dark:text-[#25D366]">
                                    <span className="h-1.5 w-1.5 rounded-full bg-[#075E54] dark:bg-[#25D366]" />com cobertura
                                  </span>
                                ) : String(dd.cobertura).toLowerCase()
                              ) : null}
                            />
                            <Par label="Crédito" valor={dd.credito || null} />
                            <Par label="É MEI?" valor={dd.mei ? 'Sim' : 'Não'} />
                            <p className="pt-2 text-[9.5px] font-bold uppercase tracking-[0.08em] text-muted-foreground">Contato</p>
                            <Par label="E-mail" valor={dd.email || null} />
                            <Par
                              label="Telefone"
                              valor={dd.telefone ? formatarTelefone(dd.telefone) : null}
                              acao={dd.telefone ? (
                                <ClickToCall telefone={dd.telefone} leadId={lead.id}>
                                  <span className="inline-flex h-5 w-5 cursor-pointer items-center justify-center rounded-md text-primary hover:bg-primary/10 dark:text-[#C87484]" title="Ligar">
                                    <Phone className="h-[11px] w-[11px]" />
                                  </span>
                                </ClickToCall>
                              ) : undefined}
                            />
                          </div>
                          <div className="min-w-0">
                            <p className="pt-1 text-[9.5px] font-bold uppercase tracking-[0.08em] text-muted-foreground">Localização</p>
                            <Par label="Endereço" valor={enderecoLimpo ? <span className="truncate font-semibold" title={String(dd.endereco_completo || '')}>{enderecoLimpo}</span> : null} />
                            <Par label="Cidade" valor={dd.cidade || null} />
                            <Par label="UF" valor={dd.uf || lead.uf || null} />
                            <Par label="CEP" valor={cepFmt} />
                          </div>
                        </div>
                      </section>
                    );
                  })()}

                  {/* Card de status e datas */}
                  <Card>
                    <CardHeader className="pb-2">
                      <CardTitle className="text-sm flex items-center gap-2">
                        <Calendar className="w-4 h-4" /> Status e Datas
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <div className="grid md:grid-cols-3 gap-4">
                        <div className="flex items-center justify-between py-1">
                          <span className="text-sm text-muted-foreground">Status</span>
                          <BadgeStatusAptidao statusAptidao={lead.status_aptidao || 'PROSPECT'} tipoLead={lead.tipo_lead} sobreVinho />
                        </div>
                        <InfoRow 
                          label="Data Criação" 
                          value={lead.created_at ? format(new Date(lead.created_at), 'dd/MM/yyyy HH:mm') : undefined} 
                        />
                        <InfoRow 
                          label="Última Interação" 
                          value={lead.data_ultima_interacao ? format(new Date(lead.data_ultima_interacao), 'dd/MM/yyyy HH:mm') : undefined} 
                        />
                      </div>
                    </CardContent>
                  </Card>
                </div>
              ) : lead.tipo_lead === 'TT_CPF_CNPJ' ? (
                <LeadDados360TT lead={lead} onLigar={onLigar} campanhaNome={campanhaNome} />
              ) : String(lead.tipo_lead) === 'URA' && String((lead.dados_discadora as Record<string, unknown> | null)?.origem_mailing || '').toUpperCase().startsWith('ALGAR') ? (
                <LeadDados360Algar lead={lead} onLigar={onLigar} campanhaNome={campanhaNome} />
              ) : String(lead.tipo_lead) === 'URA' && String((lead.dados_discadora as Record<string, unknown> | null)?.origem_mailing || '').toUpperCase() === 'OI' ? (
                <LeadDados360Oi lead={lead} onLigar={onLigar} campanhaNome={campanhaNome} />
              ) : String(lead.tipo_lead) === 'ALGAR_CPF' ? (
                <LeadDados360Algar lead={lead} onLigar={onLigar} campanhaNome={campanhaNome} />
              ) : String(lead.tipo_lead) === 'OI_CPF' ? (
                <LeadDados360Oi lead={lead} onLigar={onLigar} campanhaNome={campanhaNome} />
              ) : lead.tipo_lead === 'ALGAR' ? (
                <LeadDados360Algar lead={lead} onLigar={onLigar} campanhaNome={campanhaNome} />
              ) : lead.tipo_lead === 'ECOSSISTEMA_API' ? (
                <LeadDados360Api lead={lead} onLigar={onLigar} campanhaNome={campanhaNome} />
              ) : lead.tipo_lead === 'OI' ? (
                <LeadDados360Oi lead={lead} onLigar={onLigar} campanhaNome={campanhaNome} />
              ) : (
                <LeadPerfilInteligente lead={lead} onLigar={onLigar} campanhaNome={campanhaNome} />
              )}

              {/* A aba Dados não manda mensagem (Douglas 06/10/2026): SMS, WhatsApp e
                  e-mail saem da aba Proposta. */}
            </TabsContent>

            {/* ABA DADOS COMPLEMENTAR - Hub de Inteligência */}
            <TabsContent value="complementar" className="m-0 space-y-3">
              {/* 62a — TELEFONES ENCONTRADOS primeiro: fonte-neutra, chips de origem.
                  Lead CPF não tem CNPJ nem doc_cpf (Douglas 03/10/2026: "não posso perder
                  estes dados no front"): mostra o CNPJ da empresa de origem e o CPF dele. */}
              <TelefonesEncontradosCard
                cnpj={lead.cnpj || cnpjDaOrigem}
                onLigar={onLigar}
                onWhatsApp={(tel) => abrirConversa(tel, { novaAba: true })}
                onUsarNoContato={(tel) => {
                  contatoEditadoManualmenteRef.current = true;
                  setContato((prev) => ({ ...prev, telefone: tel }));
                  setActiveTab('contato');
                  toast.success('Número levado para o formulário do Contato');
                }}
              />

              {/* Enriquecimento Assertiva (API) */}
              <AssertivaDadosCard cnpj={lead.cnpj || cnpjDaOrigem || null} cpf={lead.doc_cpf || lead.cpf} email={lead.email} telefone={lead.telefone} nomeProprietario={lead.nome_proprietario} razaoSocial={lead.razao_social} leadId={lead.id} />

              {/* SEÇÃO 2: Base Operadora (Vivo) - Collapsible igual Assertiva */}
              <Collapsible open={vivoOpen} onOpenChange={setVivoOpen}>
                <Card className="relative overflow-hidden rounded-xl border-border pl-1">
                  <span aria-hidden className="absolute inset-y-0 left-0 w-1 bg-[linear-gradient(180deg,#6E1626,#4E1522_55%,#3E0E1B)]" />
                  <CollapsibleTrigger asChild>
                    <CardHeader className="cursor-pointer px-4 py-0 transition-colors hover:bg-muted/40">
                      <div className="flex h-[38px] items-center gap-2">
                        {vivoOpen ? <ChevronDown className="h-4 w-4 text-muted-foreground" /> : <ChevronRight className="h-4 w-4 text-muted-foreground" />}
                        <Smartphone className="h-3.5 w-3.5 text-muted-foreground" />
                        <CardTitle className="text-[11px] font-bold uppercase tracking-[0.08em] text-foreground">Base Operadora (Vivo)</CardTitle>
                        <span className="min-w-0 flex-1" />
                        <span className="flex-shrink-0 text-[10.5px] text-muted-foreground">{vivoOpen ? '' : 'abrir para ver o parque da operadora'}</span>
                      </div>
                    </CardHeader>
                  </CollapsibleTrigger>
                  <CollapsibleContent>
                    <CardContent className="px-3 pb-3 pt-0">
                      <LeadParqueVivoTab cnpj={lead.cnpj} leadId={lead.id} />
                    </CardContent>
                  </CollapsibleContent>
                </Card>
              </Collapsible>

              {/* SEÇÃO 3: Dados Credlink - Collapsible igual Assertiva */}
              <Collapsible open={credlinkOpen} onOpenChange={setCredlinkOpen}>
                <Card className="relative overflow-hidden rounded-xl border-border pl-1">
                  <span aria-hidden className="absolute inset-y-0 left-0 w-1 bg-[linear-gradient(180deg,#6E1626,#4E1522_55%,#3E0E1B)]" />
                  <CollapsibleTrigger asChild>
                    <CardHeader className="cursor-pointer px-4 py-0 transition-colors hover:bg-muted/40">
                      <div className="flex h-[38px] items-center gap-2">
                        {credlinkOpen ? <ChevronDown className="h-4 w-4 text-muted-foreground" /> : <ChevronRight className="h-4 w-4 text-muted-foreground" />}
                        <Database className="h-3.5 w-3.5 text-muted-foreground" />
                        <CardTitle className="text-[11px] font-bold uppercase tracking-[0.08em] text-foreground">Dados Credlink</CardTitle>
                        <span className="min-w-0 flex-1" />
                        <span className="flex-shrink-0 text-[10.5px] text-muted-foreground">{credlinkOpen ? '' : 'cadastro, situação e faturamento presumido'}</span>
                      </div>
                    </CardHeader>
                  </CollapsibleTrigger>
                  <CollapsibleContent>
                    <CardContent className="px-3 pb-3 pt-0">
                      <LeadDadosComplementarTab cnpj={lead.cnpj} onLigar={onLigar} />
                    </CardContent>
                  </CollapsibleContent>
                </Card>
              </Collapsible>

              {/* SEÇÃO 4: Ecossistema API (Dossiê CNPJ completo) */}
              <Collapsible open={ecossistemaOpen} onOpenChange={setEcossistemaOpen}>
                <Card className="relative overflow-hidden rounded-xl border-border pl-1">
                  <span aria-hidden className="absolute inset-y-0 left-0 w-1 bg-[linear-gradient(180deg,#6E1626,#4E1522_55%,#3E0E1B)]" />
                  <CollapsibleTrigger asChild>
                    <CardHeader className="cursor-pointer px-4 py-0 transition-colors hover:bg-muted/40">
                      <div className="flex h-[38px] items-center gap-2">
                        {ecossistemaOpen ? <ChevronDown className="h-4 w-4 text-muted-foreground" /> : <ChevronRight className="h-4 w-4 text-muted-foreground" />}
                        <Sparkles className="h-3.5 w-3.5 text-muted-foreground" />
                        <CardTitle className="text-[11px] font-bold uppercase tracking-[0.08em] text-foreground">Ecossistema API (Dossiê CNPJ)</CardTitle>
                        <span className="min-w-0 flex-1" />
                        <span className="flex-shrink-0 text-[10.5px] text-muted-foreground">{ecossistemaOpen ? '' : 'CNAE, quadro societário e participações'}</span>
                      </div>
                    </CardHeader>
                  </CollapsibleTrigger>
                  <CollapsibleContent>
                    <CardContent className="px-3 pb-3 pt-0">
                      <LeadDados360Api lead={dadosLead as LeadCarteira} />
                    </CardContent>
                  </CollapsibleContent>
                </Card>
              </Collapsible>

            </TabsContent>

            {/* ABA CONTATO */}
            <TabsContent value="contato" className="m-0 space-y-4">
              {/* A consulta de empresa aplica-se somente ao CNPJ. */}
              {lead.tipo_pessoa !== 'PF' && <div className="relative overflow-hidden rounded-xl border border-border bg-card pl-1">
                <span aria-hidden className="absolute inset-y-0 left-0 w-1 bg-[linear-gradient(180deg,#6E1626,#4E1522_55%,#3E0E1B)]" />
                <div className="flex items-center justify-between gap-3 border-b border-border px-4 py-2">
                  <div className="flex items-center gap-2">
                    <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-foreground">Consulta Receita Federal</p>
                    <Badge variant="outline" className="rounded-full border-primary/40 px-1.5 py-0 text-[9px] font-bold uppercase tracking-wider text-primary">Antes do pedido</Badge>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-[10px] text-muted-foreground">fonte: Receita Federal{dadosRFLocal?.source === 'cache' ? ' · em cache' : ''}</span>
                    <Button 
                      variant="outline" 
                      size="sm" 
                      onClick={async () => {
                        if (lead?.cnpj) {
                          const result = await consultarCNPJ(lead.cnpj);
                          if (result) {
                            setDadosRFCache(prev => ({ ...prev, [cnpjLimpo]: result }));
                          }
                        }
                      }}
                      disabled={loadingRF}
                      className="h-7 px-2 text-xs"
                    >
                      <RefreshCw className={`w-3 h-3 mr-1 ${loadingRF ? 'animate-spin' : ''}`} />
                      Atualizar
                    </Button>
                  </div>
                </div>
                <div className="p-4">
                  {loadingRF && !dadosRFLocal ? (
                    <div className="space-y-2">
                      <Skeleton className="h-4 w-full" />
                      <Skeleton className="h-4 w-3/4" />
                    </div>
                  ) : dadosRFLocal?.data ? (() => {
                    const rf = dadosRFLocal.data;
                    const situNorm = String(rf.situacao_cadastral || '')
                      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                      .trim().toUpperCase();
                    const ativa = situNorm === 'ATIVA' || situNorm === 'ATIVO';
                    const enderecoOficial = rf.endereco_rua
                      ? `${rf.endereco_rua}, ${rf.endereco_numero || 'S/N'} - ${rf.endereco_cidade || ''}/${rf.endereco_uf || ''}`
                      : null;
                    const fmtDataRf = (v?: string | null) => {
                      const m = String(v || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
                      return m ? `${m[3]}/${m[2]}/${m[1]}` : (v || null);
                    };
                    return (
                      <div className="grid gap-5 md:grid-cols-[minmax(240px,300px)_minmax(0,1fr)]">
                        <div>
                          <div className="flex items-center gap-3">
                            <span className={`grid h-11 w-11 flex-shrink-0 place-items-center rounded-full border ${ativa ? 'border-[#075E54]/30 bg-[#075E54]/[0.10]' : 'border-primary/25 bg-primary/[0.08]'}`}>
                              {ativa ? <Check className="h-5 w-5 text-[#075E54] dark:text-[#25D366]" /> : <X className="h-5 w-5 text-primary dark:text-[#C87484]" />}
                            </span>
                            <span className={`font-display text-[30px] font-bold uppercase leading-none tracking-tight ${ativa ? 'text-[#075E54] dark:text-[#25D366]' : 'text-primary dark:text-[#C87484]'}`}>
                              {rf.situacao_cadastral || 'SEM DADO'}
                            </span>
                          </div>
                          {fmtDataRf(rf.data_inicio_atividade) && (
                            <p className="mt-1.5 text-xs text-muted-foreground">desde {fmtDataRf(rf.data_inicio_atividade)}</p>
                          )}
                          <div className={`mt-3 flex items-start gap-2 rounded-lg border px-3 py-2.5 text-xs leading-snug ${ativa ? 'border-[#075E54]/30 bg-[#075E54]/[0.05] text-muted-foreground' : 'border-primary/25 bg-primary/[0.04]'}`}>
                            <AlertTriangle className={`mt-px h-3.5 w-3.5 shrink-0 ${ativa ? 'text-[#075E54] dark:text-[#25D366]' : 'text-primary dark:text-[#C87484]'}`} />
                            <span>
                              {ativa
                                ? <><b className="font-bold text-[#075E54] dark:text-[#25D366]">Livre para pedido</b> — a empresa está regular.</>
                                : <><b className="font-bold text-primary dark:text-[#C87484]">Não envie pedido</b> — empresa irregular na Receita. Confirme a situação com o cliente antes de seguir.</>}
                            </span>
                          </div>
                        </div>
                        <div className="text-sm">
                          {[
                            {
                              Icone: Users, rotulo: 'Sócio-administrador',
                              valor: rf.socios && rf.socios.length > 0
                                ? <span className="font-bold uppercase" title={rf.socios.map((so: any) => `${so.nome}${so.qualificacao ? ` (${so.qualificacao})` : ''}`).join(', ')}>{rf.socios.map((so: any) => so.nome).join(', ')}</span>
                                : <span className="font-normal text-muted-foreground">Sem sócios cadastrados</span>,
                            },
                            {
                              Icone: Phone, rotulo: 'Telefone na Receita',
                              valor: (rf.telefone_formatado || rf.telefone_principal)
                                ? <ClickToCall telefone={rf.telefone_principal || rf.telefone_formatado} leadId={lead.id}><span className="cursor-pointer font-bold tabular-nums text-foreground hover:text-primary hover:underline">{rf.telefone_formatado || rf.telefone_principal}</span></ClickToCall>
                                : <span className="font-normal text-muted-foreground">Não informado</span>,
                            },
                            {
                              Icone: MapPin, rotulo: 'Endereço oficial',
                              valor: enderecoOficial
                                ? <span className="font-bold uppercase" title={enderecoOficial}>{enderecoOficial}</span>
                                : <span className="font-normal text-muted-foreground">Endereço não informado</span>,
                            },
                          ].map(({ Icone, rotulo, valor }) => (
                            <div key={rotulo} className="flex items-center justify-between gap-4 border-b border-border py-2.5 last:border-b-0">
                              <span className="flex flex-shrink-0 items-center gap-2 text-muted-foreground"><Icone className="h-4 w-4" />{rotulo}</span>
                              <span className="min-w-0 truncate text-right text-foreground">{valor}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })() : (
                    <p className="text-sm text-muted-foreground">
                      Clique em "Atualizar" para consultar a situação da empresa na Receita Federal.
                    </p>
                  )}
                </div>
              </div>}

              {/* Regras de convergência REMOVIDAS desta aba (Douglas 28/08) — a
                  justificativa continua valendo no fechamento do pedido; só a
                  prosa saiu desta tela. */}

              {/* 60 — CONTATO REAL: pessoas, não formulário */}
              <div className="relative overflow-hidden rounded-xl border border-border bg-card pl-1">
                <span aria-hidden className="absolute inset-y-0 left-0 w-1 bg-[linear-gradient(180deg,#6E1626,#4E1522_55%,#3E0E1B)]" />
                <div className="flex items-center justify-between gap-3 border-b border-border px-4 py-2">
                  <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.08em] text-foreground">
                    <User className="h-3.5 w-3.5 text-muted-foreground" />Contato real
                  </p>
                  <span className="text-[10.5px] text-muted-foreground">{(contato.nome?.trim() || contato.telefone?.trim()) ? '1 contato' : '0 contatos'}</span>
                  {contatoOrigemMaster && (
                    <Badge variant="outline" className="rounded-full border-[#075E54]/40 bg-[#075E54]/[0.06] px-1.5 py-0 text-[9px] font-bold uppercase tracking-wider text-[#075E54] dark:text-[#25D366]">
                      <Database className="mr-1 h-3 w-3" />
                      Encontrado no CRM
                    </Badge>
                  )}
                </div>
                <div className="space-y-3 p-4">
                  {(contato.nome?.trim() || contato.telefone?.trim()) ? (
                    <div className="flex items-center gap-3 rounded-lg border border-border bg-muted/40 px-3 py-2.5">
                      <span className="grid h-8 w-8 flex-shrink-0 place-items-center rounded-full bg-primary/10 text-[10px] font-bold text-primary">
                        {(contato.nome || '?').trim().split(/\s+/).filter(Boolean).slice(0, 2).map((par) => par[0]).join('').toUpperCase() || '?'}
                      </span>
                      <div className="min-w-0 flex-1">
                        <p className="truncate text-sm font-semibold text-foreground">{contato.nome || '—'}</p>
                        <p className="truncate text-xs text-muted-foreground">
                          {[contato.cargo, contato.email].filter(Boolean).join(' · ') || 'sem cargo/e-mail'}
                        </p>
                      </div>
                      <span className="flex-shrink-0 text-sm tabular-nums text-muted-foreground">{contato.telefone || '—'}</span>
                      {contato.telefone && (
                        <div className="flex flex-shrink-0 items-center gap-1.5">
                          <ClickToCall telefone={contato.telefone} leadId={lead.id}>
                            <Button variant="outline" size="sm" className="h-7 px-2 text-xs"><Phone className="mr-1 h-3 w-3" />Ligar</Button>
                          </ClickToCall>
                          <Button variant="outline" size="sm" className="h-7 px-2 text-xs" onClick={() => abrirConversa(contato.telefone, { novaAba: true })}>
                            <MessageSquare className="mr-1 h-3 w-3" />WhatsApp
                          </Button>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-dashed border-border bg-muted/30 px-3 py-2.5 text-sm text-muted-foreground">
                      <span className="min-w-0 flex-1">
                        Nenhum contato salvo{(dadosRFLocal?.data?.telefone_formatado || dadosRFLocal?.data?.telefone_principal)
                          ? <> — o telefone da Receita é o ponto de partida: <b className="tabular-nums text-foreground">{dadosRFLocal.data.telefone_formatado || dadosRFLocal.data.telefone_principal}</b></>
                          : '.'}
                      </span>
                      {(dadosRFLocal?.data?.telefone_formatado || dadosRFLocal?.data?.telefone_principal) && (
                        <div className="flex flex-shrink-0 items-center gap-1.5">
                          <ClickToCall telefone={dadosRFLocal.data.telefone_principal || dadosRFLocal.data.telefone_formatado} leadId={lead.id}>
                            <Button variant="outline" size="sm" className="h-7 px-2 text-xs"><Phone className="mr-1 h-3 w-3" />Ligar</Button>
                          </ClickToCall>
                          <Button variant="outline" size="sm" className="h-7 px-2 text-xs"
                            onClick={() => { contatoEditadoManualmenteRef.current = true; setContato({ ...contato, telefone: dadosRFLocal.data.telefone_formatado || dadosRFLocal.data.telefone_principal || '' }); }}>
                            Usar no formulário
                          </Button>
                        </div>
                      )}
                    </div>
                  )}

                  {/* formulário compacto — uma linha, no formato do desenho */}
                  <div className="grid items-end gap-3 md:grid-cols-[minmax(0,1.3fr)_170px_minmax(0,1fr)_minmax(0,1.2fr)_auto]">
                    <div className="space-y-1.5">
                      <Label className="text-[10px] font-bold uppercase tracking-[0.08em] text-muted-foreground">Nome do contato <span className="text-primary">*</span></Label>
                      <Input className="h-10" value={contato.nome}
                        onChange={(e) => { contatoEditadoManualmenteRef.current = true; setContato({ ...contato, nome: e.target.value }); }}
                        placeholder="Nome completo" />
                    </div>
                    <div className="space-y-1.5">
                      <Label className="text-[10px] font-bold uppercase tracking-[0.08em] text-muted-foreground">Telefone <span className="text-primary">*</span></Label>
                      <Input className="h-10 tabular-nums" value={contato.telefone}
                        onChange={(e) => { contatoEditadoManualmenteRef.current = true; setContato({ ...contato, telefone: e.target.value }); }}
                        placeholder="(00) 00000-0000" />
                    </div>
                    <div className="space-y-1.5">
                      <Label className="text-[10px] font-bold uppercase tracking-[0.08em] text-muted-foreground">Cargo</Label>
                      <Input className="h-10" value={contato.cargo}
                        onChange={(e) => { contatoEditadoManualmenteRef.current = true; setContato({ ...contato, cargo: e.target.value }); }}
                        placeholder="Ex.: Gerente, Diretor" />
                    </div>
                    <div className="space-y-1.5">
                      <Label className="text-[10px] font-bold uppercase tracking-[0.08em] text-muted-foreground">E-mail</Label>
                      <Input className="h-10" type="email" value={contato.email}
                        onChange={(e) => { contatoEditadoManualmenteRef.current = true; setContato({ ...contato, email: e.target.value }); }}
                        placeholder="email@empresa.com" />
                    </div>
                    <Button onClick={salvarContato} disabled={saving}
                      className="h-10 border-0 bg-[linear-gradient(90deg,#4A1320,#5B0A0D)] px-4 text-[12.5px] font-bold text-white shadow-[0_2px_6px_rgba(91,10,13,0.30)] transition-all hover:brightness-110 dark:bg-[linear-gradient(90deg,#9D2530,#6C2236)]">
                      {saving ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <Save className="mr-1.5 h-3.5 w-3.5" />}
                      Salvar contato
                    </Button>
                  </div>
                  <p className="text-[10px] text-muted-foreground">nome e telefone são obrigatórios · o contato salvo vira o destino do WhatsApp e das propostas</p>
                </div>
              </div>
            </TabsContent>

            {/* ABA PROPOSTA - forceMount para preservar estado do Montador */}
            <TabsContent value="proposta" className="m-0 h-full" forceMount>
              <div className={`space-y-3 ${activeTab === 'proposta' ? '' : 'hidden'}`}>
              {/* SEÇÃO DINÂMICA - O que o cliente tem (baseado no tipo_lead).
                  Escondida em TODOS os leads (Douglas 06/10/2026: "isso é padrão em todas
                  as propostas"): a prévia de proposta do TOP tomou o lugar do plano atual.
                  Segue montada porque é ela que preenche a proposta com os valores de hoje
                  (parque, fatura e linhas). A fatura se envia pela aba Fatura. */}
              <div className="hidden">
              {lead.tipo_lead === 'RENOVACAO_CLARO' ? (
                <PlanoAtualRenovacao 
                  dadosFatura={dadosFatura}
                  lead={lead}
                  cnpj={lead.cnpj}
                  clienteId={lead.cliente_id}
                  ocultarPlanoAtual={proposta.ocultar_plano_atual}
                  onToggleOcultar={handleToggleOcultarPlanoAtual}
                  onFaturaUpload={() => {
                    // Refetch dados após upload manual
                    queryClient.invalidateQueries({ queryKey: ['fatura-resumo-lead', lead.cliente_id, lead.cnpj] });
                    queryClient.invalidateQueries({ queryKey: ['gestao-leads'] });
                    queryClient.invalidateQueries({ queryKey: ['meus-leads-carteira-optimized'] });
                  }}
                  onLinhasManuaisChange={setLinhasManuaisRenovacao}
                  onAplicarSugestao={renovacaoSomenteLeitura ? undefined : aplicarSugestaoDaFatura}
                />
              ) : lead.tipo_lead === 'PORTABILIDADE_VIVO' ? (
                <PlanoAtualPortabilidade 
                  lead={lead}
                  plantaVivoSnapshot={plantaVivoSnapshot}
                  proposta={proposta}
                  onPropostaChange={handlePropostaChange}
                  ocultarPlanoAtual={proposta.ocultar_plano_atual}
                  onToggleOcultar={handleToggleOcultarPlanoAtual}
                  ocultarPlanoFixo={proposta.ocultar_plano_fixo}
                  onToggleOcultarFixo={handleToggleOcultarPlanoFixo}
                  onIrParaFatura={() => setActiveTab('fatura')}
                  compactoMovel
                  semMovel={!!previaTopQuery.data}
                  semFixo={!!previaTopQuery.data}
                />
              ) : (
                <PlanoAtualTT 
                  lead={lead}
                  proposta={proposta}
                  onPropostaChange={handlePropostaChange}
                  qtdLinhasAtuais={qtdLinhasAtuais}
                  ocultarPlanoAtual={proposta.ocultar_plano_atual}
                  onToggleOcultar={handleToggleOcultarPlanoAtual}
                />
              )}
              </div>

              {/* Renovação do lead CPF: a conta e a simulação ficam acima do montador (Douglas 25/09/2026) */}
              {lead.tipo_pessoa === 'PF' && (
                <ContaRenovacaoCpf
                  leadId={lead.id}
                  composicao={composicaoParaExibir || null}
                  onComposicaoChange={handleComposicaoChange}
                />
              )}

              {previaTopQuery.data ? (
                <PreviaPropostaTopCard leadId={lead.id} dados={previaTopQuery.data} onUsar={usarPropostaPronta} />
              ) : (
                <LeadPropostaEnviadaEmail leadId={lead.id} />
              )}

              {/* MONTADOR MANUAL - key por lead para reiniciar ao trocar */}
              <MontadorComposicaoPlano
                key={`montador-${lead.id}`}
                tipoPessoa={lead.tipo_pessoa === 'PF' ? 'PF' : 'PJ'}
                clienteId={lead.cliente_id}
                razaoSocial={lead.razao_social}
                linhasIniciais={linhasAtuaisMemo}
                linhasDetalhadas={linhasDetalhadasMemo}
                valorAtual={valorAtualParsed}
                composicaoExterna={composicaoParaExibir}
                onComposicaoChange={handleComposicaoChange}
                onValoresChange={handleValoresChange}
                tipoLinhaInicial={
                  lead.tipo_lead === 'RENOVACAO_CLARO' ? 'RENOVACAO' : 
                  lead.tipo_lead === 'PORTABILIDADE_VIVO' ? 'PORTABILIDADE' : 
                  'TT'
                }
                qtdLinhasIniciais={
                  linhasAtuaisMemo.length > 0 ? qtdLinhasEsperadas :
                  linhasManuaisRenovacao.length > 0 ? linhasManuaisRenovacao.filter(l => l.numero.replace(/\D/g, '').length >= 10).length :
                  0
                }
                propostaStatus={(leadCompleto as any)?.proposta_status || 'RASCUNHO'}
                linhasTravadasIds={linhasTravadasIds}
                itensProtegidosRevisao={itensProtegidosRevisao}
                itensVinculadosRevisao={itensPedidoRevisao}
                revisaoDeCancelado={isRevisaoCancelado}
                ficamCanceladosIds={ficamCancelados}
                onFicamCanceladosChange={setFicamCancelados}
                modoAmplo={lead.tipo_lead === 'PORTABILIDADE_VIVO'}
                tmCarteiraRenovacao={carteiraClaroAtual?.tempo_contrato_voz ?? lead.m_atual ?? lead.tempo_contrato_voz_num ?? (Number(String(lead.tempo_contrato_voz || '').replace(/\D/g, '')) || null)}
              />

              {/* 67 §5 — RESUMO DA PROPOSTA: as MESMAS 4 peças em todo tipo de lead.
                  Derivado das linhas; tile sem dado mostra '—' (nunca 0 falso). */}
              {composicaoParaExibir?.linhas && composicaoParaExibir.linhas.length > 0 && (() => {
                const valorNovoResumo = Number(composicaoParaExibir.totalValor || 0);
                const gbNovoResumo = Number(composicaoParaExibir.totalGB || 0);
                const valorAtualResumo = Number(valorAtualParsed || 0);
                const diferencaResumo = valorNovoResumo - valorAtualResumo;
                const economiaPct = valorAtualResumo > 0 ? Math.round((Math.abs(diferencaResumo) / valorAtualResumo) * 100) : 0;
                const tiposNaProposta = [...new Set(composicaoParaExibir.linhas.map((l) => l.tipo))];
                const metaTipos = tiposNaProposta.length === 1
                  ? `todos ${({ RENOVACAO: 'REN', TT: 'TT POS', TT_PRE: 'TT PRE', PORTABILIDADE: 'PN', NOVA: 'NOVA', LINHA_NOVA: 'NOVA', FIBRA: 'FIBRA', TV: 'TV', SERVICO: 'SERVIÇO' } as Record<string, string>)[tiposNaProposta[0]] || tiposNaProposta[0]} · `
                  : '';
                return (
                  <div className="relative overflow-hidden rounded-xl border border-border bg-card pl-1">
                    <span aria-hidden className="absolute inset-y-0 left-0 w-1 bg-[linear-gradient(180deg,#6E1626,#4E1522_55%,#3E0E1B)]" />
                    <div className="flex min-h-[34px] items-center justify-between gap-3 border-b border-border bg-[#FBFAF9] px-4 py-1.5 dark:bg-white/[0.02]">
                      <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-card-foreground">Resumo da proposta</p>
                      <p className="text-[10px] text-muted-foreground">{composicaoParaExibir.linhas.length} {composicaoParaExibir.linhas.length === 1 ? 'item' : 'itens'} · {metaTipos}derivado das linhas</p>
                    </div>
                    <div className="grid grid-cols-2 gap-2 p-3 lg:grid-cols-4">
                      <div className="rounded-lg border border-border bg-muted/40 px-3 py-2">
                        <p className="text-[9px] font-bold uppercase tracking-[0.08em] text-muted-foreground">Valor atual</p>
                        <p className={`mt-0.5 truncate font-display text-[18px] font-bold leading-tight tabular-nums ${valorAtualResumo > 0 ? 'text-foreground' : 'text-muted-foreground/40'}`}>{valorAtualResumo > 0 ? formatarMoeda(valorAtualResumo) : '—'}</p>
                        <p className="text-[9.5px] text-muted-foreground">{valorAtualResumo > 0 ? '/mês na fatura' : 'sem fatura medida'}</p>
                      </div>
                      <div className="rounded-lg border border-border px-3 py-2">
                        <p className="text-[9px] font-bold uppercase tracking-[0.08em] text-muted-foreground">Valor novo</p>
                        <p className="mt-0.5 truncate font-display text-[18px] font-bold leading-tight tabular-nums text-money-highlight">{formatarMoeda(valorNovoResumo)}</p>
                        <p className="text-[9.5px] text-muted-foreground">/mês{gbNovoResumo > 0 ? ` · ${gbNovoResumo} GB` : ''}</p>
                      </div>
                      <div className={`rounded-lg border px-3 py-2 ${diferencaResumo < 0 && valorAtualResumo > 0 ? 'border-[#075E54]/40 bg-[#075E54]/[0.06]' : 'border-border'}`}>
                        <p className="text-[9px] font-bold uppercase tracking-[0.08em] text-muted-foreground">{diferencaResumo < 0 ? 'Economia' : 'Diferença mensal'}</p>
                        <p className={`mt-0.5 truncate font-display text-[18px] font-bold leading-tight tabular-nums ${valorAtualResumo > 0 ? (diferencaResumo < 0 ? 'text-[#075E54] dark:text-[#25D366]' : 'text-primary dark:text-[#C87484]') : 'text-muted-foreground/40'}`}>
                          {valorAtualResumo > 0 ? `${diferencaResumo > 0 ? '+' : diferencaResumo < 0 ? '−' : ''}${formatarMoeda(Math.abs(diferencaResumo))}` : '—'}
                        </p>
                        <p className="text-[9.5px] text-muted-foreground">{valorAtualResumo > 0 ? `/mês · ${diferencaResumo < 0 ? '−' : '+'}${economiaPct}%` : 'depende do valor atual'}</p>
                      </div>
                      <div className="rounded-lg border border-border px-3 py-2">
                        <p className="text-[9px] font-bold uppercase tracking-[0.08em] text-muted-foreground">Comissão estimada</p>
                        <p className={`mt-0.5 truncate font-display text-[18px] font-bold leading-tight tabular-nums ${comissaoEstimadaResumo ? 'text-money-highlight' : 'text-muted-foreground/40'}`}>
                          {comissaoEstimadaResumo ? formatarMoeda(comissaoEstimadaResumo.total) : '—'}
                        </p>
                        <p className="truncate text-[9.5px] text-muted-foreground" title={comissaoEstimadaResumo ? `soma das ${comissaoEstimadaResumo.linhas} linhas · fator da faixa de cada uma · a comissão real é a do fechamento` : 'régua de comissão: renovação por enquanto'}>
                          {comissaoEstimadaResumo ? `soma das ${comissaoEstimadaResumo.linhas} linhas · fator da faixa` : 'régua: renovação por enquanto'}
                        </p>
                      </div>
                    </div>
                    {beneficiosDosProdutos.length > 0 && (
                      <div className="flex flex-wrap items-center gap-1.5 border-t border-border px-4 py-2">
                        <span className="text-[9px] font-bold uppercase tracking-[0.08em] text-muted-foreground">Benefícios em todas as linhas</span>
                        {beneficiosDosProdutos.map((b) => (
                          <span key={b} className="inline-flex items-center gap-1 rounded-full border border-border bg-card px-2 py-0.5 text-[10px] text-foreground">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="h-2.5 w-2.5 text-[#075E54] dark:text-[#25D366]"><path d="M20 6 9 17l-5-5" /></svg>
                            {b}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })()}

              {/* 67 §5 — MENSAGEM (esquerda) · PROPOSTA IMAGEM (direita) em TODO tipo
                  de lead; lg (não xl) para a imagem aparecer ao lado no modal de 1180px */}
              <div className="grid items-start gap-4 lg:grid-cols-[minmax(0,1fr)_440px]">
              <Card className="min-w-0">
                <CardHeader className="pb-3">
                  <CardTitle className="text-sm flex items-center gap-2">
                    {isRevisaoCancelado ? <RefreshCw className="w-4 h-4" /> : <MessageSquare className="w-4 h-4" />}
                    {isRevisaoCancelado ? 'Recuperar Pedido' : 'Mensagem WhatsApp'}
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-3">
                  <>
                  {/* TABS DE TIPO DE MENSAGEM — passe o mouse para ver a mensagem que será enviada */}
                  <p className="text-[11px] text-muted-foreground">
                    Escolha o tipo de mensagem e clique em <strong>Enviar</strong>. Passe o mouse sobre cada botão para ver o texto exato que o cliente vai receber.
                  </p>
                  {/* ⛔ A previa era uma div no createPortal com `fixed` e
                      `translate(-50%, -100%)`: ela CRESCIA PARA CIMA a partir do
                      topo do botao, ate 420px — a distancia exata do cabecalho do
                      cliente. O clamp `Math.max(16, rect.top - 10)` protegia a
                      ancora, nao o TOPO do painel, entao com texto longo o topo ia
                      para coordenada negativa e metade saia da tela. Sem clamp
                      lateral, invadia a coluna do comparativo. E `z-[2147483647]`
                      punha ela acima de tudo, fora da escada de z do dialog.
                      Nao era desalinhamento: era o comportamento programado.
                      (Douglas 02/09/2026: "quando eu coloco o mouse em cima esta
                      tudo torto... ele vai la pra cima")

                      Agora usa o HoverCard do projeto: o Radix faz sozinho o flip,
                      o shift e o clamp de borda. `side="bottom"` abre PARA BAIXO,
                      no espaco que ja e' da previa fixa — nunca sobe no cabecalho.
                      ⚠️ o z-[10100] e' obrigatorio: HoverCardContent nasce z-50 e o
                      DialogContent desta tela e' z-[10000], entao sem isso a previa
                      fica INVISIVEL (a mesma pegadinha documentada em ui/dialog.tsx).
                      O valor copia o vizinho ModalDisparoEmailLeads.tsx:837, que ja
                      resolveu isso — nao inventar numero novo de z. */}
                  <div className="grid grid-cols-2 gap-1 rounded-lg bg-[#EDE8E0] p-1 sm:grid-cols-4 dark:bg-[#161010]">
                    {botoesMensagem(lead?.tipo_pessoa === 'PF', lead?.tipo_lead).map(({ tipo, label }) => {
                      const ativo = tipoMensagemAtivo === tipo;
                      // Calcular preview da mensagem deste tipo (não só do ativo)
                      const textoTipo = textoDoTipoMensagem(proposta, tipo);
                      const previewTipo = tipo === 'proposta'
                        ? (mensagemPropostaGerada || 'Monte a proposta no comparativo para gerar a mensagem.')
                        : tipo === 'proposta_email'
                          ? 'Envia por e-mail (SMTP, SendGrid ou os dois) a MESMA imagem da proposta, com o texto que você escreve na prévia, o botão de WhatsApp e a assinatura do consultor. Sem Contato Real, vai para todos os e-mails do CNPJ.'
                        : tipo === 'apresentacao_sms'
                          ? (modelosSms[0]?.texto ?? '')
                        : tipo === 'proposta_imagem'
                          ? 'Envia a imagem da proposta (igual aparece aqui no CRM) no WhatsApp, com o texto completo da proposta na legenda.'
                          : substituirVariaveis(textoTipo, tipo);
                      return (
                        <HoverCard key={tipo} openDelay={120} closeDelay={80}>
                          <HoverCardTrigger asChild>
                            {/* o clique continua selecionando o tipo; o hover so' espia */}
                            <button
                              type="button"
                              onClick={() => setTipoMensagemAtivo(tipo)}
                              className={`flex h-8 w-full min-w-0 items-center gap-1.5 rounded-md border px-2.5 text-left text-xs font-semibold transition-colors ${ativo
                                ? 'border-[#9D2530] bg-[#9D2530] text-white'
                                : 'border-border bg-card text-foreground hover:border-[#9D2530]/50'}`}
                            >
                              {enviosMensagem?.has(tipo) && (
                                <span
                                  aria-label="já enviado"
                                  className={`h-1.5 w-1.5 flex-shrink-0 rounded-full ${ativo ? 'bg-white' : 'bg-[#128C7E] dark:bg-[#25D366]'}`}
                                />
                              )}
                              <span className="truncate">{label}</span>
                            </button>
                          </HoverCardTrigger>
                          <HoverCardContent
                            side="bottom"
                            align="start"
                            sideOffset={8}
                            collisionPadding={16}
                            className="z-[10100] w-[380px] max-w-[calc(100vw-2rem)] p-3"
                          >
                            <p className="mb-1.5 text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
                              {label} · o que o cliente recebe
                            </p>
                            {enviosMensagem?.get(tipo) && (
                              <p className="mb-1.5 text-[11px] font-semibold text-[#075E54] dark:text-[#25D366]">
                                Último envio: {new Date(enviosMensagem.get(tipo) as string).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                              </p>
                            )}
                            <div className="max-h-[min(320px,40vh)] overflow-y-auto">
                              <p className="whitespace-pre-wrap text-xs leading-relaxed">{previewTipo}</p>
                            </div>
                          </HoverCardContent>
                        </HoverCard>
                      );
                    })}
                  </div>
                  <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[10.5px] text-muted-foreground">
                    <span className="inline-flex items-center gap-1.5"><span aria-hidden className="h-2.5 w-2.5 rounded-[3px] bg-[#9D2530]" />escolhido</span>
                    <span className="inline-flex items-center gap-1.5"><span aria-hidden className="h-2.5 w-2.5 rounded-[3px] border border-border bg-card" />disponível</span>
                    <span className="inline-flex items-center gap-1.5"><span aria-hidden className="h-1.5 w-1.5 rounded-full bg-[#128C7E] dark:bg-[#25D366]" />já enviado (passe o mouse para ver quando)</span>
                  </div>

                  {/* prévia fixa do tipo ativo — bolha, valores derivados.
                      Proposta E-mail e Apresentação SMS mostram PARA QUEM vai. */}
                  {tipoMensagemAtivo === 'proposta_email' ? (
                    <PropostaEmailComposer
                      previa={previaEmail}
                      carregandoPrevia={previaEmailQuery.isLoading}
                      erroPrevia={previaEmailQuery.error instanceof Error ? previaEmailQuery.error.message : null}
                      imagemUrl={imagemPreviaEmail}
                      metodo={metodoEmailAtual}
                      onMetodo={setMetodoEmail}
                      destinos={destinosQuery.data?.emails ?? []}
                      marcados={emailsMarcados}
                      onMarcados={setEmailsEscolhidos}
                      carregandoDestinos={destinosQuery.isLoading}
                      erroDestinos={destinosQuery.error instanceof Error ? destinosQuery.error.message : null}
                      assunto={assuntoEmailAtual}
                      onAssunto={setAssuntoEmail}
                      abertura={aberturaEmailAtual}
                      fechamento={fechamentoEmailAtual}
                      onAbertura={setAberturaEmail}
                      onFechamento={setFechamentoEmail}
                      versaoTexto={versaoTextoEmail}
                      onVoltarTextoPronto={() => {
                        setAssuntoEmail(null);
                        setAberturaEmail(null);
                        setFechamentoEmail(null);
                        setVersaoTextoEmail((v) => v + 1);
                      }}
                      aviso={avisoTextoEmail}
                      modelo={previaEmail?.top ? modeloEmail : undefined}
                      onModelo={trocarModeloEmail}
                      origemValores={previaEmail?.top ? `os valores vêm da proposta do TOP ${previaEmail.top.top}` : undefined}
                      rodape={previaEmail?.top && modeloEmail === 'natural'
                        ? `o texto já vem com a proposta do TOP ${previaEmail.top.top} · o botão "Clique aqui e fale comigo no meu WhatsApp" leva ao dono do cliente`
                        : undefined}
                    />
                  ) : tipoMensagemAtivo === 'apresentacao_sms' ? (
                    <div className="space-y-2">
                      <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">Apresentação SMS · um SMS por celular</p>
                      <EditorSmsProposta modelos={modelosSms} texto={textoSmsAtual} onTexto={setTextoSms} />
                      <ListaDestinosProposta
                        canal="sms"
                        destinos={destinosQuery.data?.telefones ?? []}
                        marcados={telefonesMarcados}
                        onChange={setTelefonesEscolhidos}
                        carregando={destinosQuery.isLoading}
                        erro={destinosQuery.error instanceof Error ? destinosQuery.error.message : null}
                      />
                    </div>
                  ) : (() => {
                    const textoAtivoBase = textoDoTipoMensagem(proposta, tipoMensagemAtivo);
                    const previaAtivo = tipoMensagemAtivo === 'proposta'
                      ? (mensagemPropostaGerada || 'Monte a proposta no comparativo para gerar a mensagem.')
                      : tipoMensagemAtivo === 'proposta_imagem'
                        ? 'Envia a imagem da proposta (ao lado) no WhatsApp, com o texto completo da proposta na legenda.'
                        : substituirVariaveis(textoAtivoBase, tipoMensagemAtivo);
                    return (
                      <div>
                        <div className="mb-1 flex items-center justify-between gap-2">
                          <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">Prévia · o que o cliente recebe</p>
                          {lead.tipo_lead === 'RENOVACAO_CLARO' && (tipoMensagemAtivo === 'proposta' || tipoMensagemAtivo === 'proposta_imagem') && (
                            <button
                              type="button"
                              onClick={handleToggleOcultarPlanoAtual}
                              title={proposta.ocultar_plano_atual ? 'A conta de hoje não vai na proposta. Clique para incluir.' : 'Clique para tirar a conta de hoje da proposta'}
                              className="flex items-center gap-1 text-[10px] text-muted-foreground hover:text-primary"
                            >
                              {proposta.ocultar_plano_atual ? <EyeOff className="h-3 w-3" /> : <Eye className="h-3 w-3" />}
                              {proposta.ocultar_plano_atual ? 'sem a conta de hoje' : 'com a conta de hoje'}
                            </button>
                          )}
                        </div>
                        {/* o padrão do Inbox: papel-de-parede bone com a bolha sálvia e cauda */}
                        <div className="max-h-64 overflow-y-auto rounded-lg bg-[#EFE9DF] p-3 dark:bg-[#1E1515]">
                          <div className="relative max-w-[92%] whitespace-pre-wrap rounded-lg rounded-tl-none bg-[#DDE8DC] px-3 py-2 text-xs leading-relaxed text-[#1F2B1E] shadow-sm dark:bg-[#2E3A2D] dark:text-[#D9E4D7]">
                            {previaAtivo}
                            <span className="mt-1 flex items-center justify-end gap-1 text-[9px] tabular-nums text-[#1F2B1E]/50 dark:text-[#D9E4D7]/50">
                              {new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="h-2.5 w-2.5"><path d="M2 12l5 5L17 7M9 15l3 2L22 7" /></svg>
                            </span>
                          </div>
                        </div>
                        <p className="mt-1 text-[10px] text-muted-foreground">os valores vêm do resumo acima — nada digitado à mão</p>
                      </div>
                    );
                  })()}
                  </>

                  {(ehEnvioDeProposta || tipoMensagemAtivo === 'fechamento') && (
                    <EnvioPropostaStatus status={envioProposta} enviando={enviandoProposta} />
                  )}

                  {isRevisaoCancelado && (
                    <ResumoRecuperacaoParcial
                      volta={separacaoRecuperacao.volta}
                      fica={separacaoRecuperacao.fica}
                      motivos={motivosFicaCancelada}
                      motivoId={motivoFicamId}
                      onMotivoChange={setMotivoFicamEscolhido}
                    />
                  )}

                  {/* Botões */}
                  <div className="flex items-center gap-2">
                    {isRevisaoCancelado ? (
                      <>
                      <Button
                        onClick={handleSalvarEAplicar}
                        disabled={saving || regenerando || (separacaoRecuperacao.fica.length > 0 && separacaoRecuperacao.volta.length === 0)}
                        title={separacaoRecuperacao.fica.length > 0 && separacaoRecuperacao.volta.length === 0 ? 'Nenhum item volta: deixe ao menos um voltar ou cancele a revisão' : undefined}
                        className="flex-1 border-0 bg-[linear-gradient(90deg,#4A1320,#5B0A0D)] font-bold text-white shadow-[0_2px_6px_rgba(91,10,13,0.30)] transition-all hover:brightness-110 dark:bg-[linear-gradient(90deg,#9D2530,#6C2236)]">
                        {(saving || regenerando) ? (<Loader2 className="w-4 h-4 mr-2 animate-spin" />) : (<RefreshCw className="w-4 h-4 mr-2" />)}
                        {separacaoRecuperacao.fica.length > 0
                          ? `Recuperar Pedido · ${contarItens(separacaoRecuperacao.volta)} ${contarItens(separacaoRecuperacao.volta) === 1 ? 'item' : 'itens'}`
                          : 'Recuperar Pedido'}
                      </Button>
                      <Button variant="outline" onClick={handleEnviarProposta} disabled={saving || regenerando || enviandoProposta || envioSegurado} className="border-[#9D2530] text-xs text-[#9D2530] hover:text-[#9D2530]">
                        {enviandoProposta ? 'Enviando…' : propostaJaEnviada ? 'Proposta enviada' : 'Mandar ao cliente (opcional)'}
                      </Button>
                      </>
                    ) : emModoRevisao ? (
                      // Modo revisão (não-cancelado): AMBOS os botões - salvar/aplicar + enviar proposta
                      <>
                        <Button 
                          onClick={handleSalvarEAplicar} 
                          disabled={saving || regenerando}
                          className="flex-1 border-0 bg-[linear-gradient(90deg,#4A1320,#5B0A0D)] font-bold text-white shadow-[0_2px_6px_rgba(91,10,13,0.30)] transition-all hover:brightness-110 dark:bg-[linear-gradient(90deg,#9D2530,#6C2236)]"
                        >
                          {(saving || regenerando) ? (
                            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                          ) : (
                            <RefreshCw className="w-4 h-4 mr-2" />
                          )}
                          Salvar e Aplicar ao Pedido
                        </Button>
                        <Button 
                          variant="outline"
                          onClick={handleEnviarProposta} 
                          disabled={enviandoProposta || smsSemDestino || envioSegurado}
                          className="border-[#9D2530] text-xs text-[#9D2530] hover:text-[#9D2530] disabled:opacity-50"
                        >
                          {enviandoProposta ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : propostaJaEnviada ? <Check className="w-4 h-4 mr-2" /> : <Send className="w-4 h-4 mr-2" />}
                          {enviandoProposta ? 'Enviando…' : propostaJaEnviada ? 'Proposta enviada' : `Mandar ${rotuloDoTipoMensagem(tipoMensagemAtivo, lead?.tipo_pessoa === 'PF')} (opcional)`}
                        </Button>
                      </>
                    ) : (
                      // Modo normal: botões padrão
                      <>
                        <Button onClick={salvarProposta} disabled={saving} variant="outline" className="flex-1">
                          {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />}
                          Salvar Tudo
                        </Button>
                        <Button 
                          onClick={handleEnviarProposta} 
                          disabled={enviandoProposta || smsSemDestino || envioSegurado}
                          className="flex-1 border-0 bg-[linear-gradient(90deg,#4A1320,#5B0A0D)] font-bold text-white shadow-[0_2px_6px_rgba(91,10,13,0.30)] transition-all hover:brightness-110 disabled:opacity-50 dark:bg-[linear-gradient(90deg,#9D2530,#6C2236)]"
                        >
                          {enviandoProposta ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : propostaJaEnviada ? <Check className="w-4 h-4 mr-2" /> : <Send className="w-4 h-4 mr-2" />}
                          {enviandoProposta ? 'Enviando…' : propostaJaEnviada ? 'Proposta enviada' : `Enviar ${rotuloDoTipoMensagem(tipoMensagemAtivo, lead?.tipo_pessoa === 'PF')}`}
                        </Button>
                      </>
                    )}
                  </div>
                  {tipoMensagemAtivo === 'proposta_email' && enviosMensagem?.get('proposta_email') && (
                    <p className="flex items-center gap-1.5 text-[10.5px] text-muted-foreground">
                      <span aria-hidden className="h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[#128C7E] dark:bg-[#25D366]" />
                      Último envio: {new Date(enviosMensagem.get('proposta_email') as string).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })} · o e-mail inteiro está na Timeline
                    </p>
                  )}
                </CardContent>
              </Card>

              <div className="min-w-0">
              {/* Comparativo Visual - SEMPRE aparece quando planoAtualMemo existe */}
              {planoAtualMemo && (
                <ComparativoPropostaVisual
                  ref={comparativoRef}
                  planoAtual={planoAtualMemo}
                  composicaoNova={composicaoParaExibir}
                  nomeCliente={lead.razao_social || lead.nome_fantasia}
                  cnpj={lead.cnpj}
                  consultorNome={nomeConsultorProposta}
                  consultorFotoUrl={dadosLead?.consultor_id === user?.id ? profile?.foto_url : undefined}
                  ocultarPlanoAtual={proposta.ocultar_plano_atual}
                  ocultarPlanoFixo={proposta.ocultar_plano_fixo}
                />
              )}
              <NumerosParaLigarCard
                leadId={lead.id}
                ativo={activeTab === 'proposta'}
                sequencia={leadIdsFrozen?.length ? leadIdsFrozen.slice(Math.max(0, leadIdsFrozen.indexOf(lead.id))) : undefined}
                onLigar={onLigar}
                onContatoReal={(tel) => {
                  contatoEditadoManualmenteRef.current = true;
                  setContato((prev) => ({ ...prev, telefone: tel }));
                  setActiveTab('contato');
                  toast.success('Número levado para o Contato', { description: 'Preencha o nome de quem atendeu e salve.' });
                }}
              />
              </div>
              </div>
              </div>
            </TabsContent>

            {/* ABA FATURA */}
            <TabsContent value="fatura" className="m-0 h-full">
              <LeadFaturaTab 
                clienteId={lead.cliente_id} 
                cnpj={lead.cnpj}
                linhaPlanoInicial={lead.linha_conta_fatura || lead.conta_operadora}
                tempoContratoVoz={parseInt(lead.tempo_contrato_voz || '0')}
                leadId={lead.id}
                consultorId={lead.consultor_id}
                consultorNome={lead.consultor_nome}
                equipeId={lead.equipe_id}
                equipeNome={lead.equipe_nome}
                razaoSocial={lead.razao_social}
                uf={lead.uf}
                qtdLinhasVoz={lead.qtd_linhas_voz}
                isPortabilidade={lead.tipo_lead === 'PORTABILIDADE_VIVO'}
                tipoLead={lead.tipo_lead}
                tipoPessoa={lead.tipo_pessoa === 'PF' ? 'PF' : 'PJ'}
                cpf={(lead as { cpf?: string | null }).cpf || null}
                composicaoRenovacao={composicaoParaExibir}
                faturaUploadIdRenovacao={dadosFatura?.faturaUploadId || null}
                linhasFaturaRenovacao={(dadosFatura?.linhasDetalhadas || []).map((linha) => ({
                  numero: linha.numero,
                  gbAtual: linha.gbAtual,
                  planoAtual: linha.planoAtual,
                  valorAtual: linha.valorAtual,
                  sugestaoPlanoId: linha.sugestaoPlanoId,
                  sugestaoPlanoNome: linha.sugestaoPlanoNome,
                  sugestaoValor: linha.sugestaoValor,
                  sugestaoDelta: linha.sugestaoDelta,
                  sugestaoFaixa: linha.sugestaoFaixa,
                  sugestaoAcrescimo: linha.sugestaoAcrescimo,
                  sugestaoTicketAlvoFaixa1: linha.sugestaoTicketAlvoFaixa1,
                  sugestaoMotivo: linha.sugestaoMotivo,
                  dataFidelidade: linha.dataFidelidade,
                }))}
                onComposicaoRenovacaoChange={handleComposicaoChange}
                renovacaoSomenteLeitura={renovacaoSomenteLeitura}
                modoAmplo={lead.tipo_lead === 'PORTABILIDADE_VIVO'}
              />
            </TabsContent>

            {/* ABA HISTÓRICO - forceMount para preservar estado do textarea */}
            <TabsContent value="historico" className="m-0" forceMount>
              <div className={activeTab === 'historico' ? '' : 'hidden'}>
                <TimelineUnificada cnpj={lead.cnpj} clienteId={lead.cliente_id} leadId={lead.id} leadNumero={lead.lead_numero} completa />
              </div>
            </TabsContent>

            {/* ABA PEDIDOS - Para leads CARTEIRA ou CONVERTIDO */}
            {(lead.status_lead === 'CARTEIRA' || lead.status_lead === 'CONVERTIDO') && (
              <TabsContent value="pedidos" className="m-0 space-y-4">
                <LeadPedidosTab 
                  leadId={lead.id}
                  pedidoId={lead.pedido_id} 
                  onOpenPedido={(id) => openPedido(id, 'planilha')} 
                />
              </TabsContent>
            )}

            {/* ABA BASE LINHAS - Para leads PORTABILIDADE_VIVO com dados_master_lead */}
            {lead.tipo_lead === 'PORTABILIDADE_VIVO' && lead.dados_master_lead && (
              <TabsContent value="base-linhas" className="m-0 space-y-4">
                <LeadBaseLinhasTab lead={lead} />
              </TabsContent>
            )}

          </div>
        </Tabs>

        {/* FOOTER FIXO - AÇÕES DE STATUS + NAVEGAÇÃO CARROSSEL */}
        <div className="shrink-0 border-t bg-muted/30 p-4 max-md:px-3 max-md:pt-2.5 max-md:pb-[max(0.625rem,env(safe-area-inset-bottom))]">
          <div className="flex items-center gap-3 max-md:flex-wrap max-md:justify-center max-md:gap-2">
            {/* SETA ESQUERDA - Anterior */}
            {onNavegar && (
              <Button
                variant="ghost"
                size="default"
                className="h-10 min-w-[56px] text-primary hover:bg-primary/10 disabled:opacity-[0.45]"
                onClick={() => handleTentarNavegar('anterior')}
                disabled={!canNavigate?.anterior}
                title={`${indiceAtual ?? 0} leads anteriores`}
              >
                <div className="flex items-center gap-1">
                  <ChevronLeft className="w-5 h-5" />
                  {(indiceAtual ?? 0) > 0 && <span className="text-xs font-medium tabular-nums">{indiceAtual ?? 0}</span>}
                </div>
              </Button>
            )}
            
            <span className="min-w-0 flex-1 max-md:hidden" />
            {loadingLeadCompleto ? (
              // Loading state - aguardar dados frescos antes de mostrar botão
              <Button size="default" disabled className="opacity-50 min-w-[140px]">
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Carregando...
              </Button>
            ) : (dadosLead.status_lead === 'CONVERTIDO' || dadosLead.pedido_id) ? (
              // Lead já fechado OU com pedido_id
              dadosLead.pedido_id ? (
                // Caso normal: tem pedido_id - abrir pedido existente
                <Button
                  size="default"
                  className="h-9 rounded-full border-0 bg-success/10 px-4 text-[12.5px] font-bold text-success transition-all duration-200 hover:bg-success hover:text-white"
                  onClick={() => { openPedido(dadosLead.pedido_id!, 'planilha'); onOpenChange(false); }}
                >
                  <FileText className="w-4 h-4 mr-2" />
                  Abrir Pedido
                </Button>
              ) : (
                // Caso especial: CONVERTIDO sem pedido_id - permitir criar
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        size="default"
                        className="h-9 rounded-full border-0 bg-[linear-gradient(90deg,#4A1320,#5B0A0D)] px-4 text-[12.5px] font-bold text-white shadow-[0_2px_6px_rgba(91,10,13,0.30)] transition-all hover:brightness-110 dark:bg-[linear-gradient(90deg,#9D2530,#6C2236)]"
                        onClick={async () => { 
                          await flushAutosave(); 
                          onStatusChange(lead.id, 'FECHADO'); 
                        }}
                      >
                        <AlertTriangle className="w-4 h-4 mr-2" />
                        Criar pedido
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>Lead convertido mas pedido não foi criado. Clique para criar.</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )
            ) : dadosLead.status_lead === 'NEGADO' ? (
              voltarTrabalharAberto ? null : <Button
                size="default"
                className="h-9 rounded-full border-0 bg-[linear-gradient(90deg,#4A1320,#5B0A0D)] px-4 text-[12.5px] font-bold text-white shadow-[0_2px_6px_rgba(91,10,13,0.30)] transition-all hover:brightness-110 dark:bg-[linear-gradient(90deg,#9D2530,#6C2236)]"
                onClick={() => setVoltarTrabalharAberto(true)}
              >
                <RotateCcw className="w-4 h-4 mr-2" />
                Voltar a trabalhar
              </Button>
            ) : (
              // Lead em andamento - mostrar botões de ação normais
              <>
                <Button
                  size="default"
                  variant="outline"
                  className="h-9 rounded-full border-border bg-card px-4 text-[12.5px] font-semibold text-muted-foreground transition-colors hover:border-primary/40 hover:bg-card hover:text-primary"
                  onClick={async () => { 
                    await flushAutosave(); 
                    onStatusChange(lead.id, 'NEGADO'); 
                  }}
                >
                  <X className="w-4 h-4 mr-2" />
                  Negado
                </Button>
                {dadosLead.status_lead !== 'PROPOSTA' && (
                  <Button
                    size="default"
                    variant="outline"
                    className="h-9 rounded-full border-border bg-card px-4 text-[12.5px] font-semibold text-muted-foreground transition-colors hover:border-primary/40 hover:bg-card hover:text-primary"
                    onClick={async () => { 
                      await flushAutosave(); 
                      onStatusChange(lead.id, 'NEGOCIANDO'); 
                      onOpenChange(false); 
                    }}
                  >
                    <Handshake className="w-4 h-4 mr-2" />
                    Negociando
                  </Button>
                )}
                {criarPedidoTravado ? (
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <span tabIndex={0} className="rounded-full">
                          <Button
                            size="default"
                            disabled
                            className="pointer-events-none h-9 rounded-full border border-border bg-[#EDE8E0] px-4 text-[12.5px] font-bold text-[#8A7576] dark:bg-[#161010]"
                          >
                            <Lock className="w-4 h-4 mr-2" />
                            Criar pedido
                          </Button>
                        </span>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p>{envioProposta?.codigo_criar === 'proposta_composicao_incompleta'
                          ? 'Monte e salve os produtos da proposta.'
                          : envioProposta?.codigo_criar === 'telefone_contato_invalido'
                            ? 'Corrija o telefone do Contato Real.'
                            : envioProposta?.ultimo?.situacao === 'nao_chegou'
                              ? 'A proposta não chegou ao cliente. Veja o motivo na aba Proposta.'
                              : envioProposta?.codigo_criar === 'proposta_atual_envio_nao_confirmado'
                                ? 'Libera assim que o WhatsApp confirmar o envio da proposta.'
                                : 'Envie a proposta (texto ou imagem). O Criar pedido libera quando ela sair.'}</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                ) : (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        size="default"
                        className="h-9 rounded-full border-0 bg-[linear-gradient(90deg,#4A1320,#5B0A0D)] px-4 text-[12.5px] font-bold text-white shadow-[0_2px_6px_rgba(91,10,13,0.30)] transition-all hover:brightness-110 dark:bg-[linear-gradient(90deg,#9D2530,#6C2236)]"
                        onClick={async () => { 
                          // Validar se tem produtos na proposta
                          const composicaoAtual = composicaoEditando ?? composicaoBase;
                          const temProdutos = composicaoAtual?.linhas && composicaoAtual.linhas.length > 0;
                          
                          if (!temProdutos) {
                            toast.error('Adicione pelo menos um produto na proposta antes de criar o pedido', {
                              description: 'Use os botões + TT, + Port, + Nova, etc. para adicionar produtos',
                              duration: 6000
                            });
                            setActiveTab('proposta');
                            return;
                          }

                          // ⛔ LINHA SEM PLANO VIRA ITEM DE R$ 0,00 (Douglas 02/09/2026).
                          // TT nasce de propósito sem plano — se o consultor não
                          // escolher, o item era criado valendo zero, com o nome do
                          // plano vazio, e ninguém avisava. O validador que apontava
                          // exatamente isso existia e não tinha um chamador sequer.
                          const propostaCompleta = validarPropostaCompleta(composicaoAtual);
                          if (!propostaCompleta.valida) {
                            const quais = propostaCompleta.linhasIncompletas
                              .map((l) => `${l.tipo}${l.numero ? ` ${l.numero}` : ''}`)
                              .join(' · ');
                            toast.error('Falta escolher o plano', {
                              description: `Sem plano, a linha entra no pedido valendo R$ 0,00. Escolha o plano de: ${quais}`,
                              duration: 8000,
                            });
                            setActiveTab('proposta');
                            return;
                          }
                          
                          // VALIDAÇÃO: Contato Real obrigatório
                          if (!contato.nome?.trim()) {
                            toast.error('Contato Real obrigatório', {
                              description: 'Preencha o nome do Contato Real antes de criar o pedido.',
                              duration: 6000
                            });
                            setActiveTab('comercial');
                            return;
                          }
                          
                          const telefoneDigits = contato.telefone?.replace(/\D/g, '') || '';
                          if (telefoneDigits.length < 10) {
                            toast.error('Telefone do Contato Real obrigatório', {
                              description: 'Preencha o telefone do Contato Real (mínimo 10 dígitos) antes de criar o pedido.',
                              duration: 6000
                            });
                            setActiveTab('comercial');
                            return;
                          }
                          
                          // VALIDAÇÃO: proposta enviada pelo Inbox do CRM.
                          // Régua ÚNICA — a mesma de validarLeadParaPedido, que roda
                          // depois no LeadDetailModalRenderer e no AbrirPedidoModal.
                          // Antes aqui havia uma cópia própria que aceitava retorno e
                          // fechamento no lugar da proposta: o botão liberava e o
                          // consultor só era barrado adiante, com outra mensagem.
                          await flushAutosave();
                          const validacaoProposta = await validarLeadParaPedido({
                            id: lead.id,
                            contato_real_nome: contato.nome,
                            contato_real_telefone: contato.telefone,
                            tipo_lead: lead.tipo_lead,
                          });

                          if (!validacaoProposta.valido) {
                            toast.error(validacaoProposta.erro || 'Não é possível criar o pedido', {
                              description: validacaoProposta.descricao,
                              duration: 8000
                            });
                            setActiveTab('proposta');
                            return;
                          }

                          onStatusChange(lead.id, 'FECHADO'); 
                          onOpenChange(false); 
                        }}
                      >
                        <Check className="w-4 h-4 mr-2" />
                        Criar pedido
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>Cria o pedido para preencher dados e preparar o envio ao BKO</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
                )}
              </>
            )}
            
            <span className="min-w-0 flex-1 max-md:hidden" />
            {/* SETA DIREITA - Próximo */}
            {onNavegar && (
              <Button
                variant="ghost"
                size="default"
                className="h-10 min-w-[56px] text-primary hover:bg-primary/10 disabled:opacity-30"
                onClick={() => handleTentarNavegar('proximo')}
                disabled={!canNavigate?.proximo}
                title={`${Math.max(0, (totalLeads ?? 0) - (indiceAtual ?? 0) - 1)} leads restantes`}
              >
                <div className="flex items-center gap-1">
                  <span className="text-xs font-medium tabular-nums">
                    {Math.max(0, (totalLeads ?? 0) - (indiceAtual ?? 0) - 1)}
                  </span>
                  <ChevronRight className="w-5 h-5" />
                </div>
              </Button>
            )}
          </div>
          
          {/* Indicador de posição */}
          {totalLeads && totalLeads > 1 && (
            <div className="text-center mt-2 text-xs text-muted-foreground">
              Lead {(indiceAtual ?? 0) + 1} de {totalLeads}
              {isDirty && (
                <Badge variant="outline" className="ml-2 text-xs text-primary border-primary/50">
                  Não salvo
                </Badge>
              )}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>

    {/* AlertDialog para confirmar cancelamento de revisão - CORREÇÃO #5 */}
    <AlertDialog open={showCancelRevisaoDialog} onOpenChange={setShowCancelRevisaoDialog}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-warning" />
            Cancelar revisão da proposta?
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              Ao cancelar, o lead voltará ao status anterior (<strong>CONVERTIDO</strong>) 
              e a proposta será marcada como fechada novamente.
            </p>
            <p className="text-warning font-medium mt-2 text-sm">
              ⚠️ Nenhuma alteração feita nesta revisão será salva.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={cancelandoRevisao}>
            Continuar editando
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirmarCancelRevisao}
            disabled={cancelandoRevisao}
            className="bg-warning hover:bg-warning"
          >
            {cancelandoRevisao ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Cancelando...
              </>
            ) : (
              'Cancelar revisão e voltar'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
    
    {/* AlertDialog para confirmar navegação com alterações não salvas */}
    <AlertDialog open={showNavigationGuard} onOpenChange={setShowNavigationGuard}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-warning" />
            Alterações não salvas
          </AlertDialogTitle>
          <AlertDialogDescription>
            Você tem alterações que ainda não foram salvas. O que deseja fazer?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex gap-2">
          <AlertDialogCancel onClick={() => setPendingNavigation(null)}>
            Cancelar
          </AlertDialogCancel>
          <Button variant="outline" onClick={handleDescartarENavegar}>
            Descartar e ir
          </Button>
          <Button onClick={handleConfirmarNavegacao} className="bg-success hover:bg-success">
            Salvar e ir
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  </>
  );
});
